import React, { Component } from "react";
import { Row, Col, Form, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Container } from 'reactstrap';
import { Field, reduxForm, formValueSelector } from "redux-form";
import { renderSelectField, renderText, focusOnError, renderDatePicker } from "../layout/FormInputs";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { required, checkForNull, nextEvenNo } from "../../helper/validation";
import { Loader } from "../common/Loader";
import { loggedInUserId } from '../../helper/auth';
import { HorizontalStiffiners, VerticalStiffiners } from './MasterData';
import { weightDoor } from "./Helper";
import { createShutterDesign, getShutterDesignData, updateShutterDesign } from "../../actions/DesignMaster";
import moment from 'moment';
import { onKeyPress } from "../../config/config";
import CIShutterDesign from "./CIShutterDesign";

const selector = formValueSelector('ShutterDesign');

const stemMaterialOptions = [
    { Text: 'SS 401', Value: 'SS 401' },
    { Text: 'SS 431', Value: 'SS 431' },
    { Text: 'SS 304', Value: 'SS 304' },
    { Text: 'SS 304L', Value: 'SS 304L' },
    { Text: 'SS 316', Value: 'SS 316' },
    { Text: 'SS 316L', Value: 'SS 316L' },
    { Text: 'SS DUPLEX', Value: 'SS DUPLEX' },
    { Text: 'SS SUP. DUP.', Value: 'SS SUP. DUP.' },
    { Text: '17-4PH', Value: '17-4PH' },
]

// const thrustOns

const frameMountingData = [
    { Text: 'ON WALL', Value: 'ON WALL' },
    { Text: 'ON WALL WITH HDP/STEEL PIPE TERMINATION', Value: 'ON WALL WITH HDP/STEEL PIPE TERMINATION' },
    { Text: 'ON WALL WITH RCP PIPE TERMINATION', Value: 'ON WALL WITH RCP PIPE TERMINATION' },
    { Text: 'ON PIPE FLANGE', Value: 'ON PIPE FLANGE' },
    { Text: 'ON WALL THIMBLE', Value: 'ON WALL THIMBLE' },
]

const referenceDocsOption = [
    { Text: 'Reference Documents : AWWA C561 code of practice for Slide.', Value: 0 },
    { Text: 'Reference Documents : BS 7775 code of practice for Slide/Shutter/Plank.', Value: 1 },
    { Text: 'Reference Documents : IS 5620 code of practice for Slide/Shutter/Plank.', Value: 2 },
    { Text: 'Reference Documents : AWWA C562 code of practice for Slide.', Value: 3 },
]

const manufacturingMaterialOption = [
    { Text: 'Carbon Steel', Value: 0 },
    { Text: 'Stainless Steel 304/304L Dual Certified', Value: 1 },
    { Text: 'Stainless Steel 316/316L Dual Certified', Value: 2 },
    { Text: 'Duplex SS', Value: 3 },
    { Text: 'Super Duplex SS', Value: 4 },
    { Text: 'Aluminium', Value: 5 },
]

const manufacturingMaterialOptionCI = [
    { Text: 'CI FG-260', Value: 0 },
    { Text: 'CI CLASS B / CI FG-220', Value: 1 },
    { Text: 'CI FG-200', Value: 2 },
    { Text: 'CI WITH 2% NI', Value: 3 },
    { Text: 'DI ASTM A536 60-42-10', Value: 4 },
    { Text: 'DI ASTM A536 70-50-05', Value: 5 },
    { Text: 'NI RISIST-TYPE 1 -14-18', Value: 6 },
    { Text: 'NI RISIST-TYPE 2 -18-22', Value: 7 }
]

const horizontalStiffenerOption = [
    { Text: 'A', Value: 'A' },
    { Text: 'B', Value: 'B' },
    { Text: 'C', Value: 'C' },
    // { Text: 'D', Value: 'D' },
    // { Text: 'E', Value: 'E' },
]

const verticalStiffenerOption = [
    { Text: 'A', Value: 'A' },
    { Text: 'B', Value: 'B' },
    { Text: 'C', Value: 'C' },
    // { Text: 'D', Value: 'D' },
    // { Text: 'E', Value: 'E' },
]

const sharftSpindleOption = [
    { Text: 'SINGLE SPINDLE', Value: 'SINGLE_SPINDLE' },
    { Text: 'TANDEM SPINDLE', Value: 'TANDEM_SPINDLE' },
]

const spindleDirectionOption = [
    { Text: 'RISING', Value: 'RISING' },
    { Text: 'NON RISING', Value: 'NON RISING' },
]

const SeriesOfferedOption = [

    { Text: 'A-101- FLAT BACK FRAME DESIGN', Value: 'A-101- FLAT BACK FRAME DESIGN', Key: '1' },
    { Text: 'A-102- SECTIONAL FRAME DESIGN', Value: 'A-102- SECTIONAL FRAME DESIGN', Key: '1' },
    { Text: 'A-103- INTEGRAL FRAME DESIGN', Value: 'A-103- INTEGRAL FRAME DESIGN', Key: '1' },
    { Text: 'A-104- UNIVERSAL FRAME DESIGN', Value: 'A-104- UNIVERSAL FRAME DESIGN', Key: '1' },
    { Text: 'A-111', Value: 'A-111', Key: '1' },
    { Text: 'A-112', Value: 'A-112', Key: '1' },
    { Text: 'A-113', Value: 'A-113', Key: '1' },
    { Text: 'A-113-B', Value: 'A-113-B', Key: '1' },
    { Text: 'A-114', Value: 'A-114', Key: '1' },
    { Text: 'A-121', Value: 'A-121', Key: '1' },



    { Text: 'A-201-202-203 CAST IRON OPEN CHANNEL', Value: 'A-201-202-203 CAST IRON OPEN CHANNEL', Key: '2' },
    // { Text: "A-211", Value: "A-211", Key: '2' },
    // { Text: "A-212", Value: "A-212", Key: '2' },
    // { Text: "A-213", Value: "A-213", Key: '2' },
    // { Text: "A-221", Value: "A-221", Key: '2' },
    // { Text: "A-222", Value: "A-222", Key: '2' },
    // { Text: "A-223", Value: "A-223", Key: '2' },
    { Text: 'A-211 / 212 / 213', Value: 'A-211 / 212 / 213', Key: '2' },
    { Text: 'A-221 / 222 / 223', Value: 'A-221 / 222 / 223', Key: '2' },
    { Text: 'A-301 CAST IRON WEIR GATE', Value: 'A-301 CAST IRON WEIR GATE', Key: '3' },
    { Text: 'A-311', Value: 'A-311', Key: '3' },
    { Text: 'A-321', Value: 'A-321', Key: '3' },

    // { Text: 'A-113/A-113-B/A-114', Value: 'A-113/A-113-B/A-114' },
    // { Text: 'A-211/212/213 & A-221/222/223', Value: 'A-211/212/213 & A-221/222/223' },
    // { Text: 'A-311 & 321', Value: 'A-311 & 321' },



]

const ActuationOption = [
    { Text: 'MANUAL', Value: 'MANUAL' },
    { Text: 'ELECTRIC', Value: 'ELECTRIC' },
]

const ClosureOption = [
    { Text: 'FLUSH BOTTOM CLOSURE', Value: 'FLUSH BOTTOM CLOSURE' },
    { Text: 'CONVENTIONAL BOTTOM CLOSURE', Value: 'CONVENTIONAL BOTTOM CLOSURE' }
]

const factorOfSafety = [
    { Text: "STANDARD", Value: "STANDARD" },
    { Text: "CUSTOM", Value: "CUSTOM" }
];

//table 2 for section 3 
const table2Section3G328 = [305, 612, 1020, 1220, 1525]
const table2Section3G328Value = [1, 2, 3, 4, 5, 0]
//table 3 for section 3
const table3Section3G336 = [915, 1525, 2001, 5001]
const table3Section3G336Value = [75, 100, 125, 150, 0]

// table 4
const table4Section3G351 = [305.00, 612.00, 1221.00, 1830.00, 2450.00, 2651.00, 2751.00, 3251.00, 3501.00, 4101.00, 4401.00, 5001.00]
const table4Section3G351Value = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0]
//table 4 right side
const table4BW = [45.00, 45.00, 45.00, 50.00, 50.00, 60.00, 60.00, 60.00, 75.00, 75.00, 75.00, 75.00]
const table4WT = [15.00, 15.00, 25.00, 30.00, 30.00, 30.00, 30.00, 30.00, 40.00, 40.00, 40.00, 40.00]
const table4MC = [5.00, 6.00, 6.00, 10.00, 10.00, 10.00, 10.00, 10.00, 12.00, 12.00, 12.00, 12.00]

const table5BW = [90.50, 88.00, 90.50, 105.00, 105.00, 105.00, 105.00, 105.00, 105.00, 105.00, 105.00, 105.00]
const table5WT = [12.70, 9.50, 9.50, 19.00, 19.00, 19.00, 19.00, 19.00, 19.00, 19.00, 19.00, 19.00]
const table5MC = [5.00, 6.00, 6.00, 10.00, 10.00, 10.00, 10.00, 10.00, 12.00, 12.00, 12.00, 12.00]

const table6BW = [80.00, 80.00, 80.00, 80.00, 85.00, 85.00, 90.00, 90.00, 90.00, 90.00, 100.00, 110.00]
const table6WT = [50.00, 50.00, 50.00, 50.00, 50.00, 50.00, 50.00, 50.00, 50.00, 50.00, 60.00, 60.00]
const table6MC = [5.00, 6.00, 6.00, 10.00, 10.00, 10.00, 10.00, 10.00, 12.00, 12.00, 12.00, 12.00]

const table7BW = [75.00, 80.00, 85.00]
const table7WT = [20.00, 20.00, 25.00]
const table7MC = [5.00, 8.00, 10.00]

const weightOfSideWedgesCalc = [0.99, 1.99, 2.99, 3.99, 4.99, 5.99, 6.99, 7.99, 8.99, 9.99]
const weightOfSideWedgesCalcValue = [30, 50, 70, 90, 110, 130, 150, 170, 190, 210, 0]
const validValues = [150, 200, 250, 300, 400, 450, 500, 600, 700, 800, 900, 1000, 1200];

let isDesignSafe = [];
let shearstressObj

class ShutterDesign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoader: false,
            isSubmitted: false,
            stageOneOpen: true,
            stageTwoOpen: true,
            stageThreeOpen: false,
            startDate: '',
            shutterDesignId: '',
            referenceDocumentsObj: {
                BendingStress: 0.5,
                AxialStress: 0.5,
                ShearStress: 0.25,
            },
            manufacturingMaterialObj: {
                UTS: 410,
                YS: 250,
                FSS: 300,
            },
            selectedHorizontalStiff: 'A',
            horizontalStiffenersSectionObj: HorizontalStiffiners ? HorizontalStiffiners.A : {},
            selectedVerticalStiff: 'A',
            verticalStiffenersSectionObj: VerticalStiffiners ? VerticalStiffiners.A : {},
            selectedSpindle: 'SINGLE_SPINDLE',
            selectedApplicableStandard: '',
            currentSelectedReferenceDoc: '0',
            stressObject2: {
                BendingStress: 0,
                AxialStress: 0,
                ShearStress: 0
            },
            currentSelectedMaterial: 0,
            selectedStemMaterial: 'SS 401',
            skinPlateThickness: 0,
            clPlValue: 0,
            selectedSeriesOffered: 'A-113',
            copyCosting: '',
            isPostOrder: false,
            activeActuation: '',
            modal: false,
            identifier: {},
            isPostOrderCreated: false,
            thrustOnOptions: [],
            frameExtensionOption: [],
            frameExtension: '',
            factorOfSafetyDD: '',
            frameLengthOption: [
                { Text: 'SHORT LENGTH', Value: 'SHORT LENGTH' },
                { Text: 'FULL LENGTH', Value: 'FULL LENGTH' }],
            isSeriesOfferedCI: false,
            applicableStandardDataArray: [
                { Text: 'AWWA-C561', Value: 'AWWA-C561' },
                { Text: 'AWWA-C562', Value: 'AWWA-C562' },
                { Text: 'BS-7775', Value: 'BS-7775' },
                { Text: 'IS-5620', Value: 'IS-5620' }],
            cisDataVal: [],
            shutterDataCI: []

            // data: [],
            // shutterDesignData: [],
            // isEditFlag: false,
            // ShutterId: '',
            // width: '',
            // shutterDesignCreated: ''
        };
    }

    componentDidMount() {
        // this.props.change("HRb1", 0)
        // this.props.change("HRt1", 0)
        // this.props.change("HRt3", 0)
        // this.props.change("HRd", 0)
        // this.props.change('HRd1', 0)
        // this.props.change('HRD', 0)
        // this.props.change("VRb1", 0)
        // this.props.change("VRt1", 0)
        // this.props.change("VRt3", 0)
        // this.props.change("VRd", 0)
        // this.props.change("VRd1", 0)
        // this.props.change('VRD', 0)
        // this.props.change("shaftSpindle", 'SINGLE_SPINDLE')
        // this.props.change("SpindleDirection", 'RISING')
    }

    /**
    * @method handleReferenceDocsChild
    * @description Handle reference documents
    */
    handleReferenceDocsChild = (data) => {

        //const value = e.target.value;
        let tempObj = {};
        const value = Number(data)
        if (value === 0) {

            tempObj = {
                BendingStress: 0.25,
                AxialStress: 0.25,
                ShearStress: 0.25,
            }
        } else if (value === 1) {

            tempObj = {
                BendingStress: 0.75,
                AxialStress: 0.75,
                ShearStress: 0.3,
            }
        } else if (value === 2) {

            tempObj = {
                BendingStress: 0.4,
                AxialStress: 0.4,
                ShearStress: 0.3,
            }
        } else if (value === 3) {

            tempObj = {
                BendingStress: 0.2,
                AxialStress: 0.2,
                ShearStress: 0.2,
            }
        } else if (!value) {

            tempObj = {
                BendingStress: 0,
                AxialStress: 0,
                ShearStress: 0,
            }
        }


        this.setState({ referenceDocumentsObj: tempObj, currentSelectedReferenceDoc: value !== null ? (value).toString() : null })
    }

    /**
   * @method handleManufacturingMaterial
   * @description Handle reference documents
   */
    handleManufacturingMaterialChild = (data) => {
        const { referenceDocumentsObj, currentSelectedReferenceDoc } = this.state;
        let tempObj = {};
        const value = Number(data)

        const X27 = () => {
            switch (currentSelectedReferenceDoc) {
                case '0':
                    return 0.25
                case '1':
                    return 0.75
                case '2':
                    return 0.40
                case '3':
                    return 0.20
                default:
                    return 0
            }
        }
        const X28 = () => {
            switch (currentSelectedReferenceDoc) {
                case '0':
                    return 0.5
                case '1':
                    return 0.75
                case '2':
                    return 0.40
                case '3':
                    return 0.40
                default:
                    return 0
            }
        };

        const Y29 = (Y27, Y28) => Math.min(Y27, Y28);
        const X29 = (y27, y28) => (Y29(y27, y28) === y27) ? X27() : X28();
        const Y30 = (y27, y28, val1, val2) => (Y29(y27, y28) === y27) ? val1 : val2;
        // if (S23 = '0') {
        //     N385
        // }
        // else if (S23 = '5') {
        //     N386
        // }
        // else if (S23 = '1') {
        //     N387
        // } else if (S23 = '2') {
        //     N388
        // } else if (S23 = '3') {
        //     N389
        // } else {
        //     N390
        // }
        // { Text: 'Carbon Steel', Value: 0 },
        // { Text: 'Stainless Steel 304/316', Value: 1 },
        // { Text: 'Stainless Steel 304L/316L', Value: 2 },
        // { Text: 'Duplex SS', Value: 3 },
        // { Text: 'Super Duplex SS', Value: 4 },
        // { Text: 'Aluminium', Value: 5 },
        //  0    5    1    2    3     4
        //  300  186  276  276  540   550
        // =IF(AND(S23=L385),P385,IF(AND(S23=L386),P386,IF(AND(S23=L387),P387,IF(AND(S23=L388),P388,IF(AND(S23=L389),P389,O390)))))

        if (value === 0) {
            tempObj = {
                UTS: 410,
                YS: 250,
                FSS: 300,
            }
        } else if (value === 1) {
            tempObj = {
                UTS: 517,
                YS: 207,
                FSS: 276,
            }
        }
        else if (value === 2) {
            tempObj = {
                UTS: 517,
                YS: 207,
                FSS: 276,
            }

            // tempObj = {
            //     UTS: 482,
            //     YS: 172,
            //     FSS: 276,
            // }

        } else if (value === 3) {
            tempObj = {
                UTS: 655,
                YS: 450,
                FSS: 540,
            }

        } else if (value === 4) {
            tempObj = {
                UTS: 795,
                YS: 550,
                FSS: 550,
            }

        }
        else if (value === 5) {
            tempObj = {
                UTS: 290,
                YS: 241,
                FSS: 186,
            }
        } else if (!value) {
            tempObj = {
                UTS: 0,
                YS: 0,
                FSS: 0,
            }
        }

        const stressObj = {
            BendingStress: X29(tempObj.UTS * X27(), tempObj.YS * X28()),
            AxialStress: X29(tempObj.UTS * X27(), tempObj.YS * X28()),
            ShearStress: referenceDocumentsObj.ShearStress
        }

        const stressObject2 = {
            BendingStress: Y30(tempObj.UTS * X27(), tempObj.YS * X28(), tempObj.UTS, tempObj.YS) * X29(tempObj.UTS * X27(), tempObj.YS * X28()),
            AxialStress: Y30(tempObj.UTS * X27(), tempObj.YS * X28(), tempObj.UTS, tempObj.YS) * X29(tempObj.UTS * X27(), tempObj.YS * X28()),
            ShearStress: referenceDocumentsObj.ShearStress * tempObj.FSS
        }


        this.setState({
            manufacturingMaterialObj: tempObj,
            referenceDocumentsObj: stressObj,
            stressObject2,
            currentSelectedMaterial: value
        })
    }

    setThrustOnOptionsArray = (frameLength) => {
        if (frameLength === 'SHORT LENGTH') {
            this.setState({
                thrustOnOptions: [{ Text: 'OP. PLATFORM', Value: 'OP. PLATFORM' }]
            })
        } else {
            this.setState({
                thrustOnOptions: [
                    { Text: 'OP. PLATFORM', Value: 'OP. PLATFORM' },
                    { Text: 'FRAME', Value: 'FRAME' },
                    { Text: 'FRAME VIA THRUST TUBE', Value: 'FRAME VIA THRUST TUBE' },
                ]
            })
        }
    }

    setFrameExtensionArray = (frameExtension) => {

        if (frameExtension === 'A-211 / 212 / 213' || frameExtension === 'A-221 / 222 / 223'
            || frameExtension === 'A-201-202-203 CAST IRON OPEN CHANNEL'
        ) {
            this.setState({
                frameExtensionOption: [
                    { Text: 'SELF CONTAINED', Value: 'SELF CONTAINED' },
                    { Text: 'SELF CONTAINED FRAME WITH EXT LENGTH', Value: 'SELF CONTAINED FRAME WITH EXT LENGTH' },
                    { Text: 'CLOSED TOP FRAME WITH EXT STEM LENGTH', Value: 'CLOSED TOP FRAME WITH EXT STEM LENGTH' }
                ]
            })
        } else {
            this.setState({
                frameExtensionOption: [
                    { Text: 'NOT REQUIRED', Value: 'NOT REQUIRED' },
                    { Text: 'REQUIRED', Value: 'REQUIRED' }
                ]
            })
        }
    }

    setFramelength = (value) => {

        if (value === 'A-211 / 212 / 213' || value === 'A-221 / 222 / 223' ||
            value === 'A-201-202-203 CAST IRON OPEN CHANNEL') {
            this.setState({
                frameLengthOption: [
                    { Text: 'FULL LENGTH', Value: 'FULL LENGTH' }
                ]
            })
        }
        else {
            this.setState({
                frameLengthOption: [
                    { Text: 'SHORT LENGTH', Value: 'SHORT LENGTH' },
                    { Text: 'FULL LENGTH', Value: 'FULL LENGTH' }
                ]
            })
        }
    }

    setApplicabilityStandard = (value) => {

        if (this.state.isSeriesOfferedCI) {
            this.setState({
                applicableStandardDataArray: [
                    { Text: 'AWWA-C560', Value: 'AWWA-C560' },
                    { Text: 'BS-7775', Value: 'BS-7775' },
                    { Text: 'IS-13349', Value: 'IS-13349' }]
            })
        } else {
            this.setState({
                applicableStandardDataArray: [
                    { Text: 'AWWA-C561', Value: 'AWWA-C561' },
                    { Text: 'AWWA-C562', Value: 'AWWA-C562' },
                    { Text: 'BS-7775', Value: 'BS-7775' },
                    { Text: 'IS-5620', Value: 'IS-5620' }],
            })
        }
    }
    getShutterData = () => {
        const { ShutterId } = this.props;

        this.props.getShutterDesignData(ShutterId, (res) => {
            if (res && res.data && res.data.Data) {
                let Data = res.data.Data;
                this.setState({ shutterDataCI: Data })
                if (Data.SelectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN' || Data.SelectedSeriesOffered === 'A-102- SECTIONAL FRAME DESIGN'
                    || Data.SelectedSeriesOffered === 'A-103- INTEGRAL FRAME DESIGN' || Data.SelectedSeriesOffered === 'A-104- UNIVERSAL FRAME DESIGN' ||
                    Data.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' || Data.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') {
                    this.setState({ isSeriesOfferedCI: true }, () => { this.setApplicabilityStandard(Data.SelectedSeriesOffered) })
                } else {
                    this.setState({ isSeriesOfferedCI: false }, () => this.setApplicabilityStandard(Data.SelectedSeriesOffered))
                }

                let shaftSpindle = '';
                if (String(sharftSpindleOption && sharftSpindleOption[0].Text) === String(Data.SelectedSpindleType)) {
                    shaftSpindle = sharftSpindleOption[0].Value;
                } else if ((sharftSpindleOption && sharftSpindleOption[1].Text) === String(Data.SelectedSpindleType)) {
                    shaftSpindle = sharftSpindleOption[1].Value;
                }
                let ClosureType = '';
                if (String(ClosureOption && ClosureOption[0].Text) === String(Data.SelectedClosureType)) {
                    ClosureType = ClosureOption[0].Value;
                } else if (String(ClosureOption && ClosureOption[1].Text) === String(Data.SelectedClosureType)) {
                    ClosureType = ClosureOption[1].Value;
                }
                let referenceDocuments = '';
                if (String(referenceDocsOption && referenceDocsOption[0].Text) === String(Data.SelectedReferenceDocument)) {
                    referenceDocuments = referenceDocsOption[0].Value;
                } else if (String(referenceDocsOption && referenceDocsOption[1].Text) === String(Data.SelectedReferenceDocument)) {
                    referenceDocuments = referenceDocsOption[1].Value;
                } else if (String(referenceDocsOption && referenceDocsOption[2].Text) === String(Data.SelectedReferenceDocument)) {
                    referenceDocuments = referenceDocsOption[2].Value;
                } else if (String(referenceDocsOption && referenceDocsOption[3].Text) === String(Data.SelectedReferenceDocument)) {
                    referenceDocuments = referenceDocsOption[3].Value;
                }
                let manufacturingMaterial = '';
                if (String(manufacturingMaterialOption && manufacturingMaterialOption[0].Text) === String(Data.SelectedMaterialType)) {
                    manufacturingMaterial = manufacturingMaterialOption[0].Value;
                } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[1].Text) === String(Data.SelectedMaterialType)) {
                    manufacturingMaterial = manufacturingMaterialOption[1].Value;
                } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[2].Text) === String(Data.SelectedMaterialType)) {
                    manufacturingMaterial = manufacturingMaterialOption[2].Value;
                } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[3].Text) === String(Data.SelectedMaterialType)) {
                    manufacturingMaterial = manufacturingMaterialOption[3].Value;
                } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[4].Text) === String(Data.SelectedMaterialType)) {
                    manufacturingMaterial = manufacturingMaterialOption[4].Value;
                } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[5].Text) === String(Data.SelectedMaterialType)) {
                    manufacturingMaterial = manufacturingMaterialOption[5].Value;
                }


                this.handleReferenceDocsChild(referenceDocuments);
                this.handleManufacturingMaterialChild(manufacturingMaterial);
                this.setState({
                    selectedHorizontalStiff: Data.SelectedHorizontalStiffnerSection,
                    selectedVerticalStiff: Data.SelectedVerticalStiffnerSection,
                    selectedSeriesOffered: Data.SelectedSeriesOffered,
                    activeActuation: Data.SelectedActuation,
                    stageTwoOpen: true,
                    stageThreeOpen: true,
                    isLoader: false,
                    identifier: {
                        item_number: Data.ItemNumber,
                        pid_number: Data.PIDNumber,
                        quote_number: Data.QuoteNumber
                    },
                    isPostOrderCreated: Data.IsPostCreated,
                    currentSelectedReferenceDoc: referenceDocuments,
                    currentSelectedMaterial: manufacturingMaterial,
                    selectedStemMaterial: Data.SelectedStemMaterial,
                    selectedSpindle: shaftSpindle,
                    frameExtension: Data.SelectedFrameExtension, //API change
                    factorOfSafetyDD: Data.SelectedFactorOfSafety, // API change
                });

                this.setFrameExtensionArray(this.state.selectedSeriesOffered)

                this.setThrustOnOptionsArray(Data.SelectedFrameLengthType)
                this.props.change('date', moment(Data.Dated))
                this.props.change('selectedThrustOn', Data.SelectedThrustOn)
                this.props.change('referenceDocuments', referenceDocuments)
                this.props.change('ItemNumber', Data.ItemNumber)
                this.props.change('pid_number', Data.PIDNumber)
                this.props.change('quote_number', Data.QuoteNumber)
                this.props.change('client', Data.Client)
                this.props.change('project', Data.Project)
                this.props.change('location', Data.Location)
                this.props.change('tag_number', Data.TagNumber)
                this.props.change('rev_number', Data.RevisionNumber)
                if (Data.RevisionDate) {
                    this.props.change('rev_date', moment(Data.RevisionDate))
                }
                this.props.change('applicableStandard', Data.SelectedApplicableStandard)
                this.props.change('stemMaterial', Data.SelectedStemMaterial)
                this.props.change('height', Data.SizeHeight)
                this.props.change('width', Data.SizeWidth)
                this.props.change('seatingHead', Data.SeatingHead)
                this.props.change('unseatingHead', Data.UnseatingHead)
                this.props.change('cl_pl', Data.ClPl)
                this.props.change('stemDia', Data.SelectedStemDiameter)
                this.props.change('shaftSpindle', shaftSpindle)
                this.props.change('SpindleDirection', Data.SelectedSpindleDirection)
                this.props.change('SelectedSeriesOffered', Data.SelectedSeriesOffered)
                this.props.change('Actuation', Data.SelectedActuation)
                this.props.change('ClosureType', ClosureType)
                this.props.change('SelectedFrameLengthType', Data.SelectedFrameLengthType)
                this.props.change('manufacturingMaterial', manufacturingMaterial)
                this.props.change('frameMounting', Data.SelectedFrameMounting)
                this.props.change('verticalStiffeners', Data.NoOfVerticalStiffeners)
                this.props.change('horizontalStiffeners', Data.NoOfHorizontalStiffeners)
                this.props.change('skinPlateThickness', Data.SkinPlateThickness)
                this.props.change('horizontalStiffenersSection', Data.SelectedHorizontalStiffnerSection)
                this.props.change('HRb1', Data.HorizontalStiffenerb1)
                this.props.change('HRt1', Data.HorizontalStiffenert1)
                this.props.change('HRt3', Data.HorizontalStiffenert3)
                this.props.change('HRd', Data.HorizontalStiffenerInnerd)
                //this.props.change('HRd1', Data.HRd1)
                //this.props.change('HRD', Data.HRD)
                this.props.change('horizontalDeflection', Data.HorizontalL)
                this.props.change('verticalStiffenersSection', Data.SelectedVerticalStiffnerSection)
                this.props.change('VRb1', Data.VerticalStiffenerb1)
                this.props.change('VRt1', Data.VerticalStiffenert1)
                this.props.change('VRt3', Data.VerticalStiffenert3)
                this.props.change('VRd', Data.VerticalStiffenerInnerd)
                //this.props.change("VRd1", Data.VRd1)
                //this.props.change("VRD", Data.VRD)
                this.props.change('verticalDeflection', Data.VerticalL)
                this.props.change('FL', Data.FrameLength)
                this.props.change('FOS1', Data.FOSOne)
                this.props.change('FOS2', Data.FOSTwo)
                this.props.change('FOS3', Data.FOSThree)
                this.props.change('SelectedFrameExtension', Data.SelectedFrameExtension)
                this.props.change('factorOfSafetyDD', Data.SelectedFactorOfSafety)
                this.props.change('consideredWeightOfDoor_Shutter', Data.ConsideredWeightOfDoorOrShutter)

                this.props.ActuationToggler(Data.SelectedActuation)
                setTimeout(() => {
                    this.handleReferenceDocsChild(referenceDocuments)
                    this.handleManufacturingMaterialChild(manufacturingMaterial)
                    this.calculationHandler();
                }, 100)
                this.setFramelength(Data.SelectedSeriesOffered);
            }
        })
    }

    // componentDidUpdate(prevProps) {
    //     setTimeout(() => {

    //     if (prevProps.fieldObj.SelectedSeriesOffered !== undefined && 
    //         this.state.selectedSeriesOffered !== undefined && 
    //         (prevProps.fieldObj.SelectedSeriesOffered !== this.state.selectedSeriesOffered)) {
    //         this.getShutterData()
    //     }
    //     }, 4000);
    // }

    componentDidMount = () => {

        const { data, isEditFlag, ShutterId, isViewFlag } = this.props;

        this.setState({ isLoader: true })
        if (isEditFlag || isViewFlag || ShutterId) {
            this.getShutterData()
        } else {
            let shaftSpindle = sharftSpindleOption[0].Value;
            let ClosureType = ClosureOption[0].Value;
            let referenceDocuments = referenceDocsOption[0].Value;
            let manufacturingMaterial = manufacturingMaterialOption[0].Value;
            this.handleReferenceDocsChild(referenceDocuments);
            this.handleManufacturingMaterialChild(manufacturingMaterial);
            this.props.change('date', data.date)
            this.props.change('selectedThrustOn', data.selectedThrustOn)
            this.props.change('applicableStandard', data.applicableStandard)
            this.props.change('stemMaterial', data.stemMaterial)
            this.props.change('ItemNumber', data.ItemNumber)
            this.props.change('pid_number', data.pid_number)
            this.props.change('quote_number', data.quote_number)
            this.props.change('client', data.client)
            this.props.change('project', data.project)
            this.props.change('location', data.location)
            this.props.change('tag_number', data.tag_number)
            this.props.change('rev_number', data.rev_number)
            this.props.change('rev_date', data.rev_date)
            this.props.change('height', data.height)
            this.props.change('width', data.width)
            this.props.change('seatingHead', data.seatingHead)
            this.props.change('unseatingHead', data.unseatingHead)
            this.props.change('stemDia', data.stemDia)
            this.props.change('cl_pl', data.cl_pl)
            this.props.change('shaftSpindle', data.shaftSpindle)
            this.props.change('SpindleDirection', data.SpindleDirection)
            this.props.change('frameMounting', data.frameMounting)
            this.props.change('ClosureType', data.ClosureType)
            this.props.change('Actuation', data.Actuation)
            this.props.change('SelectedSeriesOffered', data.SelectedSeriesOffered)
            this.props.change('SelectedFrameLengthType', data.SelectedFrameLengthType)
            this.props.change('HRb1', data.HRb1)
            this.props.change('HRd', data.HRd)
            this.props.change('HRt1', data.HRt1)
            this.props.change('HRt3', data.HRt3)
            this.props.change('HRb1', data.HRb1)
            this.props.change('HRd1', data.HRd1)
            this.props.change('HRD', data.HRD)
            this.props.change('VRb1', data.VRb1)
            this.props.change('VRt1', data.VRt1)
            this.props.change("VRd1", data.VRd1)
            this.props.change("VRD", data.VRD)
            this.props.change('VRt3', data.VRt3)
            this.props.change('VRd', data.VRd)
            // this.props.change('referenceDocuments', '')
            // this.props.change('manufacturingMaterial', data.manufacturingMaterial)
            this.props.change('horizontalStiffenersSection', data.horizontalStiffenersSection)
            this.props.change('verticalStiffenersSection', data.verticalStiffenersSection)
            this.props.change('horizontalStiffeners', data.horizontalStiffeners)
            this.props.change('verticalStiffeners', data.verticalStiffeners)
            this.props.change('skinPlateThickness', data.skinPlateThickness)
            this.props.change('horizontalDeflection', data.horizontalDeflection)
            this.props.change('verticalDeflection', data.verticalDeflection)
            this.props.change('FL', data.FrameLength)
            this.props.change('FOS1', data.FOSOne)
            this.props.change('FOS2', data.FOSTwo)
            this.props.change('FOS3', data.FOSThree)
            this.props.change('factorOfSafetyDD', data.SelectedFactorOfSafety)
            this.setState({
                selectedSeriesOffered: data.SelectedSeriesOffered,
                isLoader: false,
                currentSelectedReferenceDoc: '',
                currentSelectedMaterial: '',
                selectedSpindle: data.SpindleDirection
            })

            setTimeout(() => {
                this.handleReferenceDocsChild(null)
                this.handleManufacturingMaterialChild(null)
                this.calculationHandler();
                this.setState({ isLoader: false })
            }, 100)
        }
    }

    componentWillUnmount = () => {
        const { fieldObj } = this.props;
        this.props.setData(fieldObj);
        this.props.setShutterDesignData({
            ...this.props.shutterDesignData,
            UTS: this.state.manufacturingMaterialObj.UTS,
            shutterDesignId: this.state.shutterDesignId,
            selectedSpindle: this.state.selectedSpindle,
            setApplicableStandard: this.state.selectedApplicableStandard,
            stemMaterial: this.state.selectedStemMaterial,
        });

    }

    calculationHandler = () => {
        setTimeout(() => {
            this.calculate()
        }, 100)
    }

    calculate = () => {

        const { selectedHorizontalStiff, selectedVerticalStiff } = this.state;
        let t1 = checkForNull(this.returnFieldInteger('HRt1'));
        let t2 = checkForNull(this.returnFieldInteger('skinPlateThickness'));
        let d = checkForNull(this.returnFieldInteger('HRd'));
        let d1 = checkForNull(this.returnFieldInteger('HRd1'));

        if (selectedHorizontalStiff === 'A') {
            this.props.change('HRd1', d - t1)
            this.props.change('HRD', t2 + d)
        } else if (selectedHorizontalStiff === 'B') {
            this.props.change('HRd1', d)
            this.props.change('HRD', t2 + d)
        } else if (selectedHorizontalStiff === 'C') {
            this.props.change('HRd1', d - 2 * t1)
            this.props.change('HRD', t2 + d)
        } else if (selectedHorizontalStiff === 'D') {
            this.props.change('HRd1', d - 2 * t1)
            this.props.change('HRD', t2 + d)
        } else if (selectedHorizontalStiff === 'E') {

            this.props.change('HRd1', d - t1)
            this.props.change('HRD', d1 + t1 + t2)
        }

        let Vt1 = this.returnFieldInteger('VRt1');
        let Vd = this.returnFieldInteger('VRd');
        let Vd1 = this.returnFieldInteger('VRd1');

        if (selectedVerticalStiff === 'A') {
            this.props.change('VRd1', Vd - Vt1)
            this.props.change('VRD', t2 + Vd)
        } else if (selectedVerticalStiff === 'B') {
            this.props.change('VRd1', Vd)
            this.props.change('VRD', t2 + Vd)
        } else if (selectedVerticalStiff === 'C') {
            this.props.change('VRd1', Vd - 2 * Vt1)
            this.props.change('VRD', t2 + Vd)
        } else if (selectedVerticalStiff === 'D') {
            this.props.change('VRd1', Vd - 2 * Vt1)
            this.props.change('VRD', t2 + Vd)
        } else if (selectedVerticalStiff === 'E') {
            this.props.change('VRd1', Vd - Vt1)
            this.props.change('VRD', Vd1 + Vt1 + t2)
        }
    }

    returnFieldInteger = (fieldName) => {
        const { fieldObj } = this.props;

        switch (fieldName) {
            case 'HRb1':
                return fieldObj && fieldObj.HRb1 ? Number(fieldObj.HRb1) : 0;
            case 'HRd':
                return fieldObj && fieldObj.HRd ? Number(fieldObj.HRd) : 0;
            case 'HRd1':
                return fieldObj && fieldObj.HRd1 ? Number(fieldObj.HRd1) : 0;
            case 'HRD':
                return fieldObj && fieldObj.HRD ? Number(fieldObj.HRD) : 0;
            case 'HRt1':
                return fieldObj && fieldObj.HRt1 ? Number(fieldObj.HRt1) : 0;
            case 'HRt3':
                return fieldObj && fieldObj.HRt3 ? Number(fieldObj.HRt3) : 0;
            case 'VRb1':
                return fieldObj && fieldObj.VRb1 ? Number(fieldObj.VRb1) : 0;
            case 'VRd':
                return fieldObj && fieldObj.VRd ? Number(fieldObj.VRd) : 0;
            case 'VRd1':
                return fieldObj && fieldObj.VRd1 ? Number(fieldObj.VRd1) : 0;
            case 'VRD':
                return fieldObj && fieldObj.VRD ? Number(fieldObj.VRD) : 0;
            case 'VRt1':
                return fieldObj && fieldObj.VRt1 ? Number(fieldObj.VRt1) : 0;
            case 'VRt3':
                return fieldObj && fieldObj.VRt3 ? Number(fieldObj.VRt3) : 0;
            case 'height':
                return fieldObj && fieldObj.height ? Number(fieldObj.height) : 0;
            case 'horizontalDeflection':
                return fieldObj && fieldObj.horizontalDeflection ? Number(fieldObj.horizontalDeflection) : 0;
            case 'horizontalStiffeners':
                return fieldObj && fieldObj.horizontalStiffeners ? Number(fieldObj.horizontalStiffeners) : 0;
            case 'horizontalStiffenersSection':
                return fieldObj && fieldObj.horizontalStiffenersSection ? Number(fieldObj.horizontalStiffenersSection) : 0;
            case 'seatingHead':
                return fieldObj && fieldObj.seatingHead ? Number(fieldObj.seatingHead) : 0;
            case 'skinPlateThickness':
                return fieldObj && fieldObj.skinPlateThickness ? Number(fieldObj.skinPlateThickness) : 0;
            case 'unseatingHead':
                return fieldObj && fieldObj.unseatingHead ? Number(fieldObj.unseatingHead) : 0;
            case 'verticalDeflection':
                return fieldObj && fieldObj.verticalDeflection ? Number(fieldObj.verticalDeflection) : 0;
            case 'verticalStiffeners':
                return fieldObj && fieldObj.verticalStiffeners ? Number(fieldObj.verticalStiffeners) : 0;
            case 'width':
                return fieldObj && fieldObj.width ? Number(fieldObj.width) : 0;
            default:
                break;
        }
    }

    /**
    * @method stageOneController
    * @description Hide and Show stage one 
    */
    stageOneController = () => {
        this.setState({
            stageOneOpen: !this.state.stageOneOpen
        })
    }

    /**
    * @method stageTwoController
    * @description Hide and Show stage two 
    */
    stageTwoController = () => {
        this.setState({
            stageTwoOpen: !this.state.stageTwoOpen
        })
    }

    /**
    * @method stageThreeController
    * @description Hide and Show stage three 
    */
    stageThreeController = () => {
        this.setState({
            stageThreeOpen: !this.state.stageThreeOpen
        })
    }

    /**
    * @method handleStemDia
    * @description Hide and Show stage three 
    */
    handleStemDia = (e) => {
        const value = e.target.value;
    }

    /**
    * @method handleFrameLength
    * @description 
    */
    handleFrameLength = (e) => {
        const value = e.target.value;
        this.setThrustOnOptionsArray(value)
    }

    /**
    * @method handleFrameExtension
    * @description 
    */
    handleFrameExtension = (e) => {
        const value = e.target.value;
        this.setState({ frameExtension: value })
    }

    /**
    * @method nextStepTwo
    * @description Move to step 2 
    */
    nextStepTwo = () => {
        this.setState({
            stageTwoOpen: !this.state.stageTwoOpen
        })
    }

    /**
    * @method handleDate
    * @description Handle date
    */
    handleDate = (date) => {
        this.setState({
            startDate: date,
        });
    };

    /**
    * @method seatingWaterCalculation
    * @description Calculate seating water head 
    */
    seatingWaterCalculation = () => {
        return (this.returnFieldInteger('seatingHead') * 1000) + (this.returnFieldInteger('height') / 2)
    };

    /**
    * @method unseatingWaterCalculation
    * @description Calculate unseating water head
    */
    unseatingWaterCalculation = () => {
        return (this.returnFieldInteger('unseatingHead') * 1000) + (this.returnFieldInteger('height') / 2)
    };

    /**
    * @method returnMaxNumber
    * @description Return max number
    */
    returnMaxNumber = () => {
        const seatingHead = this.returnFieldInteger('seatingHead') * 1000 + (this.returnFieldInteger('height') / 2)
        const unseatingHead = (this.returnFieldInteger('unseatingHead') * 1000) + (this.returnFieldInteger('height') / 2)

        if (seatingHead > unseatingHead) {
            return seatingHead;
        } else if (unseatingHead > seatingHead) {
            return unseatingHead;
        } if (unseatingHead == seatingHead) {
            return seatingHead;
        }

    };

    handleReferenceDocs = (e) => {
        const value = e.target.value;
        this.handleReferenceDocsChild(value)
    }

    handleManufacturingMaterial = (e) => {
        const value = e.target.value;
        this.handleManufacturingMaterialChild(value)
    }


    /**
    * @method bayWidthVerticalStif
    * @description Calculate bay width of vertical stiffeners
    */
    bayWidthVerticalStif = () => {
        const { fieldObj } = this.props;
        return (fieldObj && fieldObj.verticalStiffeners) ? checkForNull((this.returnFieldInteger('width') / (this.returnFieldInteger('verticalStiffeners') - 1))) : 0
    };

    /**
    * @method bayWidthHorizontalStif
    * @description Calculate bay width of horizontal stiffeners
    */
    bayWidthHorizontalStif = () => {
        const { fieldObj } = this.props;
        return (fieldObj && fieldObj.horizontalStiffeners) ? checkForNull((this.returnFieldInteger('height') / (this.returnFieldInteger('horizontalStiffeners') - 1))) : 0
    };

    /**
    * @method maxPressureCenterSkinPlate
    * @description Calculate max Pressure Center Skin Plate
    */
    maxPressureCenterSkinPlate = () => {
        const { fieldObj } = this.props;
        return (((1010 * 9.81) * (fieldObj && fieldObj.seatingHead ? `${this.returnMaxNumber() / 1000}` : 0)) / 1000000)
    };

    /**
    * @method returnMaxStiffeners
    * @description Calculate return Max Stiffeners
    */
    returnMaxStiffeners = () => {
        const { fieldObj } = this.props;
        const verticalStiff = (fieldObj && fieldObj.verticalStiffeners) ? checkForNull((this.returnFieldInteger('width') / (this.returnFieldInteger('verticalStiffeners') - 1))) : 0;
        const horizontalStiff = (fieldObj && fieldObj.horizontalStiffeners) ? checkForNull((this.returnFieldInteger('height') / (this.returnFieldInteger('horizontalStiffeners') - 1))) : 0;

        if (verticalStiff < horizontalStiff) {
            return checkForNull((horizontalStiff / verticalStiff));
        } else {
            return checkForNull((verticalStiff / horizontalStiff));
        }

    };

    /**fieldObj
    * @method nonDimensionalFactor
    * @description Calculate non Dimensional Factor
    */
    nonDimensionalFactor = () => {
        const { } = this.props;
        const maxStiffener = this.returnMaxStiffeners();

        if (maxStiffener <= 1) {
            return 30.9;
        } else if (maxStiffener <= 1.25) {
            return 40.3;
        } else if (maxStiffener <= 1.5) {
            return 45.5;
        } else if (maxStiffener <= 1.75) {
            return 48.4;
        } else if (maxStiffener <= 2) {
            return 49.9;
        } else if (maxStiffener <= 2.5) {
            return 50;
        } else {
            return 50;
        }

    };

    /**
    * @method calculateSkinPlateBendingStress
    * @description Calculate Skin Plate Bending Stress
    */
    calculateSkinPlateBendingStress = () => {
        const { fieldObj } = this.props;
        const nonDimensionalFactor = this.nonDimensionalFactor();
        const maxPressureSkinPlate = this.maxPressureCenterSkinPlate();

        const verticalStiff = (fieldObj && fieldObj.verticalStiffeners) ? checkForNull((this.returnFieldInteger('width') / (this.returnFieldInteger('verticalStiffeners') - 1))) : 0;
        const horizontalStiff = (fieldObj && fieldObj.horizontalStiffeners) ? checkForNull((this.returnFieldInteger('height') / (this.returnFieldInteger('horizontalStiffeners') - 1))) : 0;
        let returnValue = '';
        if (verticalStiff < horizontalStiff) {
            returnValue = verticalStiff;
        } else {
            returnValue = horizontalStiff;
        }

        const bendingStress = (nonDimensionalFactor / 100 * maxPressureSkinPlate * (returnValue * returnValue)) / (this.returnFieldInteger('skinPlateThickness') * this.returnFieldInteger('skinPlateThickness'))
        return checkForNull(bendingStress)
    };

    /**
    * @method bendingStressAlert
    * @description bending Stress Alert
    */
    bendingStressAlert = () => {

        // const permissibleBendingStress = (referenceDocumentsObj.BendingStress * manufacturingMaterialObj.YS).toFixed(2)
        const permissibleBendingStress = shearstressObj
        const bendingStressInPlate = this.calculateSkinPlateBendingStress()

        if (permissibleBendingStress > bendingStressInPlate) {
            return "The bending stress in skin plate due to applied water head is less than the permissible stress, Hence the considered thickness of skin plate is safe.";
        } else {
            return <p className='error'>Design is unsafe. Please choose different values.</p>;
        }
    };

    /**
    * @method handlehorizontalStiffeners
    * @description bending Stress Alert
    */
    handlehorizontalStiffeners = (e) => {

        let t1 = this.returnFieldInteger('HRt1');
        let d = this.returnFieldInteger('HRd');

        const value = e.target.value;
        let tempObj = {};

        if (value === 'A') {
            this.props.change('HRd1', d - t1)
            tempObj = HorizontalStiffiners.A;
        } else if (value === 'B') {
            this.props.change('HRd1', d)
            tempObj = HorizontalStiffiners.B;
        } else if (value === 'C') {
            this.props.change('HRd1', d - 2 * t1)
            tempObj = HorizontalStiffiners.C;
        } else if (value === 'D') {
            this.props.change('HRd1', d - 2 * t1)
            tempObj = HorizontalStiffiners.D;
        } else if (value === 'E') {
            this.props.change('HRd1', d - t1)
            tempObj = HorizontalStiffiners.E;
        }

        this.setState({
            selectedHorizontalStiff: value,
            horizontalStiffenersSectionObj: tempObj
        }, () => this.calculationHandler())
    };

    handlefactorOfSafetyDD = (e) => {
        this.setState({
            factorOfSafetyDD: e.target.value
            // horizontalStiffenersSectionObj: tempObj
        });//, () => this.calculationHandler())
    };

    /**
    * @method hrb1AlertMsg
    * @description Horizontal stiff b1 alert msg according to selected section
    */
    hrb1AlertMsg = () => {
        const { selectedHorizontalStiff } = this.state;

        if ((selectedHorizontalStiff === 'A' || selectedHorizontalStiff === 'C' || selectedHorizontalStiff === 'D' || selectedHorizontalStiff === 'E') && Number(this.returnFieldInteger('HRb1')) === 0) {
            return 'Warning either put the value of b1 or change the section';
        } else if (selectedHorizontalStiff === 'B' && Number(this.returnFieldInteger('HRb1')) === 0) {
            return '';
        } else if (selectedHorizontalStiff === 'B' && Number(this.returnFieldInteger('HRb1')) !== 0) {
            return 'Warning either put the value of b1 or change the section';
        } else {
            return '';
        }
    }

    /**
    * @method hrt1AlertMsg
    * @description Horizontal stiff t1 alert msg according to selected section
    */
    hrt1AlertMsg = () => {
        const { selectedHorizontalStiff } = this.state;

        if ((selectedHorizontalStiff === 'A' || selectedHorizontalStiff === 'C' || selectedHorizontalStiff === 'D' || selectedHorizontalStiff === 'E') && Number(this.returnFieldInteger('HRt1')) === 0) {
            return 'Warning either put the value of t1 or change the section';
        } else if (selectedHorizontalStiff === 'B' && Number(this.returnFieldInteger('HRt1')) === 0) {
            return '';
        } else if (selectedHorizontalStiff === 'B' && Number(this.returnFieldInteger('HRt1')) !== 0) {
            return 'Warning either put the value of t1 or change the section';
        } else {
            return '';
        }
    }

    /**
    * @method returnEndVerticalStiff
    * @description Return end vertical stiffiners
    */
    returnEndVerticalStiff = () => {
        const { fieldObj } = this.props;

        return fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;
    }

    /**
    * @method returnCoActingWidthB1
    * @description Co acting width B1
    */
    returnCoActingWidthB1 = () => {
        const { fieldObj } = this.props;

        return fieldObj ? checkForNull(((40 * this.returnFieldInteger('skinPlateThickness')) + this.returnFieldInteger('HRt3'))) : 0;
    }

    /**
    * @method returnCoActingWidthB2
    * @description Co acting width B2
    */
    returnCoActingWidthB2 = () => {
        return this.returnEndVerticalStiff() * 0.11;
    }

    /**
    * @method returnMinimumCoActingWidth
    * @description Return Co acting minimum width
    */
    returnMinimumCoActingWidth = () => {
        const coActingB1 = this.returnCoActingWidthB1();
        const coActingB2 = this.returnCoActingWidthB2();
        const bayWidthHorizontal = this.bayWidthHorizontalStif();

        return checkForNull((Math.min(coActingB1, coActingB2, bayWidthHorizontal)));
    }

    /**
    * @method HRStiffY1Calculation
    * @description Return Y1 according to Horizontal stiffeners
    */
    HRStiffY1Calculation = () => {
        const { selectedHorizontalStiff } = this.state;

        let B = this.returnMinimumCoActingWidth();
        let D = this.returnFieldInteger('skinPlateThickness') + this.returnFieldInteger('HRd');
        let b1 = this.returnFieldInteger('HRb1');
        let b = this.returnFieldInteger('HRb1') - this.returnFieldInteger('HRt1');
        let d1 = this.returnFieldInteger('HRd1');
        let t1 = this.returnFieldInteger('HRt1');
        let t2 = this.returnFieldInteger('skinPlateThickness');
        let t3 = this.returnFieldInteger('HRt3');
        let d = this.returnFieldInteger('HRd');
        let a1 = b1 * t1;
        let a = d1 * t3;
        let a2 = B * t2;
        let a3 = '';

        let returnY1 = '';

        if (selectedHorizontalStiff === 'A') {

            returnY1 = (a2 * (2 * D - t2) + (a1 * t1) + a * (d1 + 2 * t1)) / (2 * (a1 + a + a2))

        } else if (selectedHorizontalStiff === 'B') {

            b = B - t3;
            d1 = d;
            returnY1 = (B * Math.pow(D, 2) - b * Math.pow(d1, 2)) / (2 * (B * D - b * d1))

        } else if (selectedHorizontalStiff === 'C' || selectedHorizontalStiff === 'D') {

            b = b1;
            d1 = d - 2 * t1;
            a1 = b * t1;
            a = d1 * t3;
            a2 = checkForNull(B * t2);

            returnY1 = (a2 * (D - t2 / 2) + a1 * (d1 + t1 + t1 / 2) + a * (d1 / 2 + t1) + a1 * t1 / 2) / (2 * a1 + a + a2)

        } else if (selectedHorizontalStiff === 'E') {

            d1 = d - t1;
            D = t2 + d1 + t1;
            a1 = b1 * t1;
            a2 = t3 * d1;
            a3 = B * t2;

            returnY1 = (a3 * (t2 / 2 + d1 + t1) + a2 * (d1 / 2 + t1) + a1 * (t1 / 2)) / (a1 + a2 + a3)

        }

        return checkForNull(returnY1);
    }

    /**
    * @method HRStiffY2Calculation
    * @description Return Y2 according to Horizontal stiffeners
    */
    HRStiffY2Calculation = () => {
        const { selectedHorizontalStiff } = this.state;

        let B = this.returnMinimumCoActingWidth();
        let D = this.returnFieldInteger('skinPlateThickness') + this.returnFieldInteger('HRd');
        let b1 = this.returnFieldInteger('HRb1');
        let b = this.returnFieldInteger('HRb1') - this.returnFieldInteger('HRt1');
        let d1 = this.returnFieldInteger('HRd1');
        let t1 = this.returnFieldInteger('HRt1');
        let t2 = this.returnFieldInteger('skinPlateThickness');
        let t3 = this.returnFieldInteger('HRt3');
        let d = this.returnFieldInteger('HRd');
        let a1 = b1 * t1;
        let a = d1 * t3;
        let a2 = B * t2;
        let a3 = '';

        let returnY2 = '';

        if (selectedHorizontalStiff === 'A') {

            returnY2 = (a1 * (2 * D - t1) + (a2 * t2) + a * (d1 + 2 * t2)) / (2 * (a1 + a + a2))

        } else if (selectedHorizontalStiff === 'B') {

            b = B - t3;
            d1 = d;

            // 
            // 
            // 
            // 
            // 
            // 
            // 
            // 
            // 

            returnY2 = (B * Math.pow(D, 2) + (b * Math.pow(d1, 2)) - (2 * b * d1 * D)) / (2 * ((B * D) - (b * d1)))

        } else if (selectedHorizontalStiff === 'C' || selectedHorizontalStiff === 'D') {

            b = b1;
            d1 = d - 2 * t1;
            a1 = b * t1;
            a = d1 * t3;
            a2 = checkForNull(B * t2);

            returnY2 = (a1 * (D - t1 / 2) + a * (d1 / 2 + t1 + t2) + a1 * (t2 + t1 / 2) + a2 * t2 / 2) / (2 * a1 + a + a2)

        } else if (selectedHorizontalStiff === 'E') {

            d1 = d - t1;
            D = t2 + d1 + t1;
            a1 = b1 * t1;
            a2 = t3 * d1;
            a3 = B * t2;

            returnY2 = (a1 * (t1 / 2 + d1 + t2) + a2 * (d1 / 2 + t2) + a3 * (t2 / 2)) / (a1 + a2 + a3)

        }

        return checkForNull(returnY2);
    }

    /**
    * @method HRStiffInertiaCalculation
    * @description Return I according to Horizontal stiffeners
    */
    HRStiffInertiaCalculation = () => {
        const { selectedHorizontalStiff } = this.state;

        let B = this.returnMinimumCoActingWidth();
        let D = this.returnFieldInteger('skinPlateThickness') + this.returnFieldInteger('HRd');
        let b1 = this.returnFieldInteger('HRb1');
        let b = this.returnFieldInteger('HRb1') - this.returnFieldInteger('HRt1');
        let d1 = this.returnFieldInteger('HRd1');
        let t1 = this.returnFieldInteger('HRt1');
        let t2 = this.returnFieldInteger('skinPlateThickness');
        let t3 = this.returnFieldInteger('HRt3');
        let d = this.returnFieldInteger('HRd');
        let a1 = b1 * t1;
        let a = d1 * t3;
        let a2 = B * t2;
        let a3 = '';
        let Intertia = '';
        let I1 = '';
        let I2 = '';
        let returnInertia = '';

        if (selectedHorizontalStiff === 'A') {

            I1 = (1 / 12) * ((a1 * Math.pow(t1, 2)) + (a2 * Math.pow(t2, 2)) + (a * Math.pow(d1, 2)));
            I2 = (a1 * a2 * Math.pow((D + d1), 2) + a1 * a * Math.pow((t1 + d1), 2) + a2 * a * Math.pow((t2 + d1), 2));
            Intertia = I1 + (I2 / (4 * (a1 + a + a2)));
            returnInertia = Intertia / 1000000000000

        } else if (selectedHorizontalStiff === 'B') { //TODO: This should be swtich case

            b = B - t3;   //TODO: The below values should be a function
            d1 = d;

            returnInertia = ((1 / (12 * ((B * D) - (b * d1)))) * ((Math.pow((B * Math.pow(D, 2) - b * Math.pow(d1, 2)), 2)) - (4 * B * D * b * d1 * Math.pow((D - d1), 2)))) / 1000000000000

        } else if (selectedHorizontalStiff === 'C' || selectedHorizontalStiff === 'D') {

            b = b1;
            d1 = d - 2 * t1;
            a1 = b * t1;
            a = d1 * t3;
            a2 = checkForNull(B * t2);

            returnInertia = ((1 / 12) * (a1 * Math.pow(t1, 2) + a * Math.pow(d1, 2) + a1 * Math.pow(t1, 2) + a2 * Math.pow(t2, 2)) + a1 * Math.pow((this.HRStiffY1Calculation() - t1 / 2), 2) + a * Math.pow((this.HRStiffY1Calculation() - d1 / 2), 2) + a1 * Math.pow((this.HRStiffY2Calculation() - t2 - t1 / 2), 2) + a2 * Math.pow((this.HRStiffY2Calculation() - t2 / 2), 2)) / 1000000000000

        } else if (selectedHorizontalStiff === 'E') {

            d1 = d - t1;
            D = t2 + d1 + t1;
            a1 = b1 * t1;
            a2 = t3 * d1;
            a3 = B * t2;

            returnInertia = ((1 / 12) * (a1 * Math.pow(t1, 2) + a3 * Math.pow(t2, 2) + a2 * Math.pow(d1, 2)) + ((a1 * a3 * Math.pow((D + d1), 2) + a1 * a2 * Math.pow((t1 + d1), 2) + a3 * a2 * Math.pow((t2 + d1), 2))) / (4 * (a1 + a2 + a3))) / 1000000000000

        }

        return checkForNull(returnInertia);
    }

    /**
    * @method VRStiffY1Calculation
    * @description Return Y1 according to Vertical stiffeners
    */
    VRStiffY1Calculation = () => {
        const { selectedVerticalStiff } = this.state;

        let B = this.returnVerticalMinimumCoActingWidth();
        let D = this.returnFieldInteger('skinPlateThickness') + this.returnFieldInteger('VRd');
        let b1 = this.returnFieldInteger('VRb1');
        let b = this.returnFieldInteger('VRb1') - this.returnFieldInteger('VRt1');
        let d1 = this.returnFieldInteger('VRd1');
        let t1 = this.returnFieldInteger('VRt1');
        let t2 = this.returnFieldInteger('skinPlateThickness');
        let t3 = this.returnFieldInteger('VRt3');
        let d = this.returnFieldInteger('VRd');
        let a1 = b1 * t1;
        let a = d1 * t3;
        let a2 = B * t2;
        let a3 = '';

        let returnY1 = '';

        if (selectedVerticalStiff === 'A') {

            returnY1 = (a2 * (2 * D - t2) + (a1 * t1) + a * (d1 + 2 * t1)) / (2 * (a1 + a + a2))

        } else if (selectedVerticalStiff === 'B') {

            b = B - t3;
            d1 = d;
            returnY1 = (B * Math.pow(D, 2) - b * Math.pow(d1, 2)) / (2 * (B * D - b * d1))

        } else if (selectedVerticalStiff === 'C' || selectedVerticalStiff === 'D') {

            b = b1;
            d1 = d - 2 * t1;
            a1 = b * t1;
            a = d1 * t3;
            a2 = checkForNull(B * t2);

            returnY1 = (a2 * (D - t2 / 2) + a1 * (d1 + t1 + t1 / 2) + a * (d1 / 2 + t1) + a1 * t1 / 2) / (2 * a1 + a + a2)

        } else if (selectedVerticalStiff === 'E') {

            d1 = d - t1;
            D = t2 + d1 + t1;
            a1 = b1 * t1;
            a2 = t3 * d1;
            a3 = B * t2;

            returnY1 = (a3 * (t2 / 2 + d1 + t1) + a2 * (d1 / 2 + t1) + a1 * (t1 / 2)) / (a1 + a2 + a3)

        }

        return checkForNull(returnY1);
    }

    /**
        * @method VRStiffY2Calculation
        * @description Return Y2 according to Vertical stiffeners
        */
    VRStiffY2Calculation = () => {
        const { selectedVerticalStiff } = this.state;

        let B = this.returnVerticalMinimumCoActingWidth();
        let D = this.returnFieldInteger('skinPlateThickness') + this.returnFieldInteger('VRd');
        let b1 = this.returnFieldInteger('VRb1');
        let b = this.returnFieldInteger('VRb1') - this.returnFieldInteger('VRt1');
        let d1 = this.returnFieldInteger('VRd1');
        let t1 = this.returnFieldInteger('VRt1');
        let t2 = this.returnFieldInteger('skinPlateThickness');
        let t3 = this.returnFieldInteger('VRt3');
        let d = this.returnFieldInteger('VRd');
        let a1 = b1 * t1;
        let a = d1 * t3;
        let a2 = B * t2;
        let a3 = '';

        let returnY2 = '';

        if (selectedVerticalStiff === 'A') {

            returnY2 = (a1 * (2 * D - t1) + (a2 * t2) + a * (d1 + 2 * t2)) / (2 * (a1 + a + a2))

        } else if (selectedVerticalStiff === 'B') {

            b = B - t3;
            d1 = d;

            returnY2 = (B * Math.pow(D, 2) + b * Math.pow(d1, 2) - 2 * b * d1 * D) / (2 * (B * D - b * d1))

        } else if (selectedVerticalStiff === 'C' || selectedVerticalStiff === 'D') {

            b = b1;
            d1 = d - 2 * t1;
            a1 = b * t1;
            a = d1 * t3;
            a2 = checkForNull(B * t2);

            returnY2 = (a1 * (D - t1 / 2) + a * (d1 / 2 + t1 + t2) + a1 * (t2 + t1 / 2) + a2 * t2 / 2) / (2 * a1 + a + a2)

        } else if (selectedVerticalStiff === 'E') {

            d1 = d - t1;
            D = t2 + d1 + t1;
            a1 = b1 * t1;
            a2 = t3 * d1;
            a3 = B * t2;

            returnY2 = (a1 * (t1 / 2 + d1 + t2) + a2 * (d1 / 2 + t2) + a3 * (t2 / 2)) / (a1 + a2 + a3)

        }

        return checkForNull(returnY2);
    }


    /**
    * @method VRStiffInertiaCalculation
    * @description Return I according to Vertical stiffeners
    */
    VRStiffInertiaCalculation = () => {
        const { selectedVerticalStiff } = this.state;

        let B = this.returnVerticalMinimumCoActingWidth();
        let D = this.returnFieldInteger('skinPlateThickness') + this.returnFieldInteger('VRd');
        let b1 = this.returnFieldInteger('VRb1');
        let b = this.returnFieldInteger('VRb1') - this.returnFieldInteger('VRt1');
        let d1 = this.returnFieldInteger('VRd1');
        let t1 = this.returnFieldInteger('VRt1');
        let t2 = this.returnFieldInteger('skinPlateThickness');
        let t3 = this.returnFieldInteger('VRt3');
        let d = this.returnFieldInteger('VRd');
        let a1 = b1 * t1;
        let a = d1 * t3;
        let a2 = B * t2;
        let a3 = '';

        let Intertia = '';
        let I1 = '';
        let I2 = '';
        let returnInertia = '';

        if (selectedVerticalStiff === 'A') {

            I1 = (1 / 12) * ((a1 * Math.pow(t1, 2)) + (a2 * Math.pow(t2, 2)) + (a * Math.pow(d1, 2)));
            I2 = (a1 * a2 * Math.pow((D + d1), 2) + a1 * a * Math.pow((t1 + d1), 2) + a2 * a * Math.pow((t2 + d1), 2));
            Intertia = I1 + (I2 / (4 * (a1 + a + a2)));
            returnInertia = Intertia / 1000000000000

        } else if (selectedVerticalStiff === 'B') { //TODO: This should be swtich case

            b = B - t3;   //TODO: The below values should be a function
            d1 = d;

            returnInertia = ((1 / (12 * ((B * D) - (b * d1)))) * ((Math.pow((B * Math.pow(D, 2) - b * Math.pow(d1, 2)), 2)) - (4 * B * D * b * d1 * Math.pow((D - d1), 2)))) / 1000000000000

        } else if (selectedVerticalStiff === 'C' || selectedVerticalStiff === 'D') {

            b = b1;
            d1 = d - 2 * t1;
            a1 = b * t1;
            a = d1 * t3;
            a2 = checkForNull(B * t2);

            returnInertia = ((1 / 12) * (a1 * Math.pow(t1, 2) + a * Math.pow(d1, 2) + a1 * Math.pow(t1, 2) + a2 * Math.pow(t2, 2)) + a1 * Math.pow((this.VRStiffY1Calculation() - t1 / 2), 2) + a * Math.pow((this.VRStiffY1Calculation() - d1 / 2), 2) + a1 * Math.pow((this.VRStiffY2Calculation() - t2 - t1 / 2), 2) + a2 * Math.pow((this.VRStiffY2Calculation() - t2 / 2), 2)) / 1000000000000

        } else if (selectedVerticalStiff === 'E') {

            d1 = d - t1;
            D = t2 + d1 + t1;
            a1 = b1 * t1;
            a2 = t3 * d1;
            a3 = B * t2;

            returnInertia = ((1 / 12) * (a1 * Math.pow(t1, 2) + a3 * Math.pow(t2, 2) + a2 * Math.pow(d1, 2)) + ((a1 * a3 * Math.pow((D + d1), 2) + a1 * a2 * Math.pow((t1 + d1), 2) + a3 * a2 * Math.pow((t2 + d1), 2))) / (4 * (a1 + a2 + a3))) / 1000000000000

        }

        return checkForNull(returnInertia);
    }


    /**
    * @method bayWidthHtalStiffSpan
    * @description Bay width of horizontal stiffiners span
    */
    bayWidthHtalStiffSpan = () => {
        const { fieldObj } = this.props;
        const bayWidthHorizontal = this.bayWidthHorizontalStif();
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull(((bayWidthHorizontal / 1000) * (width / 1000)))
    }

    /**
    * @method returnHydroForceMaxHead
    * @description Hydrostatic force due to max head
    */
    returnHydroForceMaxHead = () => {
        const { fieldObj } = this.props;

        const bayWidthHorizontalSpan = Number(this.bayWidthHtalStiffSpan());
        const maxNumber = Number((this.returnMaxNumber() / 1000));
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;
        //
        //
        return checkForNull(((1010 * 9.81 * maxNumber * bayWidthHorizontalSpan) / (width / 1000)))
    }

    /**
    * @method returnHydroForceSeatingHead
    * @description Hydrostatic force due to seating head
    */
    returnHydroForceSeatingHead = () => {
        const { fieldObj } = this.props;

        const bayWidthHorizontalSpan = Number(this.bayWidthHtalStiffSpan());
        const maxNumber = Number((this.seatingWaterCalculation() / 1000));
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull(((1010 * 9.81 * maxNumber * bayWidthHorizontalSpan) / (width / 1000)))
    }

    /**
    * @method returnHydroForceUnseatingHead
    * @description Hydrostatic force due to unseating head
    */
    returnHydroForceUnseatingHead = () => {
        const { fieldObj } = this.props;

        const bayWidthHorizontalSpan = Number(this.bayWidthHtalStiffSpan());
        const maxNumber = Number((this.unseatingWaterCalculation() / 1000));
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull(((1010 * 9.81 * maxNumber * bayWidthHorizontalSpan) / (width / 1000)))
    }

    /**
    * @method returnBendingMomentMaxHead
    * @description Bending moment due to Maximum head
    */
    returnBendingMomentMaxHead = () => {
        const { fieldObj } = this.props;

        const hydroForceMaxHead = Number(this.returnHydroForceMaxHead());
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull(((hydroForceMaxHead * (Math.pow((width / 1000), 2))) / 8))
    }

    /**
    * @method returnBendingMomentSeatingHead
    * @description Bending moment due to Seating head
    */
    returnBendingMomentSeatingHead = () => {
        const { fieldObj } = this.props;

        const hydroForceSeatingHead = Number(this.returnHydroForceSeatingHead());
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull((hydroForceSeatingHead * (Math.pow((width / 1000), 2))) / 8)
    }

    /**
    * @method returnBendingMomentUnSeatingHead
    * @description Bending moment due to Unseating head
    */
    returnBendingMomentUnSeatingHead = () => {
        const { fieldObj } = this.props;

        const hydroForceUnSeatingHead = Number(this.returnHydroForceUnseatingHead());
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull(((hydroForceUnSeatingHead * (Math.pow((width / 1000), 2))) / 8))
    }

    /**
    * @method returnMaxTensileStress
    * @description Maximum Tensile Stress
    */
    returnMaxTensileStress = () => {
        const bendingMomentSeatingHead = Number(this.returnBendingMomentSeatingHead());
        const Z2 = checkForNull((this.HRStiffInertiaCalculation() / (this.HRStiffY2Calculation() / 1000)))
        //
        return checkForNull((bendingMomentSeatingHead / Z2))
    }

    /**
    * @method tensileStressDesignMessage
    * @description Tensile stress design message
    */
    tensileStressDesignMessage = () => {
        const MaxTensileStress = checkForNull(this.returnMaxTensileStress() / Math.pow(10, 6))
        // const PermissibleCompressiveStress = (referenceDocumentsObj.BendingStress * manufacturingMaterialObj.YS)
        const PermissibleCompressiveStress = shearstressObj
        if (PermissibleCompressiveStress > MaxTensileStress) {
            // isDesignSafe = true
            return 'The tensile stress is less than the permissible stress, Hence the design is safe.';
        } else {
            // isDesignSafe = false
            return <p className='error'>Design is unsafe. Please choose different values</p>;
        }
    }

    /**
    * @method returnMaxCompressiveStress
    * @description Maximum Compressive Stress
    */
    returnMaxCompressiveStress = () => {
        const bendingMomentSeatingHead = Number(this.returnBendingMomentSeatingHead());
        const Z1 = (this.HRStiffInertiaCalculation() / (this.HRStiffY1Calculation() / 1000))

        return checkForNull((bendingMomentSeatingHead / Z1))
    }

    /**
    * @method compressiveStressDesignMessage
    * @description Compressive stress design message
    */
    compressiveStressDesignMessage = () => {
        const MaxCompressiveStress = checkForNull(this.returnMaxCompressiveStress() / Math.pow(10, 6))
        // const PermissibleCompressiveStress = (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS)
        const PermissibleCompressiveStress = shearstressObj

        if (PermissibleCompressiveStress > MaxCompressiveStress) {
            // isDesignSafe = true
            return 'The compressive stress is less than the permissible stress, Hence the design is safe.';
        } else {
            // isDesignSafe = false
            return <p className='error'>Design is unsafe. Please choose different values</p>;
        }
    }

    /**
    * @method returnMaxTensileStressUnSeatHead
    * @description Maximum Tensile Stress Unseat head
    */
    returnMaxTensileStressUnSeatHead = () => {
        const bendingMomentUnSeatingHead = Number(this.returnBendingMomentUnSeatingHead());
        const Z1 = (this.HRStiffInertiaCalculation() / (this.HRStiffY1Calculation() / 1000))

        return checkForNull(bendingMomentUnSeatingHead / Z1)
    }

    /**
    * @method tensileStressUnseatHeadDesignMessage
    * @description Tensile stress unseat head design message
    */
    tensileStressUnseatHeadDesignMessage = () => {
        const MaxCompressiveStress = checkForNull(this.returnMaxTensileStressUnSeatHead() / Math.pow(10, 6))
        // const PermissibleCompressiveStress = (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS)
        const PermissibleCompressiveStress = shearstressObj

        if (PermissibleCompressiveStress > MaxCompressiveStress) {
            // isDesignSafe = true
            return 'The tensile stress is less than the permissible stress, Hence the design is safe.';
        } else {
            // isDesignSafe = false
            return <p className='error'>Design is unsafe. Please choose different values</p>;
        }
    }

    /**
    * @method returnMaxCompressiveStressUnseatedHead
    * @description Maximum Compressive Stress Unseat head
    */
    returnMaxCompressiveStressUnseatedHead = () => {
        const bendingMomentUnSeatingHead = Number(this.returnBendingMomentUnSeatingHead());
        const Z2 = (this.HRStiffInertiaCalculation() / (this.HRStiffY2Calculation() / 1000))

        return checkForNull((bendingMomentUnSeatingHead / Z2))
    }

    /**
    * @method compressiveStressUnseatHeadDesignMessage
    * @description Compressive stress unseat head design message
    */
    compressiveStressUnseatHeadDesignMessage = () => {
        const MaxCompressiveStress = checkForNull(this.returnMaxCompressiveStressUnseatedHead() / Math.pow(10, 6))
        // const PermissibleCompressiveStress = (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS)
        const PermissibleCompressiveStress = shearstressObj

        if (PermissibleCompressiveStress > MaxCompressiveStress) {
            // isDesignSafe = true
            return 'The compressive stress is less than the permissible stress, Hence the design is safe.';
        } else {
            // isDesignSafe = false
            return <p className='error'>Design is unsafe. Please choose different values</p>;
        }
    }

    /**
    * @method returnMaxShearForce
    * @description Maximum shear force
    */
    returnMaxShearForce = () => {
        const { fieldObj } = this.props;
        const hydroForceMaxHead = this.returnHydroForceMaxHead();
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull((hydroForceMaxHead * (width / 1000)) / 2)
    }

    // /**
    // * @method returnMaxShearStress
    // * @description Maximum shear stress
    // */
    // returnMaxShearStress = () => {
    //     const { fieldObj } = this.props;
    //     const MaxShearForce = this.returnMaxShearForce();
    //     const MinimumCoActingWidth = this.returnMinimumCoActingWidth();
    //     const HRt3 = fieldObj && fieldObj.HRt3 ? this.returnFieldInteger('HRt3') : 0;

    //     return checkForNull((1.5 * (MaxShearForce / (MinimumCoActingWidth * HRt3 / 1000000))));
    // }

    /**
    * @method returnMaxShearStress
    * @description Maximum shear stress
    */
    returnMaxShearStress = () => {
        const { fieldObj } = this.props;
        const MaxShearForce = this.returnMaxShearForce();
        const MinimumCoActingWidth = this.returnMinimumCoActingWidth();
        const HRt3 = fieldObj && fieldObj.HRt3 ? this.returnFieldInteger('HRt3') : 0;
        const HRd1 = fieldObj && fieldObj.HRd1 ? this.returnFieldInteger('HRd1') : 0;

        return checkForNull((1.5 * (MaxShearForce / (HRd1 * HRt3 / 1000000))));
    }


    /**
    * @method shearStressMaxHeadMessage
    * @description Shear stress max head message
    */
    shearStressMaxHeadMessage = () => {
        const { manufacturingMaterialObj } = this.state;

        const MaxShearStress = checkForNull(this.returnMaxShearStress() / Math.pow(10, 6))
        // const PermissibleShearStress = (referenceDocumentsObj.ShearStress * manufacturingMaterialObj.FSS)
        const PermissibleShearStress = this.shearStressCalc() * manufacturingMaterialObj.FSS

        if (PermissibleShearStress > MaxShearStress) {
            // isDesignSafe = true
            return 'The shear stress is less than the permissible stress, Hence the design is safe.';
        } else {
            // isDesignSafe = false
            return <p className='error'>Design is unsafe. Please choose different values</p>;
        }
    }

    /**
    * @method returnMaxDeflectionAtCentre
    * @description Maximum deflection at centre
    */
    returnMaxDeflectionAtCentre = () => {
        const { fieldObj } = this.props;

        //S167
        const hydroForceMaxHead = this.returnHydroForceMaxHead();
        //S13
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;
        //S151
        const momentOfInertia = this.HRStiffInertiaCalculation();
        return checkForNull((5 * hydroForceMaxHead * (Math.pow((width / 1000), 4))) / (384 * 2 * Math.pow(10, 11) * momentOfInertia))

    }

    /**
    * @method returnPermissibleDefTenderSpec
    * @description Permissible deflection as per tender sepcification
    */
    returnPermissibleDefTenderSpec = () => {
        const { fieldObj } = this.props;

        //S13
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;
        //S230
        const horizontalDeflection = fieldObj && fieldObj.horizontalDeflection ? this.returnFieldInteger('horizontalDeflection') : 0;

        return checkForNull((width / horizontalDeflection));


    }

    /**
    * @method actualDeflectionDesignMessage
    * @description Actual deflection design message
    */
    actualDeflectionDesignMessage = () => {

        const { fieldObj } = this.props;
        //S226
        const maxDeflectionAtCentre = this.returnMaxDeflectionAtCentre() * 1000;

        //S231
        const permissionDefTenderSpec = this.returnPermissibleDefTenderSpec();

        //S232 = 1.6

        //M21, M420 referenceDocuments

        // =IF(AND(S227<S232,S227<S233,M21=M421),

        if ((this.returnMaxDeflectionAtCentre() * 1000) < this.returnPermissibleDefTenderSpec() &&
            (this.returnMaxDeflectionAtCentre() * 1000) < 1.6 && Number(fieldObj.referenceDocuments) === 0) {
            return "The actual deflection is less than the permissible deflection, Hence the design is safe."
        }

        // ,IF(AND(S227<S232,S227<S233,M21=M422),
        else if ((this.returnMaxDeflectionAtCentre() * 1000) < this.returnPermissibleDefTenderSpec() &&
            (this.returnMaxDeflectionAtCentre() * 1000) < 1.6 &&
            Number(fieldObj.referenceDocuments) === 3) {
            return "The actual deflection is less than the permissible deflection, Hence the design is safe."
        }

        // IF(AND((this.returnMaxDeflectionAtCentre() * 1000)<this.returnPermissibleDefTenderSpec(),
        // currentSelectedReferenceDoc=3),
        // "The actual deflection is less than the permissible deflection, Hence the design is safe.",

        else if ((this.returnMaxDeflectionAtCentre() * 1000) < this.returnPermissibleDefTenderSpec() &&
            Number(fieldObj.referenceDocuments) === 1) {
            return "The actual deflection is less than the permissible deflection, Hence the design is safe."
        }

        // IF(AND(S227<S232,M21=M424),
        else if ((this.returnMaxDeflectionAtCentre() * 1000) < this.returnPermissibleDefTenderSpec() &&
            Number(fieldObj.referenceDocuments) === 2) {
            return "The actual deflection is less than the permissible deflection, Hence the design is safe."
        }

        // "Design is unsafe. Please choose different values."))))
        else {
            return <p className='error'>Design is unsafe. Please choose different values.</p>;
        }


        // // AND(S227<S232,S227<S233,M21=M421
        // if (maxDeflectionAtCentre < permissionDefTenderSpec && maxDeflectionAtCentre < 1.6 &&
        //     fieldObj.referenceDocuments == 0) {
        //     // isDesignSafe = true
        //     return 'The actual deflection is less than the permissible deflection, Hence the design is safe.';
        // } else if (maxDeflectionAtCentre < permissionDefTenderSpec && maxDeflectionAtCentre < 1.6 &&
        //     fieldObj.referenceDocuments == 3) {
        //     // isDesignSafe = true
        //     return 'The actual deflection is less than the permissible deflection, Hence the design is safe.';
        // } else if (maxDeflectionAtCentre < permissionDefTenderSpec &&
        //     fieldObj.referenceDocuments == 1) {
        //     // isDesignSafe = true
        //     return 'The actual deflection is less than the permissible deflection, Hence the design is safe.';
        // } else if (maxDeflectionAtCentre < permissionDefTenderSpec &&
        //     fieldObj.referenceDocuments == 2) {
        //     // isDesignSafe = true
        //     return 'The actual deflection is less than the permissible deflection, Hence the design is safe.';
        // } else {
        //     // isDesignSafe = false
        //     return <p className='error'>Design is unsafe. Please choose different values</p>;
        // }
    }


    /**
    * @method handleVerticalStiffeners
    * @description Vertical Stiffeners Section
    */
    handleVerticalStiffeners = (e) => {

        let t1 = this.returnFieldInteger('VRt1');
        let d = this.returnFieldInteger('VRd');

        const value = e.target.value;
        let tempObj = {};

        if (value === 'A') {
            this.props.change('VRd1', d - t1)
            tempObj = VerticalStiffiners.A;
        } else if (value === 'B') {
            this.props.change('VRd1', d)
            tempObj = VerticalStiffiners.B;
        } else if (value === 'C') {
            this.props.change('VRd1', d - 2 * t1)
            tempObj = VerticalStiffiners.C;
        } else if (value === 'D') {
            this.props.change('VRd1', d - 2 * t1)
            tempObj = VerticalStiffiners.D;
        } else if (value === 'E') {
            this.props.change('VRd1', d - t1)
            tempObj = VerticalStiffiners.E;
        }

        this.setState({
            selectedVerticalStiff: value,
            verticalStiffenersSectionObj: tempObj
        })
    };

    /**
    * @method vrb1AlertMsg
    * @description Vertical stiff b1 alert msg according to selected section
    */
    vrb1AlertMsg = () => {
        const { selectedVerticalStiff } = this.state;

        if ((selectedVerticalStiff === 'A' || selectedVerticalStiff === 'C' || selectedVerticalStiff === 'D' || selectedVerticalStiff === 'E') && Number(this.returnFieldInteger('VRb1')) === 0) {
            return 'Warning either put the value of b1 or change the section';
        } else if (selectedVerticalStiff === 'B' && Number(this.returnFieldInteger('VRb1')) === 0) {
            return '';
        } else if (selectedVerticalStiff === 'B' && Number(this.returnFieldInteger('VRb1')) !== 0) {
            return 'Warning either put the value of b1 or change the section';
        } else {
            return '';
        }
    }

    /**
    * @method vrt1AlertMsg
    * @description Vertical stiff t1 alert msg according to selected section
    */
    vrt1AlertMsg = () => {
        const { selectedVerticalStiff } = this.state;

        if ((selectedVerticalStiff === 'A' || selectedVerticalStiff === 'C' || selectedVerticalStiff === 'D' || selectedVerticalStiff === 'E') && Number(this.returnFieldInteger('VRt1')) === 0) {
            return 'Warning either put the value of t1 or change the section';
        } else if (selectedVerticalStiff === 'B' && Number(this.returnFieldInteger('VRt1')) === 0) {
            return '';
        } else if (selectedVerticalStiff === 'B' && Number(this.returnFieldInteger('VRt1')) !== 0) {
            return 'Warning either put the value of t1 or change the section';
        } else {
            return '';
        }
    }

    /**
    * @method returnVerticalCoActingWidthB1
    * @description Vertical Co acting width B1
    */
    returnVerticalCoActingWidthB1 = () => {
        const { fieldObj } = this.props;

        return fieldObj ? checkForNull((((40 * this.returnFieldInteger('skinPlateThickness')) + this.returnFieldInteger('VRt3')))) : 0;
    }

    /**
    * @method returnVerticalCoActingWidthB2
    * @description Vertical Co acting width B2
    */
    returnVerticalCoActingWidthB2 = () => {
        return this.bayWidthHorizontalStif() * 0.11;
    }

    /**
    * @method returnVerticalMinimumCoActingWidth
    * @description Return Vertical Co acting minimum width
    */
    returnVerticalMinimumCoActingWidth = () => {
        const coActingB1 = this.returnVerticalCoActingWidthB1();
        const coActingB2 = this.returnVerticalCoActingWidthB2();
        const bayWidthVertical = this.bayWidthVerticalStif();

        return checkForNull((Math.min(coActingB1, coActingB2, bayWidthVertical)));
    }

    /**
    * @method bayWidthVtalStiffSpan
    * @description Bay width of Vertical stiffiners span
    */
    bayWidthVtalStiffSpan = () => {
        const { fieldObj } = this.props;
        const bayWidthVertical = this.bayWidthVerticalStif();
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull(((bayWidthVertical / 1000) * (this.bayWidthHorizontalStif() / 1000)))
    }

    /**
    * @method returnVerticalHydroForceMaxHead
    * @description Vertical Hydrostatic force due to max head
    */
    returnVerticalHydroForceMaxHead = () => {
        const bayWidthVerticalSpan = Number(this.bayWidthVtalStiffSpan());
        const maxNumber = Number((this.returnMaxNumber() / 1000));
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        return checkForNull(((1010 * 9.81 * maxNumber * bayWidthVerticalSpan) / (CenterToCenterWidthHorizontalStif / 1000)))
    }

    /**
    * @method returnVerticalHydroForceSeatingHead
    * @description Vertical Hydrostatic force due to seating head
    */
    returnVerticalHydroForceSeatingHead = () => {

        const bayWidthVerticalSpan = Number(this.bayWidthVtalStiffSpan());
        const maxNumber = Number((this.seatingWaterCalculation() / 1000));
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        return checkForNull(((1010 * 9.81 * maxNumber * bayWidthVerticalSpan) / (CenterToCenterWidthHorizontalStif / 1000)))
    }

    /**
    * @method returnHydroForceUnseatingHead
    * @description Vertical Hydrostatic force due to unseating head
    */
    returnVerticalHydroForceUnseatingHead = () => {

        const bayWidthVtalStiffSpan = Number(this.bayWidthVtalStiffSpan());
        const maxNumber = Number((this.unseatingWaterCalculation() / 1000));
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        return checkForNull(((1010 * 9.81 * maxNumber * bayWidthVtalStiffSpan) / (CenterToCenterWidthHorizontalStif / 1000)))
    }

    /**
    * @method returnVerticalBendingMomentMaxHead
    * @description Vertical Bending moment due to Maximum head
    */
    returnVerticalBendingMomentMaxHead = () => {
        const verticalHydroForceMaxHead = Number(this.returnVerticalHydroForceMaxHead());
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        return checkForNull(((verticalHydroForceMaxHead * (Math.pow((CenterToCenterWidthHorizontalStif / 1000), 2))) / 12))
    }

    /**
    * @method returnVerticalBendingMomentSeatingHead
    * @description Vertical Bending moment due to Seating head
    */
    returnVerticalBendingMomentSeatingHead = () => {
        const verticalHydroForceSeatingHead = Number(this.returnVerticalHydroForceSeatingHead());
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        return checkForNull(((verticalHydroForceSeatingHead * (Math.pow((CenterToCenterWidthHorizontalStif / 1000), 2))) / 12))
    }

    /**
    * @method returnVerticalBendingMomentUnSeatingHead
    * @description Bending moment due to Unseating head
    */
    returnVerticalBendingMomentUnSeatingHead = () => {
        const verticalHydroForceUnSeatingHead = Number(this.returnVerticalHydroForceUnseatingHead());
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        return checkForNull(((verticalHydroForceUnSeatingHead * (Math.pow((CenterToCenterWidthHorizontalStif / 1000), 2))) / 12))
    }

    /**
    * @method returnVerticalMaxTensileStress
    * @description Vertical Maximum Tensile Stress
    */
    returnVerticalMaxTensileStress = () => {
        const verticalBendingMomentSeatingHead = Number(this.returnVerticalBendingMomentSeatingHead());
        const Z2 = (this.VRStiffInertiaCalculation() / (this.VRStiffY2Calculation() / 1000))

        return checkForNull((verticalBendingMomentSeatingHead / Z2))
    }

    /**
    * @method verticalTensileStressDesignMessage
    * @description Vertical Tensile stress design message
    */
    verticalTensileStressDesignMessage = () => {
        const verticalMaxTensileStress = checkForNull(this.returnVerticalMaxTensileStress() / Math.pow(10, 6))
        // const PermissibleCompressiveStress = (referenceDocumentsObj.BendingStress * manufacturingMaterialObj.YS)
        const PermissibleCompressiveStress = shearstressObj

        if (PermissibleCompressiveStress > verticalMaxTensileStress) {
            // isDesignSafe = true
            return 'The tensile stress is less than the permissible stress, Hence the design is safe.';
        } else {
            // isDesignSafe = false
            return <p className='error'>Design is unsafe. Please choose different values</p>;
        }
    }

    /**
    * @method returnVerticalMaxCompressiveStress
    * @description Vertical Maximum Compressive Stress
    */
    returnVerticalMaxCompressiveStress = () => {
        const verticalBendingMomentSeatingHead = Number(this.returnVerticalBendingMomentSeatingHead());
        const Z1 = (this.VRStiffInertiaCalculation() / (this.VRStiffY1Calculation() / 1000))

        return checkForNull((verticalBendingMomentSeatingHead / Z1))
    }

    /**
    * @method verticalCompressiveStressDesignMessage
    * @description Vertical Compressive stress design message
    */
    verticalCompressiveStressDesignMessage = () => {
        const verticalMaxCompressiveStress = checkForNull(this.returnVerticalMaxCompressiveStress() / Math.pow(10, 6))
        // const PermissibleCompressiveStress = (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS)
        const PermissibleCompressiveStress = shearstressObj

        if (PermissibleCompressiveStress > verticalMaxCompressiveStress) {
            // isDesignSafe = true
            return 'The compressive stress is less than the permissible stress, Hence the design is safe.';
        } else {
            // isDesignSafe = false
            return <p className='error'>Design is unsafe. Please choose different values</p>;
        }
    }

    /**
    * @method returnVerticalMaxTensileStressUnSeatHead
    * @description Vertical Maximum Tensile Stress Unseat head
    */
    returnVerticalMaxTensileStressUnSeatHead = () => {
        const verticalBendingMomentUnSeatingHead = Number(this.returnVerticalBendingMomentUnSeatingHead());
        const Z1 = (this.VRStiffInertiaCalculation() / (this.VRStiffY1Calculation() / 1000))

        return checkForNull((verticalBendingMomentUnSeatingHead / Z1))
    }

    /**
    * @method verticalTensileStressUnseatHeadDesignMessage
    * @description Vertical Tensile stress unseat head design message
    */
    verticalTensileStressUnseatHeadDesignMessage = () => {
        const VerticalMaxCompressiveStress = checkForNull(this.returnVerticalMaxTensileStressUnSeatHead() / Math.pow(10, 6))
        // const PermissibleCompressiveStress = (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS)
        const PermissibleCompressiveStress = shearstressObj

        if (PermissibleCompressiveStress > VerticalMaxCompressiveStress) {
            // isDesignSafe = true
            return 'The tensile stress is less than the permissible stress, Hence the design is safe.';
        } else {
            // isDesignSafe = false
            return <p className='error'>Design is unsafe. Please choose different values</p>;
        }
    }

    /**
    * @method returnVerticalMaxCompressiveStressUnseatedHead
    * @description Vertical Maximum Compressive Stress Unseat head
    */
    returnVerticalMaxCompressiveStressUnseatedHead = () => {
        const verticalBendingMomentUnSeatingHead = Number(this.returnVerticalBendingMomentUnSeatingHead());
        const Z2 = (this.VRStiffInertiaCalculation() / (this.VRStiffY2Calculation() / 1000))

        return checkForNull((verticalBendingMomentUnSeatingHead / Z2))
    }

    /**
    * @method verticalCompressiveStressUnseatHeadDesignMessage
    * @description Vertical Compressive stress unseat head design message
    */
    verticalCompressiveStressUnseatHeadDesignMessage = () => {
        const VerticalMaxCompressiveStress = checkForNull(this.returnVerticalMaxCompressiveStressUnseatedHead() / Math.pow(10, 6))
        // const PermissibleCompressiveStress = (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS)
        const PermissibleCompressiveStress = shearstressObj

        if (PermissibleCompressiveStress > VerticalMaxCompressiveStress) {
            // isDesignSafe = true
            return 'The compressive stress is less than the permissible stress, Hence the design is safe.';
        } else {
            // isDesignSafe = false
            return <p className='error'>Design is unsafe. Please choose different values</p>;
        }
    }

    /**
    * @method returnVerticalMaxShearForce
    * @description Vertical Maximum shear force
    */
    returnVerticalMaxShearForce = () => {
        const hydroForceMaxHead = this.returnVerticalHydroForceMaxHead();
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())
        return checkForNull(((hydroForceMaxHead * (CenterToCenterWidthHorizontalStif / 1000)) / 2))
    }

    /**
    * @method returnVerticalMaxShearStress
    * @description Vertical Maximum shear stress
    */
    returnVerticalMaxShearStress = () => {
        const { fieldObj } = this.props;
        const { verticalStiffenersSectionObj } = this.state

        const MaxShearForce = this.returnVerticalMaxShearForce();
        const MinimumCoActingWidth = this.returnVerticalMinimumCoActingWidth();
        const VRt3 = fieldObj && fieldObj.VRt3 ? this.returnFieldInteger('VRt3') : 0;

        return checkForNull((1.5 * (MaxShearForce / (this.returnFieldInteger('VRd1') * VRt3 / 1000000))));
    }

    /**
    * @method verticalShearStressMaxHeadMessage
    * @description Vertical Shear stress max head message
    */
    verticalShearStressMaxHeadMessage = () => {
        const { manufacturingMaterialObj } = this.state;

        const MaxShearStress = checkForNull(this.returnVerticalMaxShearStress() / Math.pow(10, 6))
        // const PermissibleShearStress = (referenceDocumentsObj.ShearStress * manufacturingMaterialObj.FSS)
        const PermissibleShearStress = this.shearStressCalc() * manufacturingMaterialObj.FSS

        if (PermissibleShearStress > MaxShearStress) {
            // isDesignSafe = true
            return 'The shear stress is less than the permissible stress, Hence the design is safe.';
        } else {
            // isDesignSafe = false
            return <p className='error'>Design is unsafe. Please choose different values</p>;
        }
    }

    /**
    * @method returnVerticalMaxDeflectionAtCentre
    * @description Vertical Maximum deflection at centre
    */
    returnVerticalMaxDeflectionAtCentre = () => {
        //S167
        const hydroForceMaxHead = this.returnVerticalHydroForceMaxHead();

        //S13
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        //S151
        const momentOfInertia = this.VRStiffInertiaCalculation();

        return checkForNull((hydroForceMaxHead * (Math.pow((CenterToCenterWidthHorizontalStif) / 1000, 4) / (384 * 2 * Math.pow(10, 11) * momentOfInertia))))
    }

    /**
    * @method returnVerticalPermissibleDefTenderSpec
    * @description Vertical Permissible deflection as per tender sepcification
    */
    returnVerticalPermissibleDefTenderSpec = () => {
        const { fieldObj } = this.props;

        //S14
        const height = fieldObj && fieldObj.height ? this.returnFieldInteger('height') + 80 : 0;

        //S357
        const verticalDeflection = fieldObj && fieldObj.verticalDeflection ? this.returnFieldInteger('verticalDeflection') : 0;

        return checkForNull((height / verticalDeflection));

    }

    /**
    * @method actualVerticalDeflectionDesignMessage
    * @description Actual Vertical deflection design message
    */
    actualVerticalDeflectionDesignMessage = () => {
        const { fieldObj } = this.props;
        //S226
        const maxDeflectionAtCentre = this.returnVerticalMaxDeflectionAtCentre() * 1000;

        //S231
        const permissionDefTenderSpec = this.returnVerticalPermissibleDefTenderSpec();

        //S232 = 1.6
        //M21, M420 referenceDocuments

        // =IF(AND(S354<S359,S354<S360,M21=M421),      //0312
        if ((this.returnVerticalMaxDeflectionAtCentre() * 1000) < this.returnVerticalPermissibleDefTenderSpec() &&
            (this.returnVerticalMaxDeflectionAtCentre() * 1000) < 1.6 && Number(fieldObj.referenceDocuments) === 0) {
            return "The actual deflection is less than the permissible deflection, Hence the design is safe."
        }

        // IF(AND(S354<S359,S354<S360,M21=M422),
        else if ((this.returnVerticalMaxDeflectionAtCentre() * 1000) < this.returnVerticalPermissibleDefTenderSpec() &&
            (this.returnVerticalMaxDeflectionAtCentre() * 1000) < 1.6 && Number(fieldObj.referenceDocuments) === 3) {
            return "The actual deflection is less than the permissible deflection, Hence the design is safe."
        }

        // IF(AND(S354<S359,M21=M423),
        else if ((this.returnVerticalMaxDeflectionAtCentre() * 1000) < this.returnVerticalPermissibleDefTenderSpec() &&
            Number(fieldObj.referenceDocuments) === 1) {
            return "The actual deflection is less than the permissible deflection, Hence the design is safe."
        }

        // IF(AND(S354<S359,M21=M424),
        else if ((this.returnVerticalMaxDeflectionAtCentre() * 1000) < this.returnVerticalPermissibleDefTenderSpec() &&
            Number(fieldObj.referenceDocuments) === 2) {
            return "The actual deflection is less than the permissible deflection, Hence the design is safe."
        }

        else {
            // isDesignSafe = false
            return <p className='error'>Design is unsafe. Please choose different values.</p>;
        }



        // if (maxDeflectionAtCentre < permissionDefTenderSpec &&
        //     maxDeflectionAtCentre < 1.6 &&
        //     fieldObj.referenceDocuments == 0) {
        //     // isDesignSafe = true
        //     return 'The actual deflection is less than the permissible deflection, Hence the design is safe.';
        // } else if (maxDeflectionAtCentre < permissionDefTenderSpec &&
        //     fieldObj.referenceDocuments == 1) {
        //     // isDesignSafe = true
        //     return 'The actual deflection is less than the permissible deflection, Hence the design is safe.';
        // } else if (maxDeflectionAtCentre < permissionDefTenderSpec &&
        //     fieldObj.referenceDocuments == 2) {
        //     // isDesignSafe = true
        //     return 'The actual deflection is less than the permissible deflection, Hence the design is safe.';
        // } else if (maxDeflectionAtCentre < permissionDefTenderSpec &&
        //     maxDeflectionAtCentre < 1.6 &&
        //     fieldObj.referenceDocuments == 3) {
        //     // isDesignSafe = true
        //     return "The actual deflection is less than the permissible deflection, Hence the design is safe.";
        // } else {
        //     // isDesignSafe = false
        //     return <p className='error'>Design is unsafe. Please choose different values</p>;
        // }
    }

    /**
    * @method horizontalRibsHeight
    * @description Horizontal Ribs height
    */
    horizontalRibsHeight = () => {
        const { selectedHorizontalStiff } = this.state;
        let hrRibsHeight = '';

        if (selectedHorizontalStiff === 'A') {
            hrRibsHeight = this.returnFieldInteger('HRb1') + this.returnFieldInteger('HRd1');
        } else if (selectedHorizontalStiff === 'B') {
            hrRibsHeight = this.returnFieldInteger('HRd1');
        } else if (selectedHorizontalStiff === 'C') {
            hrRibsHeight = 2 * this.returnFieldInteger('HRb1') + this.returnFieldInteger('HRd1');
        } else if (selectedHorizontalStiff === 'D') {
            hrRibsHeight = 2 * this.returnFieldInteger('HRb1') + this.returnFieldInteger('HRd1');
        } else if (selectedHorizontalStiff === 'E') {
            // hrRibsHeight = this.returnFieldInteger('HRd') + this.returnFieldInteger('HRd1');
            hrRibsHeight = this.returnFieldInteger('HRb1') + this.returnFieldInteger('HRd1')



        } else {
            hrRibsHeight = 0;
        }

        return hrRibsHeight;
    }

    /**
    * @method handleSeriesOffered
    * @description Handle offered series
    */
    handleSeriesOffered = (e) => {
        const value = e.target.value;

        this.setState({ selectedSeriesOffered: value, frameExtension: '', })

        if (value === 'A-101- FLAT BACK FRAME DESIGN' || value === 'A-102- SECTIONAL FRAME DESIGN'
            || value === 'A-103- INTEGRAL FRAME DESIGN' || value === 'A-104- UNIVERSAL FRAME DESIGN' ||
            value === 'A-201-202-203 CAST IRON OPEN CHANNEL' || value === 'A-301 CAST IRON WEIR GATE') {
            this.setState({ isSeriesOfferedCI: true }, () => { this.setApplicabilityStandard(value) })
        } else {
            this.setState({ isSeriesOfferedCI: false }, () => this.setApplicabilityStandard(value))
        }
        this.setFramelength(value);
        this.setFrameExtensionArray(value);
        // this.getShutterData()
    }

    /**
    * @method handleActuation
    * @description Handle Actuation
    */
    handleActuation = (e) => {
        const value = e.target.value;
        this.setState({ activeActuation: value })
        this.props.ActuationToggler(value)
    }

    /**
    * @method handleClosureType
    * @description Handle Closure Type
    */
    handleClosureType = (e) => {
        const value = e.target.value;

    }

    /**
    * @method verticalRibsHeight
    * @description Vertical Ribs height
    */
    verticalRibsHeight = () => {
        const { selectedVerticalStiff } = this.state;
        let vrRibsHeight = '';

        if (selectedVerticalStiff === 'A') {
            vrRibsHeight = this.returnFieldInteger('VRb1') + this.returnFieldInteger('VRd1');
        } else if (selectedVerticalStiff === 'B') {
            vrRibsHeight = this.returnFieldInteger('VRd1');
        } else if (selectedVerticalStiff === 'C') {
            vrRibsHeight = 2 * this.returnFieldInteger('VRb1') + this.returnFieldInteger('VRd1');
        } else if (selectedVerticalStiff === 'D') {
            vrRibsHeight = 2 * this.returnFieldInteger('VRb1') + this.returnFieldInteger('VRd1');
        } else if (selectedVerticalStiff === 'E') {
            vrRibsHeight = this.returnFieldInteger('VRd') + this.returnFieldInteger('VRd1');
        } else {
            vrRibsHeight = 0;
        }

        return vrRibsHeight;
    }

    handleApplicableStandardSelect = (e) => {
        const value = e.target.value;
        this.setState({ selectedApplicableStandard: value })
    }

    isUniqueNumberChanged = () => {
        const { fieldObj } = this.props;
        const { item_number, pid_number, quote_number } = this.state.identifier





        if (String(item_number) === String(fieldObj.ItemNumber) && String(pid_number) === String(fieldObj.pid_number) && String(quote_number) === String(fieldObj.quote_number)) {
            return true
        } else {
            return false
        }
    }

    /**
    * @method shutterDesignConfirmation
    * @description Shutter confirmation after save for Edit and Create Copy
    */
    shutterDesignConfirmation = (values) => {
        const toasterBody = (
            <Form >
                <FormGroup tag="fieldset">
                    {/* <legend>Radio Buttons</legend> */}
                    {!this.state.isPostOrderCreated && <FormGroup check>
                        <Label check>
                            <Input type="radio" name="radio1" onChange={(e) => this.setState({ copyCosting: false, isPostOrder: false })} />{' '}
                            Save to existing costing.
                        </Label>
                    </FormGroup>
                    }

                    <FormGroup check>
                        <Label check>
                            <Input type="radio" name="radio1" onChange={(e) => this.setState({ copyCosting: true, isPostOrder: false })} />{' '}
                            Save as new costing.
                        </Label>
                    </FormGroup>
                    {
                        this.isUniqueNumberChanged() && !this.state.isPostOrderCreated &&
                        <FormGroup check disabled>
                            <Label check>
                                <Input type="radio" name="radio1" onChange={(e) => this.setState({ isPostOrder: true, copyCosting: false })} />{' '}
                                Post Order
                            </Label>
                        </FormGroup>
                    }
                </FormGroup>

            </Form>
        )
        const toastrConfirmOptions = {
            onOk: (values) => {
                this.confirmCreate(values)
            },
            // onCancel: (values) => {
            //     this.confirmEdit(values)
            // },
            okText: 'Save',
            // cancelText: 'No'
        };
        // return toastr.confirm(`${MESSAGES.CREATE_COPY_ALERT}`, toastrConfirmOptions);
        return toastr.confirm(toasterBody, toastrConfirmOptions);
    }

    // continueEditingConfirmation = () => {
    //     const toastrBody = ``
    //     const toastrConfirmOptions = {
    //         onOk: (values) => {

    //         },
    //         // onCancel: (values) => {
    //         //     this.props.toggle('1')
    //         // },
    //         okText: 'Okay',
    //         // cancelText: 'Cancel'
    //     };
    //     // return toastr.confirm(`${MESSAGES.CREATE_COPY_ALERT}`, toastrConfirmOptions);
    //     return toastr.confirm(toastrBody, toastrConfirmOptions);
    // }

    /**
    * @method confirmCreate
    * @description Create the copy of existing shutter design's
    */
    confirmCreate = (values) => {
        this.shutterDesignHandler(values, this.state.copyCosting)
    }

    // /**
    // * @method confirmEdit
    // * @description Edit existing shutter design 
    // */
    // confirmEdit = (values) => {
    //     this.shutterDesignHandler(values, false)
    // }

    handleHeightOnchange = (e) => {
        const h = parseInt(e.target.value);
        const cl_pl = 3.084576 - h / 2000
        return this.setState({ clPlValue: cl_pl })
    }

    /**
    * Submit the login form
    * @param values
    */
    onSubmit(values) {
        const { selectedSeriesOffered, cisDataVal } = this.state
        const { fieldObj, isEditFlag, shutterDesignCreated, } = this.props;
        if (this.state.selectedSeriesOffered === 'A-111' || this.state.selectedSeriesOffered === 'A-112') {
            if ((!validValues.includes(Number(fieldObj.width)) || !validValues.includes(Number(fieldObj.height))) || Number(fieldObj.width) !== Number(fieldObj.height)) {
                // Handle the case where fieldObj.width or fieldObj.height is not a valid value or they are not the same
                toastr.warning('Please provide the width and height for gate series A-111 and A-112 as per the relevant standards');
                return false;
            }
        }
        this.calculate()
        const { referenceDocumentsObj, manufacturingMaterialObj } = this.state;
        const PermissibleCompressiveStress = (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS)
        const maxDeflectionAtCentre = this.returnVerticalMaxDeflectionAtCentre() * 1000
        const permissibleBendingStress = (referenceDocumentsObj.BendingStress * manufacturingMaterialObj.YS).toFixed(2)
        const bendingStressInPlate = this.calculateSkinPlateBendingStress()
        const PermissibleShearStress = (referenceDocumentsObj.ShearStress * manufacturingMaterialObj.FSS)
        const MaxTensileStress = checkForNull(this.returnMaxTensileStress() / Math.pow(10, 6))
        const MaxCompressiveStress = checkForNull(this.returnMaxCompressiveStressUnseatedHead() / Math.pow(10, 6))
        const MaxShearStress = checkForNull(this.returnVerticalMaxShearStress() / Math.pow(10, 6))
        const verticalMaxTensileStress = checkForNull(this.returnVerticalMaxTensileStress() / Math.pow(10, 6))
        const verticalMaxCompressiveStress = checkForNull(this.returnVerticalMaxCompressiveStress() / Math.pow(10, 6))
        const VerticalMaxCompressiveStress = checkForNull(this.returnVerticalMaxCompressiveStressUnseatedHead() / Math.pow(10, 6))
        if ((selectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN' || selectedSeriesOffered === 'A-102- SECTIONAL FRAME DESIGN'
            || selectedSeriesOffered === 'A-103- INTEGRAL FRAME DESIGN' || selectedSeriesOffered === 'A-104- UNIVERSAL FRAME DESIGN' ||
            selectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' || selectedSeriesOffered === 'A-301 CAST IRON WEIR GATE')) {
            if (cisDataVal.CastIronSafeCheck) {
                if (isEditFlag || shutterDesignCreated) {
                    this.shutterDesignConfirmation(values);
                    return false;
                }

                // Create new Shutter Design 
                // Create Copy of existing
                // Conditionally Edit existing Shutter design 
                this.shutterDesignHandler(values, true)
            } else {
                toastr.warning('Your design is unsafe, Please check all the values once again.')
            }
        } else {
            if (
                (this.state.selectedSeriesOffered === 'A-111' || this.state.selectedSeriesOffered === 'A-112') ||
                (permissibleBendingStress > bendingStressInPlate &&
                    PermissibleCompressiveStress > MaxTensileStress &&
                    PermissibleCompressiveStress > MaxCompressiveStress &&
                    PermissibleCompressiveStress > MaxCompressiveStress &&
                    PermissibleCompressiveStress > MaxCompressiveStress &&
                    PermissibleShearStress > MaxShearStress &&
                    PermissibleCompressiveStress > verticalMaxTensileStress &&
                    PermissibleCompressiveStress > verticalMaxCompressiveStress &&
                    PermissibleCompressiveStress > VerticalMaxCompressiveStress &&
                    PermissibleShearStress > MaxShearStress &&
                    ((maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                        maxDeflectionAtCentre < 1.6 &&
                        Number(fieldObj.referenceDocuments) === 0) ||
                        (maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                            maxDeflectionAtCentre < 1.6 &&
                            Number(fieldObj.referenceDocuments) === 3) ||
                        (maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                            Number(fieldObj.referenceDocuments) === 1) ||
                        (maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                            Number(fieldObj.referenceDocuments) === 2)
                    )
                    &&
                    ((maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                        maxDeflectionAtCentre < 1.6 &&
                        Number(fieldObj.referenceDocuments) === 0) ||
                        (maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                            Number(fieldObj.referenceDocuments) === 1) ||
                        (maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                            Number(fieldObj.referenceDocuments) === 2) ||
                        (maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                            maxDeflectionAtCentre < 1.6 &&
                            Number(fieldObj.referenceDocuments) === 3)
                    )) || this.state.isSeriesOfferedCI
            ) {
                if (isEditFlag || shutterDesignCreated) {
                    this.shutterDesignConfirmation(values);
                    return false;
                }
                // Create new Shutter Design 
                // Create Copy of existing
                // Conditionally Edit existing Shutter design 
                this.shutterDesignHandler(values, true)
            } else {
                toastr.warning('Your design is unsafe, Please check all the values once again.')
            }
        }
    }

    shutterDesignHandler = (values, isCopyCosting) => {
        const { stemDiaField, selectHorizontalRib, manufacturingMaterial, hs1, hs2, hs3, hs4, hs5, hs6, hs7,
            hs8, hs9, hs10, hs11, hs12, hs13, hs14, hs15, factorOfSafetyDD, horizontalStiffenersSection, FOSValue } = this.state.cisDataVal
        this.setState({ isLoader: true })
        const { fieldObj, isEditFlag, ShutterId, shutterDesignCreated } = this.props;
        const { selectedSeriesOffered, currentSelectedReferenceDoc } = this.state;
        const { referenceDocumentsObj, manufacturingMaterialObj,
            horizontalStiffenersSectionObj, verticalStiffenersSectionObj, } = this.state;

        let refDocsId = '';
        if (Number(currentSelectedReferenceDoc) === 0) {
            refDocsId = referenceDocsOption[0].Text;
        } else if (Number(currentSelectedReferenceDoc) === 1) {
            refDocsId = referenceDocsOption[1].Text;
        } else if (Number(currentSelectedReferenceDoc) === 2) {
            refDocsId = referenceDocsOption[2].Text;
        } else {
            refDocsId = referenceDocsOption[3].Text;
        }

        let MaterialTypeId = '';
        if (String(manufacturingMaterialOption && manufacturingMaterialOption[0].Value) === String(fieldObj.manufacturingMaterial)) {
            MaterialTypeId = manufacturingMaterialOption[0].Text;
        } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[1].Value) === String(fieldObj.manufacturingMaterial)) {
            MaterialTypeId = manufacturingMaterialOption[1].Text;
        } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[2].Value) === String(fieldObj.manufacturingMaterial)) {
            MaterialTypeId = manufacturingMaterialOption[2].Text;
        } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[3].Value) === String(fieldObj.manufacturingMaterial)) {
            MaterialTypeId = manufacturingMaterialOption[3].Text;
        } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[4].Value) === String(fieldObj.manufacturingMaterial)) {
            MaterialTypeId = manufacturingMaterialOption[4].Text;
        } else {
            MaterialTypeId = manufacturingMaterialOption[5].Text;
        }

        let MaterialTypeCI = '';
        if (String(manufacturingMaterialOptionCI && manufacturingMaterialOptionCI[0].Value) === String(manufacturingMaterial)) {
            MaterialTypeCI = manufacturingMaterialOptionCI[0].Text;
        } else if (String(manufacturingMaterialOptionCI && manufacturingMaterialOptionCI[1].Value) === String(manufacturingMaterial)) {
            MaterialTypeCI = manufacturingMaterialOptionCI[1].Text;
        } else if (String(manufacturingMaterialOptionCI && manufacturingMaterialOptionCI[2].Value) === String(manufacturingMaterial)) {
            MaterialTypeCI = manufacturingMaterialOptionCI[2].Text;
        } else if (String(manufacturingMaterialOptionCI && manufacturingMaterialOptionCI[3].Value) === String(manufacturingMaterial)) {
            MaterialTypeCI = manufacturingMaterialOptionCI[3].Text;
        } else if (String(manufacturingMaterialOptionCI && manufacturingMaterialOptionCI[4].Value) === String(manufacturingMaterial)) {
            MaterialTypeCI = manufacturingMaterialOptionCI[4].Text;
        } else if (String(manufacturingMaterialOptionCI && manufacturingMaterialOptionCI[5].Value) === String(manufacturingMaterial)) {
            MaterialTypeCI = manufacturingMaterialOptionCI[5].Text;
        } else if (String(manufacturingMaterialOptionCI && manufacturingMaterialOptionCI[6].Value) === String(manufacturingMaterial)) {
            MaterialTypeCI = manufacturingMaterialOptionCI[6].Text;
        } else {
            MaterialTypeCI = manufacturingMaterialOptionCI[7].Text;
        }

        let shaftSpindle = '';
        if (String(sharftSpindleOption && sharftSpindleOption[0].Value) === String(fieldObj.shaftSpindle)) {
            shaftSpindle = sharftSpindleOption[0].Text;
        } else if (String(sharftSpindleOption && sharftSpindleOption[1].Value) === String(fieldObj.shaftSpindle)) {
            shaftSpindle = sharftSpindleOption[1].Text;
        }

        let ClosureType = '';
        if (String(ClosureOption && ClosureOption[0].Value) === String(fieldObj.ClosureType)) {
            ClosureType = ClosureOption[0].Text;
        } else if (String(ClosureOption && ClosureOption[1].Value) === String(fieldObj.ClosureType)) {
            ClosureType = ClosureOption[1].Text;
        }

        let ActiveTab = (fieldObj.Actuation === 'MANUAL') ? '3' : '4';
        const horizontalRibsHeight = this.horizontalRibsHeight();
        const verticalRibsHeight = this.verticalRibsHeight();
        let shutterData = {}


        const factorOfSafetyOp = (this.state.isSeriesOfferedCI) ? factorOfSafetyDD : this.state.factorOfSafetyDD
        const SelectedManufacturingMaterial = (this.state.isSeriesOfferedCI) ? MaterialTypeCI : MaterialTypeId

        if (selectedSeriesOffered === 'A-111' || selectedSeriesOffered === 'A-112') {
            shutterData = {
                loggedInUserId: loggedInUserId(),
                Dated: fieldObj.date,
                ItemNumber: fieldObj.ItemNumber,
                PIDNumber: fieldObj.pid_number,
                QuoteNumber: fieldObj.quote_number,
                Client: fieldObj.client,
                Project: fieldObj.project,
                Location: fieldObj.location,
                TagNumber: fieldObj.tag_number,
                ReferenceDrawingNumber: '',
                RevisionNumber: fieldObj.rev_number,
                RevisionDate: fieldObj.rev_date,
                SelectedStemMaterial: fieldObj.stemMaterial,
                SelectedApplicableStandard: fieldObj.applicableStandard,
                SizeWidth: Number(fieldObj.width),
                SizeHeight: Number(fieldObj.height),
                Quantity: 0,
                SeatingHead: Number(fieldObj.seatingHead),
                UnseatingHead: Number(fieldObj.unseatingHead),
                ClPl: Number(fieldObj.cl_pl),
                SelectedFrameMounting: fieldObj.frameMounting,
                SelectedClosureType: ClosureType,
                SelectedFrameLengthType: fieldObj.SelectedFrameLengthType,
                SelectedSpindleType: shaftSpindle,
                SelectedSpindleDirection: fieldObj.SpindleDirection,
                SelectedActuation: fieldObj.Actuation,
                SelectedSpindleDiameter: null,
                SelectedStemDiameter: fieldObj.stemDia,
                SelectedSeriesOffered: fieldObj.SelectedSeriesOffered,
                SelectedThrustOn: fieldObj.selectedThrustOn,
                FrameLength: fieldObj.FL,
                SelectedFrameExtension: this.state.frameExtension,
                SelectedFactorOfSafety: this.state.factorOfSafetyDD,
                FOS1: fieldObj.FOS1,
                FOS2: fieldObj.FOS2,
                FOS3: fieldObj.FOS2
            }
        } else {
            shutterData = {
                ShutterDesignCalculationNumber: '',
                CompanyId: '',
                SizeWidth: Number(fieldObj.width),
                SizeHeight: Number(fieldObj.height),
                Quantity: 0,
                SeatingHead: Number(fieldObj.seatingHead),
                UnseatingHead: Number(fieldObj.unseatingHead),
                ClPl: Number(fieldObj.cl_pl),
                SeatingWaterHeadOnDoor: fieldObj && fieldObj.seatingHead ? checkForNull(this.seatingWaterCalculation()) : 0,
                UnseatingWaterHeadOnDoor: fieldObj && fieldObj.unseatingHead ? checkForNull(this.unseatingWaterCalculation()) : 0,
                DesignWaterHeadFromInvertOfOpening: (fieldObj && fieldObj.unseatingHead && fieldObj.seatingHead) ? this.returnMaxNumber() : 0,
                // ReferenceDocumentId: refDocsId,
                SelectedReferenceDocument: refDocsId,
                // MaterialTypeId: MaterialTypeId,
                SelectedMaterialType: SelectedManufacturingMaterial,
                UltimateTensileStrength: manufacturingMaterialObj.UTS * 1,
                YieldStrength: manufacturingMaterialObj.YS * 1,
                UltimateShearStrength: manufacturingMaterialObj.FSS,
                BendingStress: referenceDocumentsObj.BendingStress * manufacturingMaterialObj.YS,
                AxialStress: referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS,
                ShearStress: referenceDocumentsObj.ShearStress * manufacturingMaterialObj.FSS,
                MaximumWaterHead: this.seatingWaterCalculation() / 1000,
                MaximumPressureOnCentreOfSkinPlate: checkForNull(((1010 * 9.81) * (fieldObj && fieldObj.seatingHead ? `${(this.seatingWaterCalculation() / 1000)}` : 0))),
                NoOfVerticalStiffeners: Number(fieldObj.verticalStiffeners),
                NoOfHorizontalStiffeners: Number(fieldObj.horizontalStiffeners),
                SkinPlateThickness: Number(fieldObj.skinPlateThickness),
                BayWidthOfVerticalStiffeners: checkForNull(this.bayWidthVerticalStif()),
                BayWidthOfHorizontalStiffeners: checkForNull(this.bayWidthHorizontalStif()),
                BbyA: checkForNull(this.returnMaxStiffeners()),
                NonDimensionalFactorK: this.nonDimensionalFactor(),
                BendingStressInSkinPlate: checkForNull(this.calculateSkinPlateBendingStress()),
                PermissibleBendingStress: referenceDocumentsObj.BendingStress * manufacturingMaterialObj.YS,
                SkinPlateMessage: this.bendingStressAlert(),
                //HorizontalStiffenerId: fieldObj.horizontalStiffenersSection,
                SelectedHorizontalStiffnerSection: fieldObj.horizontalStiffenersSection,
                HorizontalStiffenerb1: this.returnFieldInteger('HRb1'),
                HorizontalStiffenert1: this.returnFieldInteger('HRt1'),
                HorizontalStiffenert2: fieldObj && fieldObj.skinPlateThickness ? this.returnFieldInteger('skinPlateThickness') : 0,
                HorizontalStiffenert3: Number(fieldObj.HRt3),
                HorizontalStiffenerInnerd: Number(fieldObj.HRd),
                HorizontalStiffenerd1: this.returnFieldInteger('HRd1'), //this.returnFieldInteger('HRd1')
                HorizontalStiffenerD: this.returnFieldInteger('HRD'),
                CentreToCentreDistanceOfEndVerticalStiffeners: this.returnEndVerticalStiff(),
                HorizontalCoActingWidthB1: checkForNull(this.returnCoActingWidthB1()),
                HorizontalCoActingWidthB2: this.returnCoActingWidthB2(),
                HorizontalCoActingWidthB3: checkForNull(this.bayWidthHorizontalStif()),
                HorizontalMinimumValueOfCoActingWidthB: checkForNull(this.returnMinimumCoActingWidth()),
                HorizontalStiffenery1: this.HRStiffY1Calculation(),
                HorizontalStiffenery2: this.HRStiffY2Calculation(),
                HorizontalStiffenerMomentOfInertiaI: this.HRStiffInertiaCalculation(),
                HorizontalStiffenerZ1: (this.HRStiffInertiaCalculation() / (this.HRStiffY1Calculation() / 1000)),
                HorizontalStiffenerZ2: (this.HRStiffInertiaCalculation() / (this.HRStiffY2Calculation() / 1000)),
                HorizontalStiffenerA: checkForNull(this.bayWidthHtalStiffSpan()),
                HorizontalHydrostaticForceDueToMaximumHead: checkForNull(this.returnHydroForceMaxHead()),
                HorizontalHydrostaticForceDueToSeatingHead: checkForNull(this.returnHydroForceSeatingHead()),
                HorizontalHydrostaticForceDueToUnseatingHead: checkForNull(this.returnHydroForceUnseatingHead()),
                HorizontalBendingMomentDueToMaximumHead: checkForNull(this.returnBendingMomentMaxHead()),
                HorizontalBendingMomentDueToSeatingHead: checkForNull(this.returnBendingMomentSeatingHead()),
                HorizontalBendingMomentDueToUnseatingHead: checkForNull(this.returnBendingMomentUnSeatingHead()),
                HorizontalMaximumTensileStressDuringBendingOnSeatingHead: checkForNull(this.returnMaxTensileStress()),
                HorizontalPermissibleTensileStressDuringBendingOnSeatingHead: (referenceDocumentsObj.BendingStress * manufacturingMaterialObj.YS),
                HorizontalTensileStressDuringBendingOnSeatingHeadMessage: this.tensileStressDesignMessage(),
                HorizontalMaximumCompressiveStressDuringBendingOnSeatingHead: checkForNull(this.returnMaxCompressiveStress()),
                HorizontalPermissibleCompressiveStressDuringBendingOnSeatingHead: (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS),
                HorizontalCompressiveStressDuringBendingOnSeatingHeadMessage: this.compressiveStressDesignMessage(),
                HorizontalMaximumTensileStressDuringBendingOnUnseatingHead: checkForNull(this.returnMaxTensileStressUnSeatHead()),
                HorizontalPermissibleTensileStressDuringBendingOnUnseatingHead: (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS),
                HorizontalTensileStressDuringBendingOnUnseatingHeadMessage: this.tensileStressUnseatHeadDesignMessage(),
                HorizontalMaximumCompressiveStressDuringBendingOnUnseatingHead: checkForNull(this.returnMaxCompressiveStressUnseatedHead()),
                HorizontalPermissibleCompressiveStressDuringBendingOnUnseatingHead: (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS),
                HorizontalCompressiveStressDuringBendingOnUnseatingHeadMessage: this.compressiveStressUnseatHeadDesignMessage(),
                HorizontalMaxShearForce: checkForNull(this.returnMaxShearForce()),
                HorizontalMaxShearStress: parseInt(this.returnMaxShearStress()),
                HorizontalPermissibleShearStress: (referenceDocumentsObj.ShearStress * manufacturingMaterialObj.FSS),
                HorizontalCheckForShearStressMessage: this.shearStressMaxHeadMessage(),
                HorizontalMaxDeflectionAtCentre: checkForNull(this.returnMaxDeflectionAtCentre()),
                HorizontalL: Number(fieldObj.horizontalDeflection),
                HorizontalPermissibleDeflectionAsPerTenderSpecification: checkForNull(this.returnPermissibleDefTenderSpec()),
                HorizontalPermissibleDeflectionNotToExceed: Number(fieldObj.referenceDocuments) === 0 ? 1.60 : 0,
                HorizontalCheckingForDeflectionMessage: this.actualDeflectionDesignMessage(),
                //VerticalStiffenerId: fieldObj.verticalStiffenersSection,
                SelectedVerticalStiffnerSection: fieldObj.verticalStiffenersSection,
                VerticalStiffenerb1: this.returnFieldInteger('VRb1'),
                VerticalStiffenert1: this.returnFieldInteger('VRt1'),
                VerticalStiffenert2: fieldObj && fieldObj.skinPlateThickness ? this.returnFieldInteger('skinPlateThickness') : 0,
                VerticalStiffenert3: Number(fieldObj.VRt3),
                VerticalStiffenerInnerd: Number(fieldObj.VRd),
                VerticalStiffenerd1: this.returnFieldInteger('VRd1'),
                VerticalStiffenerD: this.returnFieldInteger('VRD'),
                CentreToCentreDistanceOfHorizontalStiffeners: checkForNull(this.bayWidthHorizontalStif()),
                VerticalCoActingWidthB1: checkForNull(this.returnVerticalCoActingWidthB1()),
                VerticalCoActingWidthB2: checkForNull(this.returnVerticalCoActingWidthB2()),
                VerticalCoActingWidthB3: checkForNull(this.bayWidthVerticalStif()),
                VerticalMinimumValueOfCoActingWidthB: checkForNull(this.returnVerticalMinimumCoActingWidth()),
                VerticalStiffenery1: this.VRStiffY1Calculation(),
                VerticalStiffenery2: this.VRStiffY2Calculation(),
                VerticalStiffenerMomentOfInertiaI: this.VRStiffInertiaCalculation(),
                VerticalStiffenerZ1: this.VRStiffInertiaCalculation() / (this.VRStiffY1Calculation() / 1000),
                VerticalStiffenerZ2: (this.VRStiffInertiaCalculation() / (this.VRStiffY2Calculation() / 1000)),
                VerticalStiffenerA: checkForNull(this.bayWidthVtalStiffSpan()),
                VerticalHydrostaticForceDueToMaximumHead: checkForNull(this.returnVerticalHydroForceMaxHead()),
                VerticalHydrostaticForceDueToSeatingHead: checkForNull(this.returnVerticalHydroForceSeatingHead()),
                VerticalHydrostaticForceDueToUnseatingHead: checkForNull(this.returnVerticalHydroForceUnseatingHead()),
                VerticalBendingMomentDueToMaximumHead: checkForNull(this.returnVerticalBendingMomentMaxHead()),
                VerticalBendingMomentDueToSeatingHead: checkForNull(this.returnVerticalBendingMomentSeatingHead()),
                VerticalBendingMomentDueToUnseatingHead: checkForNull(this.returnVerticalBendingMomentSeatingHead()),
                VerticalMaximumTensileStressDuringBendingOnSeatingHead: checkForNull(parseInt(this.returnVerticalMaxTensileStress())),
                VerticalPermissibleTensileStressDuringBendingOnSeatingHead: (referenceDocumentsObj.BendingStress * manufacturingMaterialObj.YS),
                VerticalTensileStressDuringBendingOnSeatingHeadMessage: this.verticalTensileStressDesignMessage(),
                VerticalMaximumCompressiveStressDuringBendingOnSeatingHead: checkForNull(parseInt(this.returnVerticalMaxCompressiveStress())),
                VerticalPermissibleCompressiveStressDuringBendingOnSeatingHead: (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS),
                VerticalCompressiveStressDuringBendingOnSeatingHeadMessage: this.verticalCompressiveStressDesignMessage(),
                VerticalMaximumTensileStressDuringBendingOnUnseatingHead: checkForNull(parseInt(this.returnVerticalMaxTensileStressUnSeatHead())),
                VerticalPermissibleTensileStressDuringBendingOnUnseatingHead: (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS),
                VerticalTensileStressDuringBendingOnUnseatingHeadMessage: this.verticalTensileStressUnseatHeadDesignMessage(),
                VerticalMaximumCompressiveStressDuringBendingOnUnseatingHead: checkForNull(this.returnVerticalMaxCompressiveStressUnseatedHead()),
                VerticalPermissibleCompressiveStressDuringBendingOnUnseatingHead: (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS),
                VerticalCompressiveStressDuringBendingOnUnseatingHeadMessage: this.verticalCompressiveStressUnseatHeadDesignMessage(),
                VerticalMaxShearForce: checkForNull(this.returnVerticalMaxShearForce()),
                VerticalMaxShearStress: checkForNull(this.returnVerticalMaxShearStress()),
                VerticalPermissibleShearStress: (referenceDocumentsObj.ShearStress * manufacturingMaterialObj.FSS),
                VerticalCheckForShearStressMessage: this.verticalShearStressMaxHeadMessage(),
                VerticalMaxDeflectionAtCentre: checkForNull(this.returnVerticalMaxDeflectionAtCentre()),
                VerticalL: Number(fieldObj.verticalDeflection),
                VerticalPermissibleDeflectionAsPerTenderSpecification: checkForNull(this.returnVerticalPermissibleDefTenderSpec()),
                VerticalPermissibleDeflectionNotToExceed: Number(fieldObj.referenceDocuments) === 0 ? 1.60 : 0,
                VerticalCheckingForDeflectionMessage: this.actualDeflectionDesignMessage(),
                SkinPlateThicknessRequired: checkForNull(parseInt(this.returnFieldInteger('skinPlateThickness'))),
                SkinPlateThicknessConsidered: this.returnFieldInteger('skinPlateThickness'),
                HorizontalRibsThicknessRequired: checkForNull(parseInt(this.returnFieldInteger('HRt3'))),
                HorizontalRibsThicknessConsidered: this.returnFieldInteger('HRt3'),
                VerticalRibsThicknessRequired: checkForNull(parseInt(this.returnFieldInteger('VRt3'))),
                VerticalRibsThicknessConsidered: this.returnFieldInteger('HRt3'),
                HorizontalRibsHeightRequired: checkForNull(parseInt(horizontalRibsHeight)),
                // HorizontalRibsHeightConsidered: this.returnFieldInteger('VRt3'),
                HorizontalRibsHeightConsidered: checkForNull(horizontalRibsHeight),
                VerticalRibsHeightRequired: checkForNull(parseInt(verticalRibsHeight)),
                VerticalRibsHeightConsidered: checkForNull(verticalRibsHeight),
                HorizontalRibsQuantityRequired: checkForNull(parseInt(this.returnFieldInteger('horizontalStiffeners'))),
                HorizontalRibsQuantityConsidered: this.returnFieldInteger('horizontalStiffeners'),
                VerticalRibsQuantityRequired: checkForNull(parseInt(this.returnFieldInteger('verticalStiffeners'))),
                VerticalRibsQuantityConsidered: this.returnFieldInteger('verticalStiffeners'),
                WeightOfDoorOrShutter: (this.state.isSeriesOfferedCI) ? fieldObj.consideredWeightOfDoor_Shutter : checkForNull(weightDoor(fieldObj, this.state.currentSelectedMaterial)),
                SelectedFrameMounting: fieldObj.frameMounting,
                SelectedClosureType: ClosureType,
                SelectedFrameLengthType: fieldObj.SelectedFrameLengthType,
                SelectedSpindleType: shaftSpindle,
                SelectedSpindleDirection: fieldObj.SpindleDirection,
                SelectedActuation: fieldObj.Actuation,
                SelectedSpindleDiameter: null,
                SelectedStemDiameter: stemDiaField,
                SelectedSeriesOffered: fieldObj.SelectedSeriesOffered,
                CreatedBy: loggedInUserId(),
                loggedInUserId: loggedInUserId(),
                Dated: fieldObj.date,
                ItemNumber: fieldObj.ItemNumber,
                PIDNumber: fieldObj.pid_number,
                QuoteNumber: fieldObj.quote_number,
                Client: fieldObj.client,
                Project: fieldObj.project,
                // GateSize: fieldObj.project ? fieldObj.project : 0,
                Location: fieldObj.location,
                TagNumber: fieldObj.tag_number,
                ReferenceDrawingNumber: '',
                RevisionNumber: fieldObj.rev_number,
                RevisionDate: fieldObj.rev_date,
                SelectedStemMaterial: fieldObj.stemMaterial,
                SelectedApplicableStandard: fieldObj.applicableStandard,
                SelectedThrustOn: fieldObj.selectedThrustOn,
                FrameLength: fieldObj.FL,
                SelectedFrameExtension: this.state.frameExtension,
                SelectedFactorOfSafety: factorOfSafetyOp,
                FOSOne: fieldObj.FOS1,
                FOSTwo: fieldObj.FOS2,
                FOSThree: fieldObj.FOS3,
                CustomFactorOfSafetyValue: Number(FOSValue),
                SelectTypicalHorizontalRIB: selectHorizontalRib,
                SelectWeConsiderSectionForHorizontalStiffeners: horizontalStiffenersSection,
                TypicalHorizontalRIBThicknessOneForA: hs1,
                TypicalHorizontalRIBThicknessTwoForA: hs2,
                TypicalHorizontalRIBHeightForA: hs3,
                TypicalHorizontalRIBShutterThicknessForA: hs4,
                TypicalHorizontalRIBNoOfHorzRIBSSpacingForA: hs5,
                TypicalHorizontalRIBWidthOfFlangeForB: hs6,
                TypicalHorizontalRIBThicknessForFlangeForB: hs7,
                TypicalHorizontalRIBThicknessForWebForB: hs8,
                TypicalHorizontalRIBShutterThicknessForB: hs9,
                TypicalHorizontalRIBHeightWebForB: hs10,
                TypicalHorizontalRIBNoOfHorzRIBSSpacingForB: hs11,
                TypicalVerticalRIBThicknessOneForA: hs12,
                TypicalVerticalRIBThicknessTwoForA: hs13,
                TypicalVerticalRIBHeightForA: hs14,
                TypicalVerticalRIBNoOfHorzRIBSSpacingForA: hs15,
                ConsideredWeightOfDoorOrShutter: fieldObj.consideredWeightOfDoor_Shutter,

                SizeOfSideWedges: this.sizeOfSideWedges(),
                NoOfSideWedges: this.noOfSideWedges(),
                WidthOfBorder: this.widthOfBorder(),
                ThicknessOfBorder: this.thicknessOfBorder(),
                MCAllowance: this.mcAllowance(),
                TypicalVerticalRIBShutterThicknessForA: this.state.cisDataVal.TypicalVerticalRIBShutterThicknessForA
            }
        }
        this.props.setData(fieldObj)

        if (isEditFlag || shutterDesignCreated) {
            let updatedShutterData = {
                ...shutterData,
                IsCopyDesign: isCopyCosting,
                IsPostOrder: this.state.isPostOrder,
                ShutterDesignCalculationId: ShutterId,
            }

            this.props.updateShutterDesign(updatedShutterData, (res) => {
                if (res.response && res.response.data) {
                    toastr.warning(res.response.data.Message)
                } else if (res && res.data && res.data.Result) {
                    this.setState({ shutterDesignId: res.data.Identity })
                    this.props.shutterIdNewCreated(res.data.Identity)
                    this.setState({ modal: true });
                    // this.props.toggle(ActiveTab)
                    // this.continueEditingConfirmation();
                    toastr.success('Shutter Design have been updated successfully.')
                }
                this.setState({ isLoader: false })
            })
        } else {
            this.props.createShutterDesign(shutterData, (res) => {
                if (res.response && res.response.data) {
                    toastr.warning(res.response.data.Message)
                } else if (res && res.data && res.data.Result) {
                    this.props.setShutterDesignCreated(true)
                    this.setState({ shutterDesignId: res.data.Identity })
                    this.props.shutterIdNewCreated(res.data.Identity)
                    this.props.toggle(ActiveTab)
                    toastr.success('Shutter Design have been saved successfully.')
                }
                this.setState({ isLoader: false })
            })
        }
    }

    shearStressCalc = () => {
        let temp, val, X26, X25, calcfos31

        if (this.state.factorOfSafetyDD === "STANDARD") {
            X26 = 1
            calcfos31 = 5
        } else { X26 = 0 }

        if (this.state.factorOfSafetyDD === "CUSTOM") {
            X25 = 1
            calcfos31 = this.props.fieldObj.FOS3
        }
        else {
            X25 = 0
        }

        if (this.props.fieldObj.referenceDocuments === '0') {
            temp = 0.25
        } else if (this.props.fieldObj.referenceDocuments === '3') {
            temp = 0.2
        } else {
            temp = 0.33
        }
        val = Number(temp) * Number(X26) + (1 / Number(calcfos31)) * Number(X25)
        return val
    }

    // factorOfSafetyCalc = () => {
    //     const { fieldObj } = this.props
    //     let FL = 5
    //     let frameExtension = 'SELF CONTAINED FRAME WITH EXT LENGTH'
    //     //1
    //     let tempVal
    //     // this.state.selectedSeriesOffered
    //     let tempObj
    //     SeriesOfferedOption &&
    //         SeriesOfferedOption.map((item) => {
    //             if (fieldObj.SelectedSeriesOffered == item.Value) {
    //                 tempObj = item.Key
    //             }

    //             // tempObj = {
    //             //     label: checkForNull(parseFloat(item.Text)).toFixed(2),
    //             //     value: item.Value,
    //             // };
    //             // tempArr.push(tempObj);
    //         });

    //     if (tempObj == '3') {
    //         tempVal = (Number(fieldObj.cl_pl) * 1000 + (0.5 * Number(fieldObj.height)) + 1300)
    //     }

    //     else {
    //         tempVal = (fieldObj.cl_pl * 1000 - (0.5 * fieldObj.height) + 1300)
    //     }
    //     let ref1
    //     let ref2
    //     if (tempObj == '2') {
    //         ref1 = 0
    //         ref2 = 1
    //     }
    //     else {
    //         ref1 = 1
    //         ref2 = 0
    //     }
    //     let tempVal2

    //     // =IF(selectedSeriesOffered=A-311 & 321,
    //     //     (5*1000+(0.5*914)+1300)*0+(914 +250+500+100)*1

    //     //     (5*1000-(0.5*914 )+1300)) 

    //     // =IF(D10=D251,(H8*1000+(0.5*I4)+1300),(H8*1000-(0.5*I4)+1300))*E10+(I4+250+500+100)*E9*0+(914 +250+500+100)*1

    //     tempVal2 = Number(tempVal) * Number(ref1) + (Number(fieldObj.height) + 250 + 500 + 100) * Number(ref2)
    //     //__________________

    //     //2
    //     // =(I4+250+500)*E10+((H9*1000)-I4+150+100+250+500)*E9
    //     let ref3
    //     let ref4
    //     if (tempObj == '2') {
    //         ref3 = 0
    //         ref4 = 1
    //     }
    //     else {
    //         ref3 = 1
    //         ref4 = 0
    //     }
    //     let tempVal3 = (Number(fieldObj.height) + 250 + 500) * Number(ref3) + ((Number(FL) * 1000) - Number(fieldObj.height) + 150 + 100 + 250 + 500) * Number(ref4)

    //     //______________________
    //     //3

    //     // = IF(AND(D15 = D501), 
    //     // (I4 * IF(D10 = D251, 1.66, 1.5) + 100), 
    //     // IF(AND(D15 = D502, D16 = B524), (I4 * 2 + IF(D10 = D251, 250, 100)), H9 * 1000))


    //     let ref5, ref6
    //     if (fieldObj.SelectedFrameLengthType == 'SHORT LENGTH') {
    //         if (tempObj == '3') {
    //             ref5 = 1.66
    //         }
    //         else {
    //             ref5 = 1.5
    //         }
    //         ref6 = (Number(fieldObj.height) * Number(ref5) + 100)
    //     }
    //     else {
    //         if (fieldObj.SelectedFrameLengthType == 'FULL LENGTH' && frameExtension == 'SELF CONTAINED FRAME WITH EXT LENGTH') {

    //             if (tempObj == '3') {
    //                 ref5 = 250
    //             }
    //             else {
    //                 ref5 = 100
    //             }
    //             ref6 = (Number(fieldObj.height) * 2 + Number(ref5))
    //         }
    //         else {
    //             ref6 = Number(FL) * 1000
    //         }
    //     }
    //     let refVal1
    //     if (tempObj == '3') {
    //         refVal1 = 0.6
    //     }
    //     else {
    //         refVal1 = 1
    //     }

    //     let ref7
    //     let ref8
    //     let value3
    //     if (tempObj == '2') {
    //         ref7 = 0
    //         ref8 = 1
    //     }
    //     else {
    //         ref7 = 1
    //         ref8 = 0
    //     }
    //     // =(E23+250+500-(I4*IF(D10=D251,0.6,1)))*E10+(H8*1000-(I4/2)+(900+350))*E9
    //     value3 = (Number(ref6) + 250 + 500 - (Number(fieldObj.height) * Number(refVal1))) * Number(ref7) + (Number(fieldObj.cl_pl) * 1000 - (Number(fieldObj.height) / 2) + (900 + 350)) * Number(ref8)
    //     let finalCalc

    //     // = IF(AND(D15 = D502, F508 = D20, D16 = B524), K7, IF(AND(D15 = D502, F508 = D20, D16 = B525), K8, K6))

    //     if (fieldObj.SelectedFrameLengthType == 'FULL LENGTH' && fieldObj.selectedThrustOn == 'FRAME' &&
    //         frameExtension == 'SELF CONTAINED FRAME WITH EXT LENGTH') {
    //         finalCalc = tempVal3
    //     }
    //     else if (fieldObj.SelectedFrameLengthType == 'FULL LENGTH' && fieldObj.selectedThrustOn == 'FRAME'
    //         && frameExtension == 'CLOSED TOP FRAME WITH EXT STEM LENGTH') {
    //         finalCalc = value3
    //     }
    //     else {
    //         finalCalc = tempVal2
    //     }

    //     return finalCalc
    // }













    weightOfDoor3 = () => {
        return (Number(this.widthOfBorder()) + Number(this.mcAllowance())) * (Number(this.thicknessOfBorder()) + Number(this.mcAllowance()) * 2) * 7250 / 1000000
    }

    weightOfDoor3_2 = () => {
        const { fieldObj } = this.props
        return Number(this.weightOfDoor3()) * (Number(fieldObj.width) + Number(fieldObj.height) + 2 * Number(this.widthOfBorder())) * 2 / 1000
    }

    table3_mainSec3G336 = (height) => {
        let indexTemp
        indexTemp = height <= 915.00 ? 0 : 4
        for (let i = 1; i <= 3; i++) {
            const range1 = table3Section3G336[i - 1]
            const range2 = table3Section3G336[i]

            if (height > range1 && height < range2) {
                indexTemp = i
            }
        }
        return table3Section3G336Value[indexTemp]
    }

    table1_mainSec3G320 = () => {
        // =IF(F317 < E318, F318, 0)
        const { fieldObj } = this.props
        let val
        if (fieldObj.height < 762) {
            val = 90
        }
        else if (fieldObj.height < 1525 && fieldObj.height > 762) {
            val = 100
        }
        else {
            val = 0
        }
        return val
    }

    table2_mainSec3G328 = (height) => {
        let indexTemp
        indexTemp = height <= 305 ? 0 : 5
        for (let i = 0; i <= 4; i++) {
            const range1 = table2Section3G328[i - 1]
            const range2 = table2Section3G328[i]

            if (height > range1 && height < range2) {
                indexTemp = i
            }
        }
        return table2Section3G328Value[indexTemp]
    }

    table4_mainSec3G351 = (height) => {
        let indexTemp
        indexTemp = height <= 305 ? 0 : 12
        for (let i = 1; i <= 12; i++) {
            const range1 = table4Section3G351[i - 1]
            const range2 = table4Section3G351[i]

            if (height > range1 && height < range2) {
                indexTemp = i
            }
        }
        return table4Section3G351Value[indexTemp]
    }

    sizeOfSideWedges = () => {

        // =IF(R369=101,G320,IF(R369=301,0,IF(R369=201,0,G336)))

        const { selectedSeriesOffered } = this.state
        let val

        if (selectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN') {
            val = this.table1_mainSec3G320()
        } else if (selectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') {
            val = 0
        } else if (selectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL') {
            val = 0
        } else {
            val = this.table3_mainSec3G336(this.props.fieldObj.height)
        }
        return val
    }

    weightOfSideWedges = () => {
        const { selectedSeriesOffered } = this.state
        const temp = this.noOfSideWedges()
        const tempB = Number(temp) === 0 ? 1 : temp
        let finalVal, sum = 0, index = 10
        for (let i = 0; i < 10; i++) {
            if (temp > weightOfSideWedgesCalc[i]) {
                sum = Number(sum) + Number(weightOfSideWedgesCalcValue[i])
            }
        }

        if (selectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN') {
            finalVal = 0
        } else if (selectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') {
            finalVal = 0
        } else if (selectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL') {
            finalVal = 0
        } else {
            finalVal = Number(sum) / Number(tempB)
        }
        return (Number(this.sizeOfSideWedges()) + 25) * 100 * Number(finalVal) * 2 * 7.25 / 1000000

    }

    noOfSideWedges = () => {

        // =IF(R369=101,G328,IF(R369=102,G351,IF(R369=103,G366,IF(R369=301,0,IF(R369=201,0,G381)))))

        const { selectedSeriesOffered } = this.state
        const temp = this.table4_mainSec3G351(this.props.fieldObj.height)
        let val
        if (selectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN') {
            val = this.table2_mainSec3G328(this.props.fieldObj.height)
        } else if (selectedSeriesOffered === 'A-102- SECTIONAL FRAME DESIGN') {
            val = temp
        } else if (selectedSeriesOffered === 'A-103- INTEGRAL FRAME DESIGN') {
            val = temp
        } else if (selectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') {
            val = 0
        } else if (selectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL') {
            val = 0
        } else {
            val = temp
        }
        return val
        // =IF(R369 = 101, this.table2_mainSec3G328(), IF(R369 = 102, this.table4_mainSec3G351(),
        //  IF(R369 = 103, this.table4_mainSec3G351(),
        //  IF(R369 = 301, 0, IF(R369 = 201, 0, this.table4_mainSec3G351())))))
    }

    KSeries1 = (height) => {
        let indexTemp
        let tempVal = {}
        indexTemp = height <= 305 ? 0 : 12
        for (let i = 1; i <= 12; i++) {
            const range1 = table4Section3G351[i - 1]
            const range2 = table4Section3G351[i]
            if (height > range1 && height < range2) {
                indexTemp = i
            }
        }
        tempVal.table4MC = table4MC[indexTemp]
        tempVal.table4WT = table4WT[indexTemp]
        tempVal.table4BW = table4BW[indexTemp]
        return tempVal
    }

    KSeries2 = (height) => {
        let indexTemp
        let tempVal = {}
        indexTemp = height <= 305 ? 0 : 12
        for (let i = 1; i <= 12; i++) {
            const range1 = table4Section3G351[i - 1]
            const range2 = table4Section3G351[i]
            if (height > range1 && height < range2) {
                indexTemp = i
            }
        }
        tempVal.table5MC = table5MC[indexTemp]
        tempVal.table5WT = table5WT[indexTemp]
        tempVal.table5BW = table5BW[indexTemp]
        return tempVal
    }

    KSeries3 = (height) => {
        let indexTemp
        let tempVal = {}
        indexTemp = height <= 305 ? 0 : 12
        for (let i = 1; i <= 12; i++) {
            const range1 = table4Section3G351[i - 1]
            const range2 = table4Section3G351[i]
            if (height > range1 && height < range2) {
                indexTemp = i
            }
        }
        tempVal.table6MC = table6MC[indexTemp]
        tempVal.table6WT = table6WT[indexTemp]
        tempVal.table6BW = table6BW[indexTemp]
        return tempVal
    }

    KSeries4 = () => {
        let val = {}
        const { fieldObj } = this.props
        if (fieldObj.height <= 1219.00) {
            val.BW = 75.00
            val.WT = 20.00
            val.MC = 5.00
        } else if (fieldObj.height > 1219.00 && fieldObj.height <= 2006.60) {
            val.BW = 80.00
            val.WT = 20.00
            val.MC = 8.00
        } else if (fieldObj.height > 2006.6) {
            val.BW = 85.00
            val.WT = 25.00
            val.MC = 10.00
        }
        return val
    }

    KSeries5 = () => {
        let val = {}
        const { fieldObj } = this.props
        if (fieldObj.height <= 1219.00) {
            val.BW = 74.00
            val.WT = 20.00
            val.MC = 5.00
        } else if (fieldObj.height > 1219.00 && fieldObj.height <= 2006.60) {
            val.BW = 74.00
            val.WT = 20.00
            val.MC = 8.00
        } else if (fieldObj.height > 2006.6) {
            val.BW = 86.00
            val.WT = 25.00
            val.MC = 10.00
        }
        return val
    }

    widthOfBorder = () => {

        // =IF(R369=101,H322,IF(R369=102,K351,IF(R369=103,K366,IF(R369=104,K381,IF(R369=301,K387,K393)))))

        const H322 = 45
        const { fieldObj } = this.props
        const KSeries1 = this.KSeries1(fieldObj.height)
        const KSeries2 = this.KSeries2(fieldObj.height)
        const KSeries3 = this.KSeries3(fieldObj.height)
        const KSeries4 = this.KSeries4()
        const KSeries5 = this.KSeries5()

        let val
        if (fieldObj.SelectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN') {
            val = 45
        } else if (fieldObj.SelectedSeriesOffered === 'A-102- SECTIONAL FRAME DESIGN') {
            val = KSeries1.table4BW
        } else if (fieldObj.SelectedSeriesOffered === 'A-103- INTEGRAL FRAME DESIGN') {
            val = KSeries2.table5BW
        } else if (fieldObj.SelectedSeriesOffered === 'A-104- UNIVERSAL FRAME DESIGN') {
            val = KSeries3.table6BW
        } else if (fieldObj.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') {
            val = KSeries4.BW
        } else {
            val = KSeries5.BW
        }

        return val
    }

    thicknessOfBorder = () => {

        // =IF(R369=101,I322,IF(R369=102,L351,IF(R369=103,L366,IF(R369=104,L381,IF(R369=301,L387,L393)))))

        const { fieldObj } = this.props
        const KSeries1 = this.KSeries1(fieldObj.height)
        const KSeries2 = this.KSeries2(fieldObj.height)
        const KSeries3 = this.KSeries3(fieldObj.height)
        const KSeries4 = this.KSeries4()
        const KSeries5 = this.KSeries5()

        let val
        if (fieldObj.SelectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN') {
            val = 28
        } else if (fieldObj.SelectedSeriesOffered === 'A-102- SECTIONAL FRAME DESIGN') {
            val = KSeries1.table4WT
        } else if (fieldObj.SelectedSeriesOffered === 'A-103- INTEGRAL FRAME DESIGN') {
            val = KSeries2.table5WT
        } else if (fieldObj.SelectedSeriesOffered === 'A-104- UNIVERSAL FRAME DESIGN') {
            val = KSeries3.table6WT
        } else if (fieldObj.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') {
            val = KSeries4.WT
        } else {
            val = KSeries5.WT
        }
        return val
    }

    mcAllowance = () => {

        // =IF(R369=101,J322,IF(R369=102,M351,IF(R369=103,M366,IF(R369=104,M381,IF(R369=301,M387,M393)))))

        const { fieldObj } = this.props
        const KSeries1 = this.KSeries1(fieldObj.height)
        const KSeries2 = this.KSeries2(fieldObj.height)
        const KSeries3 = this.KSeries3(fieldObj.height)
        const KSeries4 = this.KSeries4()
        const KSeries5 = this.KSeries5()

        let val
        if (fieldObj.SelectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN') {
            val = 10
        } else if (fieldObj.SelectedSeriesOffered === 'A-102- SECTIONAL FRAME DESIGN') {
            val = KSeries1.table4MC
        } else if (fieldObj.SelectedSeriesOffered === 'A-103- INTEGRAL FRAME DESIGN') {
            val = KSeries2.table5MC
        } else if (fieldObj.SelectedSeriesOffered === 'A-104- UNIVERSAL FRAME DESIGN') {
            val = KSeries3.table6MC
        } else if (fieldObj.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') {
            val = KSeries4.MC
        } else {
            val = KSeries5.MC
        }
        return val
    }

    weightOfSkinPlate = () => {
        let val = this.props.fieldObj.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE' ? this.mcAllowance() : 0
        const { hs4, hs9, horizontalStiffenersSection } = this.state.cisDataVal
        const skinPlateThicknessStage3 = horizontalStiffenersSection === 'A' ? hs4 : hs9

        return 1 * 1 * (Number(skinPlateThicknessStage3) + Number(val)) * 7250 / 1000
    }

    weightOfSkinPlate_2 = () => {
        return (Number(this.props.fieldObj.width) * Number(this.props.fieldObj.height)) * Number(this.weightOfSkinPlate()) / 1000000
    }

    cisData = (data) => {
        data.horizontalSniffersSelect = this.state.horizontalSniffersSelect

        this.setState({ cisDataVal: data })
    }

    render() {
        const { handleSubmit, pristine, submitting, fieldObj, isEditFlag, isViewFlag } = this.props;
        const {
            isLoader,
            manufacturingMaterialObj,
            currentSelectedMaterial,
            selectedSeriesOffered,
            modal,
            activeActuation,
            thrustOnOptions,
            frameExtensionOption,
            applicableStandardDataArray } = this.state;

        const horizontalRibsHeight = this.horizontalRibsHeight();
        const verticalRibsHeight = this.verticalRibsHeight();
        fieldObj.horizontalRibsHeight = this.horizontalRibsHeight();
        fieldObj.vertiRibsHeight = this.verticalRibsHeight();

        const { hs2, hs3, hs4, hs5, hs6, hs7, hs8, hs9, hs10, hs11, hs13,
            hs14, hs15, horizontalStiffenersSection } = this.state.cisDataVal

        //first value
        let X25, X26, firstVal, tempP, tempA, secondValue, con1, con2, minOfCon1_2, finalValueShearStress, val23Shear//, shearstressObj
        if (this.state.factorOfSafetyDD === "STANDARD") {
            X26 = 1
        } else { X26 = 0 }
        if (this.state.factorOfSafetyDD === "CUSTOM") {
            X25 = 1
        }
        else {
            X25 = 0
        }
        //here
        // 0  3  1
        // =IF(M21=M421,0.25,IF(M21=M422,0.2,IF(M21=M423,0.75,0.4)))*X26+(1/W28)*X25
        if (String(fieldObj.referenceDocuments) === '0') {
            tempP = 0.25
        } else if (String(fieldObj.referenceDocuments) === '3') {
            tempP = 0.20
        } else if (String(fieldObj.referenceDocuments) === '1') {
            tempP = 0.75
        } else {
            tempP = 0.4
        }
        let calcfos1, calcfos2, calcfos3

        if (this.state.factorOfSafetyDD === "STANDARD") {
            calcfos1 = 2
            calcfos2 = 2
            calcfos3 = 5
        } else {
            calcfos1 = fieldObj.FOS1
            calcfos2 = fieldObj.FOS2
        }

        firstVal = Number(tempP) * Number(X26) + (1 / Number(calcfos1)) * Number(X25)


        // second value
        // =IF(M21 = M421, 0.5, IF(M21 = M422, 0.33, IF(M21 = M423, 0.75, 0.4))) * X26 + (1 / W29) * X25

        if (fieldObj.referenceDocuments === '0') {
            tempA = 0.5
        } else if (fieldObj.referenceDocuments === '3') {
            tempA = 0.33
        } else if (fieldObj.referenceDocuments === '1') {
            tempA = 0.75
        } else {
            tempA = 0.4
        }
        secondValue = Number(tempA) * Number(X26) + (1 / Number(calcfos2)) * Number(X25)

        con1 = Number(manufacturingMaterialObj.UTS) * Number(firstVal)
        con2 = Number(manufacturingMaterialObj.YS) * Number(secondValue)
        minOfCon1_2 = Number(con1) < Number(con2) ? Number(con1) : Number(con2)
        finalValueShearStress = Number(minOfCon1_2) === Number(con1) ? Number(firstVal) : Number(secondValue)
        val23Shear = Number(minOfCon1_2) === Number(con1) ? Number(manufacturingMaterialObj.UTS) : Number(manufacturingMaterialObj.YS)
        shearstressObj = Number(finalValueShearStress) * Number(val23Shear)
        //______________________________________________________________________________________

        //3 weight formula

        const tempforRibThickness4A = fieldObj.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' ||
            fieldObj.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE'
            ? 1 : 1.5

        const ribThickness4A = nextEvenNo(hs2 * tempforRibThickness4A)

        const ribDistanceL = horizontalStiffenersSection === 'A' ? Number(fieldObj.height) / Number(hs5)
            : Number(fieldObj.height) / Number(hs11)
        //tem[]

        const horizRibThickWeb_M3 = horizontalStiffenersSection === 'A' ? (hs2) : hs8
        const horizontalRibsHeightValue = horizontalStiffenersSection === 'A' ? (hs3) : (hs5)
        const horizRibsHeightVal_M3 = horizontalStiffenersSection === 'A' ? (hs3) : (hs10)
        const horizoncalRibsQuantityVal_M = Math.ceil(fieldObj.height / ribDistanceL) + 1
        const verticalRibsQuantityVal_M = (fieldObj.width / (this.returnFieldInteger('width') / hs15)) + 1
        // =IF(Q72="A",(horizRibThickWeb_M3*horizRibsHeightVal_M3)*7250/10^6,((horizRibThickWeb_M3*horizRibsHeightVal_M3)+(fieldObj.hs7*fieldObj.hs6))*7250/10^6)

        // =IF(Q72="A",(T303*T306)*7250/10^6,((T303*T306)+(T304*U74))*7250/10^6)
        const weightOfHRibsEBR = horizontalStiffenersSection === 'A' ? (Number(horizRibThickWeb_M3) * Number(horizRibsHeightVal_M3)) * 7250 / 1000000 :
            ((Number(horizRibThickWeb_M3) * Number(horizRibsHeightVal_M3)) + (Number(hs7) * Number(hs6))) * 7250 / 1000000
        const weightOfHRibsEBR_2 = Number(weightOfHRibsEBR) * (Number(horizoncalRibsQuantityVal_M) - 2) * Number(fieldObj.width) / 1000

        const weightOfHTopBottomRib = horizontalStiffenersSection === 'A' ? (ribThickness4A * horizRibsHeightVal_M3) * 7250 / 1000000 :
            ((nextEvenNo(hs8 * 1.5) * horizRibsHeightVal_M3) + (hs6 * nextEvenNo(hs8 * 1.5))) * 7250 / 1000000

        const weightOfHTopBottomRib_2 = weightOfHTopBottomRib * 2 * Number(fieldObj.width) / 1000

        const weightOfVRibs = ((hs13) * (hs14)) * 7250 / 1000000
        const weightOfVRibs_2 = weightOfVRibs * (verticalRibsQuantityVal_M * fieldObj.height) / 1000


        // const weightOfSideWedges = ((this.sizeOfSideWedges()) + 25) * 100 * S370 * 2 * 7.25 / 1000000
        // weightOfSideWedges_2


        const weightOfShutter = Number(this.weightOfSkinPlate_2()) + Number(weightOfHRibsEBR_2) + Number(weightOfHTopBottomRib_2)
            + Number(weightOfVRibs_2) + (Number(this.weightOfSideWedges()) * Number(this.noOfSideWedges())) + Number(this.weightOfDoor3_2())

        const skinPlateThicknessStage3 = horizontalStiffenersSection === 'A' ? hs4 : hs9


        // this.weightOfSkinPlate_2()
        // weightOfHRibsEBR_2
        // weightOfHTopBottomRib_2
        // weightOfVRibs_2
        // this.weightOfSideWedges()
        // this.weightOfDoor3_2()
































        // //1
        // let a
        // // this.state.selectedSeriesOffered
        // let tempObj
        // SeriesOfferedOption &&
        //     SeriesOfferedOption.map((item) => {
        //         if (this.state.selectedSeriesOffered == item.Value) {
        //             tempObj = item.Key
        //         }

        //         // tempObj = {
        //         //     label: checkForNull(parseFloat(item.Text)).toFixed(2),
        //         //     value: item.Value,
        //         // };
        //         // tempArr.push(tempObj);
        //     });


        // if (tempObj == '3') {
        //     a = (Number(fieldObj.cl_pl) * 1000 + (0.5 * Number(fieldObj.height)) + 1300)
        // }

        // else {
        //     a = (fieldObj.cl_pl * 1000 - (0.5 * fieldObj.height) + 1300)
        // }
        // let p
        // let q
        // if (tempObj == '2') {
        //     p = 0
        //     q = 1
        // }
        // else {
        //     p = 1
        //     q = 0
        // }
        // let b1

        // // =IF(selectedSeriesOffered=A-311 & 321,
        // //     (5*1000+(0.5*914)+1300)*0+(914 +250+500+100)*1

        // //     (5*1000-(0.5*914 )+1300)) 

        // // =IF(D10=D251,(H8*1000+(0.5*I4)+1300),(H8*1000-(0.5*I4)+1300))*E10+(I4+250+500+100)*E9*0+(914 +250+500+100)*1

        // b1 = Number(a) * Number(p) + (Number(fieldObj.height) + 250 + 500 + 100) * Number(q)
        // //__________________

        // //2
        // // =(I4+250+500)*E10+((H9*1000)-I4+150+100+250+500)*E9
        // let r
        // let s
        // if (tempObj == '2') {
        //     r = 0
        //     s = 1
        // }
        // else {
        //     r = 1
        //     s = 0
        // }
        // let k2 = (Number(fieldObj.height) + 250 + 500) * Number(r) + ((Number(fieldObj.FL) * 1000) - Number(fieldObj.height) + 150 + 100 + 250 + 500) * Number(s)

        // //______________________
        // //3

        // // = IF(AND(D15 = D501), 
        // // (I4 * IF(D10 = D251, 1.66, 1.5) + 100), 
        // // IF(AND(D15 = D502, D16 = B524), (I4 * 2 + IF(D10 = D251, 250, 100)), H9 * 1000))


        // let g, h
        // if (fieldObj.SelectedFrameLengthType == 'SHORT LENGTH') {
        //     if (tempObj == '3') {
        //         g = 1.66
        //     }
        //     else {
        //         g = 1.5
        //     }
        //     h = (Number(fieldObj.height) * Number(g) + 100)
        // }
        // else {
        //     if (fieldObj.SelectedFrameLengthType == 'FULL LENGTH' && this.state.frameExtension == 'SELF CONTAINED FRAME WITH EXT LENGTH') {

        //         if (tempObj == '3') {
        //             g = 250
        //         }
        //         else {
        //             g = 100
        //         }
        //         h = (Number(fieldObj.height) * 2 + Number(g))
        //     }
        //     else {
        //         h = Number(fieldObj.FL) * 1000
        //     }
        // }
        // let qq
        // if (tempObj == '3') {
        //     qq = 0.6
        // }
        // else {
        //     qq = 1
        // }

        // let t
        // let u
        // let v3
        // if (tempObj == '2') {
        //     t = 0
        //     u = 1
        // }
        // else {
        //     t = 1
        //     u = 0
        // }
        // // =(E23+250+500-(I4*IF(D10=D251,0.6,1)))*E10+(H8*1000-(I4/2)+(900+350))*E9
        // v3 = (Number(h) + 250 + 500 - (Number(fieldObj.height) * Number(qq))) * Number(t) + (Number(fieldObj.cl_pl) * 1000 - (Number(fieldObj.height) / 2) + (900 + 350)) * Number(u)
        // let ff

        // // = IF(AND(D15 = D502, F508 = D20, D16 = B524), K7, IF(AND(D15 = D502, F508 = D20, D16 = B525), K8, K6))

        // if (fieldObj.SelectedFrameLengthType == 'FULL LENGTH' && fieldObj.selectedThrustOn == 'FRAME' &&
        //     this.state.frameExtension == 'SELF CONTAINED FRAME WITH EXT LENGTH') {
        //     ff = k2
        // }
        // else if (fieldObj.SelectedFrameLengthType == 'FULL LENGTH' && fieldObj.selectedThrustOn == 'FRAME'
        //     && this.state.frameExtension == 'CLOSED TOP FRAME WITH EXT STEM LENGTH') {
        //     ff = v3
        // }
        // else {
        //     ff = b1
        // }

        return (
            <div>
                <Modal isOpen={modal}>
                    <ModalHeader>Success</ModalHeader>
                    <ModalBody>
                        {`Shutter Design data successfully ${isEditFlag ? 'updated' : 'saved'}. Continue editing with ${activeActuation === 'MANUAL' ? 'Manual' : 'Electrical'} design and Yoke design.`}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => this.props.toggle(fieldObj.Actuation === 'MANUAL' ? '3' : '4')}>Continue</Button>{' '}
                    </ModalFooter>
                </Modal>
                {isLoader && <Loader />}
                <Container fluid className="cr-shutter-container cr-table-wrap">
                    <div className="shutter-design cr-collaps-wrap">
                        <div className="form-heading">
                            <h2>Shutter Design</h2>
                        </div>
                        <form
                            noValidate
                            className="form"
                            autoComplete="off"
                            onSubmit={handleSubmit(this.onSubmit.bind(this))}
                            onKeyPress={(e) => onKeyPress(e)}
                        >
                            <Row className={'mb-3'}>
                                <Col>
                                    <div className={'collaps-wrapper mb15'}>
                                        <Row className={'mb-3'}>
                                            <Col md="4">
                                                <Field
                                                    label={`Item Number`}
                                                    name={"ItemNumber"}
                                                    type="text"
                                                    placeholder={''}
                                                    validate={[required]}
                                                    component={renderText}
                                                    required={true}
                                                    className={''}
                                                    customClassName=" withoutBorderBottom"
                                                    readOnly={isViewFlag}
                                                />
                                            </Col>
                                            <Col md="4">
                                                <Field
                                                    label={`PID Number`}
                                                    name={"pid_number"}
                                                    type="text"
                                                    placeholder={''}
                                                    validate={[required]}
                                                    component={renderText}
                                                    required={true}
                                                    className={''}
                                                    customClassName=" withoutBorderBottom"
                                                    readOnly={isViewFlag}
                                                />
                                            </Col>
                                            <Col md="4">
                                                <Field
                                                    label={`Quote Number`}
                                                    name={"quote_number"}
                                                    type="text"
                                                    placeholder={''}
                                                    validate={[required]}
                                                    component={renderText}
                                                    required={true}
                                                    className={''}
                                                    customClassName=" withoutBorderBottom"
                                                    readOnly={isViewFlag}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className={'mb-3'}>
                                            <Col md="4">
                                                <Field
                                                    label={`Location`}
                                                    name={"location"}
                                                    type="text"
                                                    placeholder={''}
                                                    validate={[required]}
                                                    component={renderText}
                                                    required={true}
                                                    className={''}
                                                    customClassName=" withoutBorderBottom"
                                                    readOnly={isViewFlag}
                                                />
                                            </Col>
                                            <Col md="4">
                                                <Field
                                                    label={`Client`}
                                                    name={"client"}
                                                    type="text"
                                                    placeholder={''}
                                                    validate={[required]}
                                                    component={renderText}
                                                    required={true}
                                                    className={''}
                                                    customClassName=" withoutBorderBottom"
                                                    readOnly={isViewFlag}
                                                />
                                            </Col>
                                            <Col md="4">
                                                <Field
                                                    label={`Date`}
                                                    name={"date"}
                                                    autocomplete="off"
                                                    type="text"
                                                    placeholder={''}
                                                    validate={[required]}
                                                    component={renderDatePicker}
                                                    required={true}
                                                    className={''}
                                                    customClassName=" withoutBorderBottom"
                                                    readOnly={isViewFlag}
                                                    disabled={isViewFlag}

                                                />
                                                {/* <input type='date' name = 'date/> */}
                                            </Col>
                                        </Row>
                                        <Row className={'mb-3'}>
                                            <Col md="4">
                                                <Field
                                                    label={`Project`}
                                                    name={"project"}
                                                    type="text"
                                                    placeholder={''}
                                                    validate={[required]}
                                                    component={renderText}
                                                    required={true}
                                                    className={''}
                                                    customClassName=" withoutBorderBottom"
                                                    readOnly={isViewFlag}
                                                />
                                            </Col>
                                            <Col md="4">
                                                <Field
                                                    label={`Tag Number`}
                                                    name={"tag_number"}
                                                    type="text"
                                                    placeholder={''}
                                                    validate={[required]}
                                                    component={renderText}
                                                    required={true}
                                                    className={''}
                                                    customClassName=" withoutBorderBottom"
                                                    readOnly={isViewFlag}
                                                />
                                            </Col>
                                            <Col md="4">
                                                <Field
                                                    label={`Rev. Number`}
                                                    name={"rev_number"}
                                                    type="text"
                                                    placeholder={''}
                                                    // validate={[required]}
                                                    component={renderText}
                                                    // required={true}
                                                    className={''}
                                                    customClassName="withoutBorderBottom"
                                                    readOnly={isViewFlag}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className={'mb-3'}>
                                            <Col md="4">
                                                <Field
                                                    label={`Rev. Date`}
                                                    name={"rev_date"}
                                                    type="text"
                                                    placeholder={''}
                                                    // validate={[required]}
                                                    component={renderDatePicker}
                                                    // required={true}
                                                    className={''}
                                                    customClassName=" withoutBorderBottom"
                                                    readOnly={isViewFlag}
                                                    disabled={isViewFlag}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            <hr className={'mb-4 pb-1'} />
                            <Row className={'mb-3'}>
                                <Col>
                                    <div className={'collaps-wrapper m-0 card w100 mt-0'}>
                                        <div className={'collaps-head card-header'} onClick={this.stageOneController}>
                                            <h3>Stage One</h3>
                                        </div>
                                        {this.state.stageOneOpen &&
                                            <div className={'collaps-body card-body cr-stage-one'}>
                                                <Row className={'mb-3'}>
                                                    <Col md="4">
                                                        <Field
                                                            label={`WIDTH(MM)`}
                                                            name={"width"}
                                                            type="text"
                                                            placeholder={''}
                                                            validate={[required]}
                                                            component={renderText}
                                                            required={true}
                                                            className={''}
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                        />
                                                    </Col>
                                                    <Col md="4">
                                                        <Field
                                                            label={`HEIGHT(MM)`}
                                                            name={"height"}
                                                            type="text"
                                                            placeholder={''}
                                                            validate={[required]}
                                                            component={renderText}
                                                            required={true}
                                                            className={''}
                                                            onChange={(e) => this.handleHeightOnchange(e)}
                                                            customClassName=" withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                        />
                                                    </Col>
                                                    <Col md="4">
                                                        <Field
                                                            label={`SEATING HEAD (M)`}
                                                            name={"seatingHead"}
                                                            type="text"
                                                            placeholder={''}
                                                            validate={[required]}
                                                            component={renderText}
                                                            required={true}
                                                            className={''}
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className={'mb-3'}>
                                                    <Col md="4">
                                                        <Field
                                                            label={`UNSEATING HEAD (M)`}
                                                            name={"unseatingHead"}
                                                            type="text"
                                                            placeholder={''}
                                                            validate={[required]}
                                                            component={renderText}
                                                            required={true}
                                                            className={''}
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                        />
                                                    </Col>
                                                    <Col md="4">
                                                        <Field
                                                            label={`CL-PL`}
                                                            name={"cl_pl"}
                                                            type="number"
                                                            placeholder={''}
                                                            validate={[required]}
                                                            component={renderText}
                                                            // required={true}
                                                            className={''}
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                        />
                                                    </Col>
                                                    <Col md="4">
                                                        <Field
                                                            label={`SERIES OFFERED`}
                                                            name={"SelectedSeriesOffered"}
                                                            type="text"
                                                            placeholder={'----- Select -----'}
                                                            validate={[required]}
                                                            required={true}
                                                            options={SeriesOfferedOption}
                                                            onChange={this.handleSeriesOffered}
                                                            optionValue={'Value'}
                                                            optionLabel={'Text'}
                                                            component={renderSelectField}
                                                            className="custom-select"
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                            disabled={isViewFlag}
                                                            valueDescription={this.state.selectedSeriesOffered}
                                                        />
                                                    </Col>
                                                    <Col md="4">
                                                        < Field
                                                            label={`FRAME LENGTH`}
                                                            name={"SelectedFrameLengthType"}
                                                            type="text"
                                                            placeholder={'----- Select -----'}
                                                            validate={[required]}
                                                            required={true}
                                                            options={this.state.frameLengthOption}
                                                            onChange={this.handleFrameLength}
                                                            optionValue={'Value'}
                                                            optionLabel={'Text'}
                                                            component={renderSelectField}
                                                            className="custom-select"
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                            disabled={isViewFlag}
                                                        />
                                                    </Col>
                                                    <Col md="4">
                                                        <Field
                                                            label={`FRAME EXTENSION`}
                                                            name={"SelectedFrameExtension"}
                                                            type="text"
                                                            placeholder={'----- Select -----'}
                                                            validate={[required]}
                                                            required={true}
                                                            options={frameExtensionOption}
                                                            onChange={this.handleFrameExtension}
                                                            optionValue={'Value'}
                                                            optionLabel={'Text'}
                                                            component={renderSelectField}
                                                            className="custom-select"
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                            disabled={isViewFlag}
                                                        />
                                                    </Col>
                                                    <Col md="4">
                                                        {(this.state.frameExtension === 'SELF CONTAINED FRAME WITH EXT LENGTH' ||
                                                            this.state.frameExtension === 'CLOSED TOP FRAME WITH EXT STEM LENGTH' ||
                                                            this.state.frameExtension === 'REQUIRED') &&
                                                            < Field
                                                                label={`FL`}
                                                                name={"FL"}
                                                                type="text"
                                                                placeholder={''}
                                                                validate={[required]}
                                                                component={renderText}
                                                                required={true}
                                                                className={''}
                                                                customClassName="withoutBorderBottom"
                                                                readOnly={isViewFlag}
                                                            />
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row className={'mb-3'}>
                                                    <Col md="4" className={'form-group'}>
                                                        <Field
                                                            label={`SINGLE / DUAL SPINDLE`}
                                                            name={"shaftSpindle"}
                                                            type="text"
                                                            placeholder={'----- Select -----'}
                                                            validate={[required]}
                                                            required={true}
                                                            options={sharftSpindleOption}
                                                            onChange={(e) => {

                                                                this.setState({ selectedSpindle: e.target.value })
                                                                // this.handleShaftSpindle()
                                                            }}
                                                            optionValue={'Value'}
                                                            optionLabel={'Text'}
                                                            component={renderSelectField}
                                                            className="custom-select"
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                            disabled={isViewFlag}
                                                        />
                                                    </Col>
                                                    <Col md="4" className={'form-group'}>
                                                        <Field
                                                            label={`SPINDLE DIRECTION`}
                                                            name={"SpindleDirection"}
                                                            type="text"
                                                            placeholder={'----- Select -----'}
                                                            validate={[required]}
                                                            required={true}
                                                            options={spindleDirectionOption}
                                                            onChange={this.handleSpindleDirection}
                                                            optionValue={'Value'}
                                                            optionLabel={'Text'}
                                                            component={renderSelectField}
                                                            className="custom-select"
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                            disabled={isViewFlag}
                                                        />
                                                    </Col>
                                                    <Col md="4" className={'form-group'}>
                                                        <Field
                                                            label={`ACTUATION`}
                                                            name={"Actuation"}
                                                            type="text"
                                                            placeholder={'----- Select -----'}
                                                            validate={[required]}
                                                            required={true}
                                                            options={ActuationOption}
                                                            onChange={this.handleActuation}
                                                            optionValue={'Value'}
                                                            optionLabel={'Text'}
                                                            component={renderSelectField}
                                                            className="custom-select"
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                            disabled={isViewFlag}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className={'mb-3'}>
                                                    <Col md="4" className={'form-group'}>
                                                        <Field
                                                            label={`TYPE OF CLOSURE`}
                                                            name={"ClosureType"}
                                                            type="text"
                                                            placeholder={'----- Select -----'}
                                                            validate={[required]}
                                                            required={true}
                                                            options={ClosureOption}
                                                            onChange={this.handleClosureType}
                                                            optionValue={'Value'}
                                                            optionLabel={'Text'}
                                                            component={renderSelectField}
                                                            className="custom-select"
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                            disabled={isViewFlag}
                                                        />
                                                    </Col>
                                                    <Col md="4" className={'form-group'}>
                                                        <Field
                                                            label={`FRAME MOUNTING`}
                                                            name={"frameMounting"}
                                                            type="text"
                                                            placeholder={'----- Select -----'}
                                                            validate={[required]}
                                                            required={true}
                                                            options={frameMountingData}
                                                            onChange={this.handleFrameMounting}
                                                            //disabled={true}
                                                            optionValue={'Value'}
                                                            optionLabel={'Text'}
                                                            component={renderSelectField}
                                                            className="custom-select"
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                            disabled={isViewFlag}
                                                        />
                                                    </Col>
                                                    <Col md="4" className={'form-group'}>
                                                        <Field
                                                            label={`APPLICABLE STANDARD`}
                                                            name={"applicableStandard"}
                                                            type="text"
                                                            placeholder={'----- Select -----'}
                                                            validate={[required]}
                                                            required={true}
                                                            options={applicableStandardDataArray}
                                                            onChange={this.handleApplicableStandardSelect}
                                                            //disabled={true}
                                                            optionValue={'Value'}
                                                            optionLabel={'Text'}
                                                            component={renderSelectField}
                                                            className="custom-select"
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                            disabled={isViewFlag}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className={'mb-3'}>
                                                    <Col md="4" className={'form-group'}>
                                                        <Field
                                                            label={`STEM MATERIAL`}
                                                            name={"stemMaterial"}
                                                            type="text"
                                                            placeholder={'----- Select -----'}
                                                            validate={[required]}
                                                            required={true}
                                                            options={stemMaterialOptions}
                                                            onChange={(e) => this.setState({ selectedStemMaterial: e.target.value })}
                                                            optionValue={'Value'}
                                                            optionLabel={'Text'}
                                                            component={renderSelectField}
                                                            className="custom-select"
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                            disabled={isViewFlag}
                                                        />
                                                    </Col>
                                                    <Col md="4" className={'form-group'}>
                                                        <Field
                                                            label={`THRUST ON`}
                                                            name={"selectedThrustOn"}
                                                            type="text"
                                                            placeholder={'----- Select -----'}
                                                            validate={[required]}
                                                            required={true}
                                                            options={thrustOnOptions}
                                                            optionValue={'Value'}
                                                            optionLabel={'Text'}
                                                            component={renderSelectField}
                                                            className="custom-select"
                                                            customClassName="withoutBorderBottom"
                                                            readOnly={isViewFlag}
                                                            disabled={isViewFlag}
                                                        />
                                                    </Col>

                                                    {/* {this.state.isSeriesOfferedCI &&
                                                        <Col md="4" className={'form-group'}>
                                                            <Field
                                                                label={`STEM DIA AS PER DESIGN`}
                                                                name={"stemDia"}
                                                                type="text"
                                                                placeholder={'----- Select -----'}
                                                                validate={[required]}
                                                                required={true}
                                                                options={stemDiaOption}
                                                                onChange={this.handleStemDia}
                                                                optionValue={'Value'}
                                                                optionLabel={'Text'}
                                                                component={renderSelectField}
                                                                className="custom-select"
                                                                customClassName="withoutBorderBottom"
                                                                readOnly={isViewFlag}
                                                                disabled={isViewFlag}
                                                            />
                                                        </Col>
                                                    } */}
                                                </Row>
                                                <Row className={'mb-3'}>
                                                    <Col md="4">

                                                    </Col>
                                                </Row>
                                                {
                                                    selectedSeriesOffered !== 'A-111' && selectedSeriesOffered !== 'A-112' && !isViewFlag &&
                                                    <Row className={'mb-3'}>
                                                        <Col md="12" className={'text-right mb15'}>
                                                            <button
                                                                type="button"
                                                                onClick={this.nextStepTwo}
                                                                //disabled={pristine || submitting}
                                                                className={'btn btn-primary'}>Next</button>
                                                        </Col>
                                                    </Row>
                                                }
                                            </div>}
                                    </div>

                                </Col>
                            </Row>
                            {

                                selectedSeriesOffered !== 'A-111' && selectedSeriesOffered !== 'A-112' &&
                                <div>
                                    <Row className={'mb-3'}>
                                        <Col>
                                            <div className={'collaps-wrapper m-0 card w100 mt-0 cr-stage-two'}>
                                                <div className={'collaps-head card-header'} onClick={this.stageTwoController}>
                                                    <h3>Stage Two</h3>
                                                </div>

                                                {this.state.stageTwoOpen &&
                                                    <>
                                                        {
                                                            this.state.isSeriesOfferedCI ?

                                                                <CIShutterDesign
                                                                    cisData={this.cisData}
                                                                    // setData={(value) => this.setState({ data: value })}
                                                                    // setShutterDesignData={(value) => this.setState({ shutterDesignData: value })}
                                                                    horizontalSniffersSelect={this.state.horizontalSniffersSelect}
                                                                    isEditFlag={isEditFlag}
                                                                    ShutterId={this.props.ShutterId}
                                                                    ActuationToggler={this.props.ActuationToggler}
                                                                    shutterIdNewCreated={this.shutterIdNewCreated}
                                                                    // setWidth={(value => this.setState({ width: value }))}
                                                                    isViewFlag={isViewFlag}
                                                                    shutterDesignCreated={this.state.shutterDesignCreated}
                                                                    // setShutterDesignCreated={(value) => this.setState({ shutterDesignCreated: value })}
                                                                    fieldObjShutter={this.props.fieldObj}
                                                                    shutterDataCI={this.state.shutterDataCI}
                                                                // setApplicableStandard={(value) => this.setState({ applicableStandard: value })}
                                                                />
                                                                :

                                                                <div className={'collaps-body card-body'}>
                                                                    <h4>DESIGN CALCULATION FOR SHUTTER  / GATE LEAF / STOPLOG </h4>
                                                                    {/* <Row >
                                                        <Col md="2">
                                                            <p>DATED</p>
                                                        </Col>
                                                        <Col md="4">
                                                            <div className=" date-section">
                                                                <DatePicker
                                                                    name="ValidDateFrom"
                                                                    selected={this.state.startDate}
                                                                    onChange={this.handleDate}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dateFormat="MM/dd/yyyy"
                                                                    //maxDate={new Date()}
                                                                    dropdownMode="select"
                                                                    placeholderText="MM/dd/yyyy"
                                                                    className=""
                                                                    autoComplete={'off'}
                                                                    disabledKeyboardNavigation
                                                                    onChangeRaw={(e) => e.preventDefault()}
                                                                />
                                                            </div>

                                                        </Col>
                                                        <Col md="4">
                                                            <p>GATE SIZE</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{fieldObj && fieldObj.height ? this.returnFieldInteger('height') : 0}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="2">
                                                            <p>CLIENT</p>
                                                        </Col>
                                                        <Col md="4">
                                                            <p>{'--------------'}</p>
                                                        </Col>
                                                        <Col md="4">
                                                            <p>LOCATION</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{'--------------'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="2">
                                                            <p>PROJECT</p>
                                                        </Col>
                                                        <Col md="4">
                                                            <p>{'--------------'}</p>
                                                        </Col>
                                                        <Col md="4">
                                                            <p>TAG NO.</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{'--------------'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="2">
                                                            <p>{''}</p>
                                                        </Col>
                                                        <Col md="4">
                                                            <p>{''}</p>
                                                        </Col>
                                                        <Col md="4">
                                                            <p>REFERENCE DRAWING NO.</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{'--------------'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="2">
                                                            <p>{''}</p>
                                                        </Col>
                                                        <Col md="4">
                                                            <p>{''}</p>
                                                        </Col>
                                                        <Col md="4">
                                                            <p>REVISION NO. & DATE</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{'--------------'}</p>
                                                        </Col>
                                                    </Row> */}

                                                                    {/* *************DESIGN DATA************* */}
                                                                    <hr />
                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="12">
                                                                            <div className={'page-heads'}>
                                                                                1). DESIGN DATA: -
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            <p>{'a).    Width of opening'}</p>
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            <p>{'='}</p>
                                                                        </Col>
                                                                        <Col md="3">
                                                                            <p>{fieldObj && fieldObj.width ? checkForNull(this.returnFieldInteger('width')).toFixed(0) : 0} {'mm'}</p>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <p>{fieldObj && fieldObj.width ? `${checkForNull(this.returnFieldInteger('width') / 1000).toFixed(2)} m` : 0}</p>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            <p>{'b). Height of opening'}</p>
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            <p>{'='}</p>
                                                                        </Col>
                                                                        <Col md="3">
                                                                            <p>{fieldObj && fieldObj.height ? checkForNull(this.returnFieldInteger('height')).toFixed(0) : 0} {'mm'}</p>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <p>{fieldObj && fieldObj.height ? `${checkForNull(this.returnFieldInteger('height') / 1000).toFixed(2)} m` : 0}</p>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            <p>{'c). Seating water head acting on door from invert line'}</p>
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            <p>{'='}</p>
                                                                        </Col>
                                                                        <Col md="3">
                                                                            <p>{fieldObj && fieldObj.seatingHead ? checkForNull(this.seatingWaterCalculation()).toFixed(0) : 0} {'mm'}</p>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <p>{fieldObj && fieldObj.seatingHead ? `${(this.seatingWaterCalculation() / 1000).toFixed(2)} m` : 0}</p>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            <p>{'d). Unseating water head acting on door from invert line'}</p>
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            <p>{'='}</p>
                                                                        </Col>
                                                                        <Col md="3">
                                                                            <p>{fieldObj && fieldObj.unseatingHead ? checkForNull(this.unseatingWaterCalculation()).toFixed(0) : 0} {'mm'}</p>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <p>{fieldObj && fieldObj.unseatingHead ? `${checkForNull(this.unseatingWaterCalculation() / 1000).toFixed(2)} m` : 0}</p>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            <p>{'e).   Design water head from invert of Opening'}</p>
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            <p>{'='}</p>
                                                                        </Col>
                                                                        <Col md="3">
                                                                            <p>{(fieldObj && fieldObj.unseatingHead && fieldObj.seatingHead) ? checkForNull(this.returnMaxNumber()).toFixed(0) : 0} {'mm'}</p>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <p>{(fieldObj && fieldObj.unseatingHead && fieldObj.seatingHead) ? `${checkForNull(this.returnMaxNumber() / 1000).toFixed(2)} m` : 0}</p>
                                                                        </Col>
                                                                    </Row>

                                                                    {/* *************MATERIAL SPECIFICATION AND PERMISSIBLE STRESSES************* */}
                                                                    <hr />
                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="7">
                                                                            <div className={'page-heads'}>
                                                                                2). MATERIAL SPECIFICATION AND PERMISSIBLE STRESSES: -
                                                                            </div>
                                                                        </Col>
                                                                        <Col md="5">
                                                                            <Field
                                                                                label={``}
                                                                                name={"referenceDocuments"}
                                                                                type="text"
                                                                                placeholder={'----- Select -----'}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                options={referenceDocsOption}
                                                                                onChange={this.handleReferenceDocs}
                                                                                optionValue={'Value'}
                                                                                optionLabel={'Text'}
                                                                                component={renderSelectField}
                                                                                className=" custom-select"
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                                disabled={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb15 none-label'}>
                                                                        <Col md="5" className="cr-mm-dimension">{'Material used for manufacturing:'}<span class="asterisk-required">*</span></Col>
                                                                        <Col md="2" className="cr-mm-dimension text-right">{'='}</Col>
                                                                        <Col md="5" className="max-width-container">
                                                                            <Field
                                                                                label={``}
                                                                                name={"manufacturingMaterial"}
                                                                                type="text"
                                                                                placeholder={'----- Select -----'}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                options={manufacturingMaterialOption}
                                                                                onChange={this.handleManufacturingMaterial}
                                                                                optionValue={'Value'}
                                                                                optionLabel={'Text'}
                                                                                component={renderSelectField}
                                                                                className=" custom-select"
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                                disabled={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <p>{'The above selected material is used for skin plate, vertical stiffeners, horizontal stiffener and end vertical stiffeners of Slide/Shutter and have following strength:'}</p>
                                                                        </Col>
                                                                    </Row>


                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {/* <p>{'Ultimate tensile strength '}</p> */}
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            <p>{'Factor Of Safety = '}</p>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <div>
                                                                                <Field
                                                                                    label={``}
                                                                                    name={"factorOfSafetyDD"}
                                                                                    type="text"
                                                                                    placeholder={'----- Select -----'}
                                                                                    validate={[required]}
                                                                                    required={true}
                                                                                    options={factorOfSafety}
                                                                                    onChange={this.handlefactorOfSafetyDD}
                                                                                    optionValue={'Value'}
                                                                                    optionLabel={'Text'}
                                                                                    component={renderSelectField}
                                                                                    className=" custom-select"
                                                                                    customClassName=" withoutBorderBottom"
                                                                                    readOnly={isViewFlag}
                                                                                    disabled={isViewFlag}
                                                                                /></div>
                                                                        </Col>
                                                                        <Col md="3">
                                                                            {this.state.factorOfSafetyDD === "CUSTOM" &&
                                                                                <div>
                                                                                    FOS
                                                                                </div>
                                                                            }
                                                                        </Col>
                                                                    </Row>


                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            <p>{'Ultimate tensile strength '}</p>
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            <p>{'Ftu =  '}{`${manufacturingMaterialObj.UTS} Mpa`}</p>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <p>{`${manufacturingMaterialObj.UTS * 1}N/mm`}<sup>2</sup></p>
                                                                        </Col>
                                                                        <Col md="3">
                                                                            {this.state.factorOfSafetyDD == "CUSTOM" &&
                                                                                <div>
                                                                                    <Field
                                                                                        label={``}
                                                                                        name={"FOS1"}
                                                                                        type="text"
                                                                                        placeholder={''}
                                                                                        // validate={[required]}
                                                                                        component={renderText}
                                                                                        required={true}
                                                                                        className={''}
                                                                                        customClassName=" withoutBorderBottom"
                                                                                        readOnly={isViewFlag}
                                                                                    />
                                                                                </div>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            <p>{'Yield strength '}</p>
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            <p>{'Fy =  '}{`${manufacturingMaterialObj.YS} Mpa`}</p>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <p>{`${manufacturingMaterialObj.YS * 1} N/mm`}<sup>2</sup></p>
                                                                        </Col>
                                                                        <Col md="3">
                                                                            {this.state.factorOfSafetyDD == "CUSTOM" &&
                                                                                <div>
                                                                                    <Field
                                                                                        label={``}
                                                                                        name={"FOS2"}
                                                                                        type="text"
                                                                                        placeholder={''}
                                                                                        // validate={[required]}
                                                                                        component={renderText}
                                                                                        required={true}
                                                                                        className={''}
                                                                                        customClassName=" withoutBorderBottom"
                                                                                        readOnly={isViewFlag}
                                                                                    />
                                                                                </div>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            <p>{'Ultimate Shear strength'}</p>
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            <p>{'Fss =  '}{`${manufacturingMaterialObj.FSS} Mpa`}</p>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <p>{`${manufacturingMaterialObj.FSS} N/mm`}<sup>2</sup></p>
                                                                        </Col>
                                                                        <Col md="3">
                                                                            {this.state.factorOfSafetyDD == "CUSTOM" &&
                                                                                <div>
                                                                                    <Field
                                                                                        label={``}
                                                                                        name={"FOS3"}
                                                                                        type="text"
                                                                                        placeholder={''}
                                                                                        // validate={[required]}
                                                                                        component={renderText}
                                                                                        required={true}
                                                                                        className={''}
                                                                                        customClassName=" withoutBorderBottom"
                                                                                        readOnly={isViewFlag}
                                                                                    />
                                                                                </div>
                                                                            }
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <p>{'Permissible mono-axial stresses for structural components of hydraulic gates'}</p>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            <p>{'a. Bending stress ( Comp/Ten )   '}</p>
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            <p>{`=  ${checkForNull(finalValueShearStress).toFixed(2)} x ${shearstressObj == con1 ? 'Ftu' : 'Fy'} =`}</p>
                                                                        </Col>
                                                                        <Col md="3">
                                                                            {/* <b>{(referenceDocumentsObj.BendingStress * manufacturingMaterialObj.UTS).toFixed(2)} {' N/mm2'}</b> */}
                                                                            <b>{checkForNull(shearstressObj).toFixed(2)} {' N/mm'}<sup>2</sup></b>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            <p>{'b. Axial stress ( Comp/Ten )'}</p>
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            <p>{`=  ${checkForNull(finalValueShearStress).toFixed(2)} x ${shearstressObj == con1 ? 'Ftu' : 'Fy'} =`}</p>
                                                                        </Col>
                                                                        <Col md="3">
                                                                            {/* <b>{(referenceDocumentsObj.AxialStress * manufacturingMaterialObj.UTS).toFixed(2)} {' N/mm2'}</b> */}
                                                                            <b>{checkForNull(shearstressObj).toFixed(2)} {' N/mm'}<sup>2</sup></b>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            <p>{'c. Shear stress'}</p>
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            <p>{`=  ${checkForNull(this.shearStressCalc()).toFixed(2)} x Fss =`}</p>
                                                                        </Col>
                                                                        <Col md="3">
                                                                            {/* <b>{(referenceDocumentsObj.ShearStress * manufacturingMaterialObj.FSS).toFixed(2)} {' N/mm2'}</b> */}
                                                                            <b>{checkForNull(this.shearStressCalc() * manufacturingMaterialObj.FSS).toFixed(2)} {' N/mm'}<sup>2</sup></b>
                                                                        </Col>
                                                                    </Row>

                                                                    {/* ************* DESIGN OF GATE LEAF / STOP LOG ************* */}
                                                                    <hr />
                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="12">
                                                                            <div className={'page-heads'}>
                                                                                3). DESIGN OF GATE LEAF / STOP LOG: -
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <div>
                                                                                <p className={'mb-3'}>The gate leaf / slide / stop shutter / stoplog shall be designed under maximum seating / unseating head  condition. The design head shall be measured as the distance from the invert of the channel or waterway to the maximum water level.</p>
                                                                                <p className={'mb-3'}>General design of the stop log involves design of following components.</p>
                                                                                <Row>
                                                                                    <Col md='4'>
                                                                                        <p className={'mb-3'}>I) Skin Plate.</p>
                                                                                    </Col>
                                                                                    <Col md='4'>
                                                                                        <p className={'mb-3'}>II)Horizontal members. </p>
                                                                                    </Col>
                                                                                    <Col md='4'>
                                                                                        <p className={'mb-3'}>III) Vertical members. </p>
                                                                                    </Col>
                                                                                </Row>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="12">
                                                                            <div className={'page-heads'}>
                                                                                (I) SKIN PLATE: -
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <p className={'mb-3'}>
                                                                                The skin plate and stiffeners shall be designed together in a composite manner. The skin plate shall be designed for the following two conditions:
                                                                            </p>
                                                                            <p className={'mb-3'}>
                                                                                a. In bending, across the stiffeners or as panels, and
                                                                            </p>
                                                                            <p className={'mb-3'}>
                                                                                b. In bending,co-acting with stiffeners and/or horizontal stiffeners.The gate leaf shall be designed for max.head conditions
                                                                            </p>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="3">
                                                                            <p>maximum water head</p>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <p>{fieldObj && fieldObj.seatingHead ? `${(this.returnMaxNumber() / 1000).toFixed(2)} m.` : 0}</p>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="6">
                                                                            <p className={'mb-3'}>Bending stresses of flat plates in panels is:</p>
                                                                            <p className={'mb-3'}>σ =  k/100 x (p x a{<sup>2</sup>} / S{<sup>2</sup>}) N/mm<sup>2</sup></p>
                                                                            <p className={'mb-3'}>Where,</p>
                                                                            <p className={'mb-3'}>σ = bending stress in flat plate in N/mm<sup>2</sup></p>
                                                                            <p className={'mb-3'}>p = water/liquid pressure in N/mm<sup>2</sup></p>
                                                                            <p className={'mb-3'}>( relative to the plate centre), </p>
                                                                            <p className={'mb-3'}>The maximum pressure on centre of skin plate due to water head  </p>
                                                                            <p className={'mb-3'}>p = ω x h</p>
                                                                            <p className={'mb-3'}>where,</p>
                                                                            <p className={'mb-3'}>ω = specific weight of liquid in N/m<sup>3</sup></p>
                                                                            <p className={'mb-3'}>ω = ρ x g = 1010 x 9.81 N/m<sup>3</sup></p>
                                                                            <p className={'mb-3'}>ρ = mass density of liquid = 1010 Kg/m<sup>3</sup></p>
                                                                            <p className={'mb-3'}>g = specific gravitational force = 9.81 m/sec<sup>2</sup></p>
                                                                            <p className={'mb-3'}>h = water  head from centre line of gate opening in m.</p>
                                                                        </Col>
                                                                        <Col md="6">
                                                                            <p><img src={require('../../assests/images/SkinPlate.png')} /></p>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            <p>Therefore, maximum pressure on centre of skin plate due to water head  </p>
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md="5">
                                                                            {checkForNull(((1010 * 9.81) * (fieldObj && fieldObj.seatingHead ? `${(this.returnMaxNumber() / 1000)}` : 0)).toFixed(1))}{' N/m'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md="2">
                                                                            {checkForNull(this.maxPressureCenterSkinPlate().toFixed(4))} {' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12" className={'mb-3'}>
                                                                            {'We now consider as under: -'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5" className="cr-mm-dimension">
                                                                            {'Nos. of vertical stiffeners'}<span class="asterisk-required">*</span>
                                                                        </Col>
                                                                        <Col md="2" className="cr-mm-dimension text-right">
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"verticalStiffeners"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                component={renderText}
                                                                                required={true}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md="3" className="cr-mm-dimension">
                                                                            {'Nos.'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5" className="cr-mm-dimension">
                                                                            {'Nos. of horizontal stiffeners'}<span class="asterisk-required">*</span>
                                                                        </Col>
                                                                        <Col md="2" className="cr-mm-dimension text-right">
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"horizontalStiffeners"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                component={renderText}
                                                                                required={true}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md="3" className="cr-mm-dimension">
                                                                            {'Nos.'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5" className="cr-mm-dimension">
                                                                            {'Skin plate thickness'}<span class="asterisk-required">*</span>
                                                                        </Col>
                                                                        <Col md="2" className="cr-mm-dimension text-right">
                                                                            {'s ='}
                                                                        </Col>
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"skinPlateThickness"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                component={renderText}
                                                                                onChange={(e) => { this.setState({ skinPlateThickness: e.target.value }) }}
                                                                                required={true}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md="3" className="cr-mm-dimension">
                                                                            {'mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Bay width of Vertical stiffeners'}
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            {'b ='}
                                                                        </Col>
                                                                        <Col md="2">
                                                                            {checkForNull(this.bayWidthVerticalStif().toFixed(2))} {' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Bay width of Horizontal stiffeners'}
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            {'a ='}
                                                                        </Col>
                                                                        <Col md="2">
                                                                            {checkForNull(this.bayWidthHorizontalStif().toFixed(2))}  {' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Therefore, '}
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            {'b/a ='}
                                                                        </Col>
                                                                        <Col md="2">
                                                                            {checkForNull(this.returnMaxStiffeners().toFixed(2))}
                                                                        </Col>
                                                                        <Col md="3">
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Non-dimensional factor " k " depending on value of b/a. '}
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            {'k ='}
                                                                        </Col>
                                                                        <Col md="2">
                                                                            {this.nonDimensionalFactor().toFixed(2)}
                                                                        </Col>
                                                                        <Col md="3">
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col>
                                                                            <p><img width="100%" src={require('../../assests/images/table1.png')} /></p>
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Hence bending Stress in skin plate '}
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            {'σ  ='}
                                                                        </Col>
                                                                        <Col md="2">
                                                                            {checkForNull(this.calculateSkinPlateBendingStress().toFixed(2))}{' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                        <Col md="3">

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {' '}
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            {'σ  ='}
                                                                        </Col>
                                                                        <Col md="2">
                                                                            {checkForNull(this.calculateSkinPlateBendingStress().toFixed(2))}{' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Where, Permissible bending Stress'}
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            {'σ  ='}
                                                                        </Col>
                                                                        <Col md="2">
                                                                            {checkForNull(shearstressObj).toFixed(2)}   {' Mpa'}
                                                                        </Col>
                                                                        <Col md="3">

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12" className={'mt15 mb15'}>
                                                                            <b>{this.bendingStressAlert()}</b>
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="12">
                                                                            <div className={'page-heads'}>
                                                                                (II) DESIGN OF HORIZONTAL MEMBERS:-
                                                                            </div>
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col>
                                                                            {`The horizontal stiffeners shall be designed as simply supported or continuous beams. 
                                                            The spacing between horizontal stiffeners are equal, 
                                                            hence all the stiffeners carry almost equal loads. 
                                                            The horizontal members transfer water load on end vertical stiffeners.`}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3 cr-stagecard-content'}>
                                                                        <Col md="12" className="d-flex justify-content-between">
                                                                            <div className="design-horizontal">
                                                                                <div className="cr-img-wrap">
                                                                                    <img src={require('../../assests/images/SectionA.png')} />
                                                                                    or
                                                                                    <img src={require('../../assests/images/SectionE.png')} />

                                                                                </div>
                                                                                <p>{'SECTION No: A'}</p>
                                                                            </div>
                                                                            {/* <div className="design-horizontal">
                                                                    <div className="cr-img-wrap">
                                                                        <img src={require('../../assests/images/SectionB.png')} />
                                                                    </div>
                                                                    <p>{'SECTION No: B'}</p>
                                                                </div> */}
                                                                            <div className="design-horizontal">
                                                                                <div className="cr-img-wrap">
                                                                                    <img src={require('../../assests/images/SectionB.png')} />
                                                                                </div>
                                                                                <p>{'SECTION No: B'}</p>
                                                                            </div>
                                                                            <div className="design-horizontal">
                                                                                <div className="cr-img-wrap">
                                                                                    <img src={require('../../assests/images/SectionC.png')} />
                                                                                    or
                                                                                    <img src={require('../../assests/images/SectionD.png')} />

                                                                                </div>
                                                                                <p>{'SECTION No: C'}</p>
                                                                            </div>
                                                                            {/* <div className="design-horizontal">
                                                                    <div className="cr-img-wrap">
                                                                        <img src={require('../../assests/images/SectionE.png')} />
                                                                    </div>
                                                                    <p>{'SECTION No: E'}</p>
                                                                </div> */}
                                                                        </Col>
                                                                        <Col md="4" className="cr-mm-dimension">
                                                                            {'We consider section for Horizontal Stiffeners '}<span class="asterisk-required">*</span> <span className="ml-2">=</span>
                                                                        </Col>
                                                                        <Col md="2" className={'none-label min-width-field'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"horizontalStiffenersSection"}
                                                                                type="text"
                                                                                placeholder={'----- Select -----'}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                options={horizontalStiffenerOption}
                                                                                onChange={this.handlehorizontalStiffeners}
                                                                                optionValue={'Value'}
                                                                                optionLabel={'Text'}
                                                                                component={renderSelectField}
                                                                                className=" custom-select"
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                                disabled={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md="2">
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <div className="cr-where-form">
                                                                        <Row className={'mb-3'}>
                                                                            <Col md="12">
                                                                                {'Where,'}
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className={'mb-3'}>

                                                                            <Col md={'1'} className="cr-mm-dimension text-right">
                                                                                {'b1 '}<span class="asterisk-required">*</span><span className="ml-2">=</span>
                                                                            </Col>
                                                                            <Col md="2" className={'none-label'}>
                                                                                <Field
                                                                                    label={``}
                                                                                    name={"HRb1"}
                                                                                    type="text"
                                                                                    placeholder={''}
                                                                                    validate={[required]}
                                                                                    required={true}
                                                                                    // onChange={this.calculationHandler}
                                                                                    component={renderText}
                                                                                    className={''}
                                                                                    customClassName=" withoutBorderBottom"
                                                                                    readOnly={isViewFlag}
                                                                                />
                                                                            </Col>
                                                                            <Col md={'1'} className="cr-mm-dimension">
                                                                                {'mm'}
                                                                            </Col>
                                                                            <Col md={'7'} className="cr-mm-dimension">
                                                                                <div className="text-help">
                                                                                    {this.hrb1AlertMsg()}
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                    <Row className={'mb-3'}>

                                                                        <Col md={'1'} className="cr-mm-dimension text-right">
                                                                            {'t1'}<span class="asterisk-required">*</span><span className="ml-2">=</span>
                                                                        </Col>
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"HRt1"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                onChange={this.calculationHandler}
                                                                                component={renderText}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md={'1'} className="cr-mm-dimension">
                                                                            {'mm'}
                                                                        </Col>
                                                                        <Col md={'7'} className="cr-mm-dimension">
                                                                            <div className="text-help">
                                                                                {this.hrt1AlertMsg()}
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'1'} className='text-right'>
                                                                            t2<span className="ml-2">=</span>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            {fieldObj && fieldObj.skinPlateThickness ? this.returnFieldInteger('skinPlateThickness') : 0} {' mm'}
                                                                        </Col>
                                                                        <Col md={'7'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'1'} className='text-right'>
                                                                            {'t3'}<span class="asterisk-required">*</span><span className="ml-2">=</span>
                                                                        </Col>
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"HRt3"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                onChange={this.calculationHandler}
                                                                                component={renderText}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md={'1'} className="cr-mm-dimension">
                                                                            {'mm'}
                                                                        </Col>
                                                                        <Col md={'7'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'1'} className="cr-mm-dimension text-right">
                                                                            {'d'}<span class="asterisk-required">*</span><span className="ml-2">=</span>
                                                                        </Col>
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"HRd"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                onChange={this.calculationHandler}
                                                                                component={renderText}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md={'1'} className="cr-mm-dimension">
                                                                            {'mm'}
                                                                        </Col>
                                                                        <Col md={'7'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'1'} className="cr-mm-dimension text-right">
                                                                            {'d1'}<span class="asterisk-required">*</span><span className="ml-2">=</span>
                                                                        </Col>
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"HRd1"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                component={renderText}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                disabled={true}
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        {/* <Col md="2">
                                                    {horizontalStiffenersSectionObj ? horizontalStiffenersSectionObj.d1 : 0}
                                                    </Col> */}
                                                                        <Col md={'1'} className="cr-mm-dimension">
                                                                            {'mm'}
                                                                        </Col>
                                                                        <Col md={'7'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'1'} className="cr-mm-dimension text-right">
                                                                            {'D'}<span class="asterisk-required">*</span><span className="ml-2">=</span>
                                                                        </Col>
                                                                        {/* <Col md="2">
                                                    {horizontalStiffenersSectionObj ? horizontalStiffenersSectionObj.D : 0}
                                                    </Col> */}
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"HRD"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                component={renderText}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                disabled={true}
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md={'1'} className="cr-mm-dimension">
                                                                            {'mm'}
                                                                        </Col>
                                                                        <Col md={'7'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Centre to centre distance of end vertical stiffeners is'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {this.returnEndVerticalStiff()} {' mm (Approx.)'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            {'Consider bottom most horizontal member ( considered simply supported beam).The skin plate &  horizontal stiffener flange  plate co-act with the horizontal members to form composite sections, for resisting the loads. '}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Co acting width  (B1) = 40xt2+t3'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnCoActingWidthB1()).toFixed(2)} {' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Co acting width  (B2) = 0.11 x Span'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnCoActingWidthB2()).toFixed(2)} {' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Co acting width  (B3) = Bay width of Horizontal stiffeners'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.bayWidthHorizontalStif()).toFixed(2)} {' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'12'} className={'mb-3'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'We considered the minimum value of co acting width (B)'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            <b>{checkForNull(this.returnMinimumCoActingWidth().toFixed(2))}</b> {' mm'}
                                                                        </Col>

                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            {'Substituting above values '}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'y1 = '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {/* {horizontalStiffenersSectionObj ? (horizontalStiffenersSectionObj.y1).toFixed(2) : 0} */}
                                                                            {this.HRStiffY1Calculation().toFixed(2)} {' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'y2 = '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {this.HRStiffY2Calculation().toFixed(2)} {' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'I = Moment of Inertia for selected section'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {/* {horizontalStiffenersSectionObj ? (horizontalStiffenersSectionObj.I).toFixed(7) : 0} */}
                                                                            {this.HRStiffInertiaCalculation().toFixed(7)}  {' m'}<sup>4</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Z1 = I / y1 ='}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.HRStiffInertiaCalculation() / (this.HRStiffY1Calculation() / 1000)).toFixed(7)}  {' m'}<sup>3</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Z2 = I / y2 = '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.HRStiffInertiaCalculation() / (this.HRStiffY2Calculation() / 1000)).toFixed(7)}  {' m'}<sup>3</sup>
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Hydrostatic force on the bottom most stiffener'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'w ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'Load / unit length of span of bottom most stiffener'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'p x A / span'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'(ω x h x A) / span  '}
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            {'Where,'}
                                                                        </Col>
                                                                        <Col md="6">
                                                                            {'A = Bay width of Horizontal stiffeners x Span'}
                                                                        </Col>
                                                                        <Col md={'6'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="2" className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md="1">
                                                                            {checkForNull(this.bayWidthHtalStiffSpan().toFixed(3))} {'m'}<sup>2</sup>
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {''}
                                                                        </Col>
                                                                        <Col md="7">
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="6">
                                                                            {'h = water  head from invert of opening in m.'}
                                                                        </Col>
                                                                        <Col md={'6'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="6">
                                                                            {'ω  = specific weight of liquid in N/m'}<sup>3</sup>
                                                                        </Col>
                                                                        <Col md={'6'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="6">
                                                                            {'ω  = ρ x g = 1010 x 9.81 N/m'}<sup>3</sup>
                                                                        </Col>
                                                                        <Col md={'6'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            {'Substituting above values '}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Hydrostatic force due to Maximum head'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'Wmax  ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnHydroForceMaxHead().toFixed(0))} {' N/m'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Hydrostatic force due to seating head'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'Wseat  ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnHydroForceSeatingHead().toFixed(0))} {' N/m'}
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Hydrostatic force due to unseating head'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'Wunseat='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnHydroForceUnseatingHead().toFixed(0))} {' N/m'}
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'12'}>
                                                                            {'For Simply supported beam having uniform distributed load,'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Bending Moment due to Maximum head'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'BMmax='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            Wmax x L<sup>2</sup>/8
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnBendingMomentMaxHead().toFixed(0))}{' Nm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Bending Moment due to Seating head'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'BMseat ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            Wseat x L<sup>2</sup>/8
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnBendingMomentSeatingHead().toFixed(0))} {' Nm'}
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Bending Moment due to Unseating head'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'BMunseat ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            Wunseat x L<sup>2</sup>/8
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnBendingMomentUnSeatingHead().toFixed(0))} {' Nm'}
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="12">
                                                                            <div className={'page-heads'}>
                                                                                <u> {'Checking for maximum tensile and compressive stress during bending on seating Head'}</u>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Checking for maximum Tensile stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' Tensile stress ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'BMseat / Z2'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Therefore, Maximum tensile stress  '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnMaxTensileStress().toFixed(0))} {' N/m'}<sup>2</sup>
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnMaxTensileStress() / Math.pow(10, 6)).toFixed(2))} {' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnMaxTensileStress() / Math.pow(10, 6)).toFixed(2))} {' Mpa'}
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Where, Permissible tensile stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(shearstressObj).toFixed(2)} {' Mpa'}
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <b>{this.tensileStressDesignMessage()}</b>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>

                                                                        <Col md="5">
                                                                            {'Checking for maximum Compressive stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className="text-right">
                                                                            {'Compressive stress ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'BMseat / Z1'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md='4'></Col>
                                                                        <Col md="3" className="text-right">
                                                                            {'Max compressive stress ='}
                                                                        </Col>
                                                                        <Col md={'3'}>
                                                                            {checkForNull(this.returnMaxCompressiveStress().toFixed(0))}   {'N/m'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnMaxCompressiveStress() / Math.pow(10, 6)).toFixed(2))} {' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnMaxCompressiveStress() / Math.pow(10, 6)).toFixed(2))} {' Mpa'}
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Where, Permissible Compressive stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(shearstressObj).toFixed(2)} {' Mpa'}
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <b>{this.compressiveStressDesignMessage()}</b>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="12">
                                                                            <div className={'page-heads'}>
                                                                                <u>{'Checking for maximum tensile and compressive stress during bending on unseating Head'}</u>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Checking for maximum Tensile stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' Tensile stress ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'BMunseat / Z1'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Therefore, Maximum tensile stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnMaxTensileStressUnSeatHead().toFixed(0))} {' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnMaxTensileStressUnSeatHead() / Math.pow(10, 6)).toFixed(2))} {' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnMaxTensileStressUnSeatHead() / Math.pow(10, 6)).toFixed(2))} {' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Where, Permissible tensile stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(shearstressObj).toFixed(2)} {' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <b>{this.tensileStressUnseatHeadDesignMessage()}</b>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>

                                                                        <Col md="5">
                                                                            {'Checking for maximum Compressive stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className="text-right">
                                                                            {'Compressive stress ='}
                                                                        </Col>
                                                                        <Col md={'4'}>
                                                                            {'BMseat / Z2'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Max compressive stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnMaxCompressiveStressUnseatedHead().toFixed(0))} {' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnMaxCompressiveStressUnseatedHead() / Math.pow(10, 6)).toFixed(2))} {' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnMaxCompressiveStressUnseatedHead() / Math.pow(10, 6)).toFixed(2))} {' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Where, Permissible Compressive stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(shearstressObj).toFixed(2)} {' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <b>{this.compressiveStressUnseatHeadDesignMessage()}</b>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="12">
                                                                            <div className={'page-heads'}>
                                                                                <u>{'Check for Shear stress on Max Head'}</u>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {' (Wmax x L) / 2'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Max shear force (fs)'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnMaxShearForce().toFixed(1))} {' N'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            {'Ignoring the contribution of flanges, and assuming that only web is effective in resisting the shear:'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Max shear stress '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {'1.5 x fs / Shear area'}
                                                                        </Col>
                                                                        <Col md={'3'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {parseInt(this.returnMaxShearStress())} {' N/m'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnMaxShearStress() / Math.pow(10, 6)).toFixed(2))}  {' N/mm'}<sup>2</sup>
                                                                        </Col>

                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnMaxShearStress() / Math.pow(10, 6)).toFixed(2))}{' Mpa'}
                                                                        </Col>

                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Where, Permissible shear stress '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {/* {(referenceDocumentsObj.ShearStress * manufacturingMaterialObj.FSS).toFixed(2)} */}
                                                                            {checkForNull(this.shearStressCalc() * manufacturingMaterialObj.FSS).toFixed(2)} {' Mpa'}
                                                                        </Col>
                                                                        <Col md={'3'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <b>{this.shearStressMaxHeadMessage()}</b>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="12">
                                                                            <div className={'page-heads'}>
                                                                                {'Checking for deflection'}
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Max. deflection at the centre'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'δ  ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            (5 x Wmax x L<sup>4</sup>/ (384 x E x I))
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnMaxDeflectionAtCentre().toFixed(6))} {' m'}
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'δ  ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnMaxDeflectionAtCentre() * 1000).toFixed(2))} {' mm'}
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Permissible deflection as per tender specification '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'Span / L  '}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {' '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'( W + 80 )/ L '}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5" className={'cr-mm-dimension'}>
                                                                            {'Where,'}<span class="asterisk-required">*</span>
                                                                        </Col>
                                                                        <Col md={'2'} className={'cr-mm-dimension text-right'}>
                                                                            {'L ='}
                                                                        </Col>
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"horizontalDeflection"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                component={renderText}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md={'3'} className="cr-mm-dimension">
                                                                            {'mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Therefore,Permissible deflection as per tender specification'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnPermissibleDefTenderSpec().toFixed(2))} {' mm'}
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        {/* {fieldObj.referenceDocuments == 0 && */}
                                                                        <>
                                                                            <Col md="5">
                                                                                {'But as per AWWA Permissible deflection not to exceed'}
                                                                            </Col>
                                                                            <Col md={'2'} className='text-right'>
                                                                                {'='}
                                                                            </Col>
                                                                            <Col md={'2'}>
                                                                                {'1.60'}{' mm'}
                                                                            </Col>
                                                                            <Col md={'3'}>

                                                                            </Col>
                                                                        </>
                                                                        {/* } */}
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <b>{this.actualDeflectionDesignMessage()}</b>
                                                                        </Col>
                                                                    </Row>


                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="12">
                                                                            <div className={'page-heads'}>
                                                                                (III) DESIGN OF VERTICAL MEMBERS:-
                                                                            </div>
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col>
                                                                            {`The Vertical stiffeners shall be designed as simply supported or continuous beams.
                                                        The spacing between Vertical stiffeners are equal, hence all the stiffeners carry 
                                                        almost equal loads.`}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb15 cr-stagecard-content'}>
                                                                        <Col md="12" className="d-flex justify-content-between">
                                                                            <div className="design-horizontal">
                                                                                <div className="cr-img-wrap">
                                                                                    <img src={require('../../assests/images/VSectionA.png')} />
                                                                                    or
                                                                                    <img src={require('../../assests/images/VSectionE.png')} />
                                                                                </div>
                                                                                <p>{'SECTION No: A'}</p>
                                                                            </div>
                                                                            {/* <div className="design-horizontal">
                                                                    <div className="cr-img-wrap">
                                                                        <img src={require('../../assests/images/VSectionB.png')} />
                                                                    </div>
                                                                    <p>{'SECTION No: B'}</p>
                                                                </div> */}
                                                                            <div className="design-horizontal">
                                                                                <div className="cr-img-wrap">
                                                                                    <img src={require('../../assests/images/VSectionB.png')} />
                                                                                </div>
                                                                                <p>{'SECTION No: B'}</p>
                                                                            </div>
                                                                            <div className="design-horizontal">
                                                                                <div className="cr-img-wrap">
                                                                                    <img src={require('../../assests/images/VSectionC.png')} />
                                                                                    or
                                                                                    <img src={require('../../assests/images/VSectionD.png')} />
                                                                                </div>
                                                                                <p>{'SECTION No: C'}</p>
                                                                            </div>
                                                                            {/* <div className="design-horizontal">
                                                                    <div className="cr-img-wrap">
                                                                        <img src={require('../../assests/images/VSectionE.png')} />
                                                                    </div>
                                                                    <p>{'SECTION No: E'}</p>
                                                                </div> */}
                                                                        </Col>
                                                                        <Col md="5">
                                                                            {'We consider section for Vertical Stiffeners'}<span class="asterisk-required">*</span><span className="ml-2">=</span>
                                                                        </Col>
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"verticalStiffenersSection"}
                                                                                type="text"
                                                                                placeholder={'----- Select -----'}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                options={verticalStiffenerOption}
                                                                                onChange={this.handleVerticalStiffeners}
                                                                                optionValue={'Value'}
                                                                                optionLabel={'Text'}
                                                                                component={renderSelectField}
                                                                                className=" custom-select"
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                                disabled={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md="3">
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <div className="cr-where-form">
                                                                        <Row className={'mb-3'}>
                                                                            <Col md="12" className="cr-mm-dimension">
                                                                                {'Where,'}
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className={'mb-3'}>
                                                                            <Col md={'2'} className="cr-mm-dimension text-right">
                                                                                {'b1'}<span class="asterisk-required">*</span><span className="ml-2">=</span>
                                                                            </Col>
                                                                            <Col md="2" className={'none-label'}>
                                                                                <Field
                                                                                    label={``}
                                                                                    name={"VRb1"}
                                                                                    type="text"
                                                                                    placeholder={''}
                                                                                    validate={[required]}
                                                                                    required={true}
                                                                                    onChange={this.calculationHandler}
                                                                                    component={renderText}
                                                                                    className={''}
                                                                                    customClassName=" withoutBorderBottom"
                                                                                    readOnly={isViewFlag}
                                                                                />
                                                                            </Col>
                                                                            <Col md={'1'} className="cr-mm-dimension">
                                                                                {'mm'}
                                                                            </Col>
                                                                            <Col md={'5'} className="cr-mm-dimension">
                                                                                <div className="text-help">
                                                                                    {this.vrb1AlertMsg()}
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'2'} className="cr-mm-dimension text-right">
                                                                            {'t1'}<span class="asterisk-required">*</span><span className="ml-2">=</span>
                                                                        </Col>
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"VRt1"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                onChange={this.calculationHandler}
                                                                                component={renderText}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md={'1'} className="cr-mm-dimension">
                                                                            {'mm'}
                                                                        </Col>
                                                                        <Col md={'5'} className="cr-mm-dimension">
                                                                            <div className="text-help">
                                                                                {this.vrt1AlertMsg()}
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'t2'}<span className="ml-2">=</span>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            {fieldObj && fieldObj.skinPlateThickness ? this.returnFieldInteger('skinPlateThickness') : 0} {' mm'}
                                                                        </Col>
                                                                        <Col md={'1'} className="cr-mm-dimension">

                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'t3'}<span class="asterisk-required">*</span><span className="ml-2">=</span>
                                                                        </Col>
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"VRt3"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                onChange={this.calculationHandler}
                                                                                component={renderText}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md={'1'} className="cr-mm-dimension">
                                                                            {'mm'}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'2'} className="cr-mm-dimension text-right">
                                                                            {'d'}<span class="asterisk-required">*</span><span className="ml-2">=</span>
                                                                        </Col>
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"VRd"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                onChange={this.calculationHandler}
                                                                                component={renderText}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md={'1'} className="cr-mm-dimension">
                                                                            {'mm'}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'2'} className="cr-mm-dimension text-right">
                                                                            {'d1'}<span class="asterisk-required">*</span><span className="ml-2">=</span>
                                                                        </Col>
                                                                        {/* <Col md="2">
                                                    {verticalStiffenersSectionObj ? verticalStiffenersSectionObj.d1 : 0}
                                                    </Col> */}
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"VRd1"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                component={renderText}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                disabled={true}
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md={'1'} className="cr-mm-dimension">
                                                                            {'mm'}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'2'} className="cr-mm-dimension text-right">
                                                                            {'D'}<span class="asterisk-required">*</span><span className="ml-2">=</span>
                                                                        </Col>
                                                                        {/* <Col md="2">
                                                    {verticalStiffenersSectionObj ? verticalStiffenersSectionObj.D : 0}
                                                    </Col> */}
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"VRD"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                component={renderText}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                disabled={true}
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md={'1'} className="cr-mm-dimension">
                                                                            {'mm'}
                                                                        </Col>
                                                                        <Col md={'3'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Centre to centre distance of horizontal stiffeners is'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.bayWidthHorizontalStif().toFixed(2))} {'mm'} {' (Approx.)'}
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            {'The skin plate &  vertical stiffener flange  plate co-act with the vertical members to form composite sections, for resisting the loads. '}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Co acting width  (B1) = 40xt2+t3'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnVerticalCoActingWidthB1().toFixed(2))} {' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Co acting width (B2) = 40xt2+t3'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnVerticalCoActingWidthB2()).toFixed(2)} {' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Co acting width  (B3) = Bay width of Vertical stiffeners'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.bayWidthVerticalStif().toFixed(2))} {' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'12'} className={'mb-3'}>
                                                                            {''}
                                                                        </Col>

                                                                        <Col md="5">
                                                                            {'We considered the minimum value of co acting width  (B) '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            <b>{checkForNull(this.returnVerticalMinimumCoActingWidth().toFixed(2))}</b>{' mm'}
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>

                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            {'Substituting above values '}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'y1 = '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {/* {verticalStiffenersSectionObj ? (verticalStiffenersSectionObj.y1).toFixed(2) : 0} */}
                                                                            {this.VRStiffY1Calculation().toFixed(2)} {' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'y2 = '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {/* {verticalStiffenersSectionObj ? (verticalStiffenersSectionObj.y2).toFixed(2) : 0} */}
                                                                            {this.VRStiffY2Calculation().toFixed(2)}  {' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'I = Moment of Inertia for selected section'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {/* {verticalStiffenersSectionObj ? (verticalStiffenersSectionObj.I).toFixed(7) : 0} */}
                                                                            {this.VRStiffInertiaCalculation().toFixed(7)} {' m'}<sup>4</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Z1 = I / y1 ='}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {/* {((verticalStiffenersSectionObj.I / verticalStiffenersSectionObj.y1) * 1000).toFixed(7)} */}
                                                                            {checkForNull(this.VRStiffInertiaCalculation() / (this.VRStiffY1Calculation() / 1000)).toFixed(7)} {' m'}<sup>3</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Z2 = I / y2 = '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {/* {((verticalStiffenersSectionObj.I / verticalStiffenersSectionObj.y2) * 1000).toFixed(7)} */}
                                                                            {checkForNull(this.VRStiffInertiaCalculation() / (this.VRStiffY2Calculation() / 1000)).toFixed(7)} {' m'}<sup>3</sup>
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Hydrostatic force on the stiffener'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'w ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'Load / unit length of span of stiffener'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'p x A / span'}
                                                                        </Col>

                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            {'Where,'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            {'A =  Bay width of Vertical stiffeners x Centre to centre distance of horizontal stiffeners'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md="2" className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.bayWidthVtalStiffSpan().toFixed(5))} {'m'}<sup>2</sup>
                                                                        </Col>
                                                                        <Col md="3">
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="6">
                                                                            {'h = water  head from invert of opening in m.'}
                                                                        </Col>
                                                                        <Col md={'6'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="6">
                                                                            {'ω  = specific weight of liquid in N/m'}<sup>3</sup>
                                                                        </Col>
                                                                        <Col md={'6'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="6">
                                                                            {'ω  = ρ x g = 1010 x 9.81 N/m'}<sup>3</sup>
                                                                        </Col>
                                                                        <Col md={'6'}>
                                                                            {''}
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            {'Substituting above values '}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Hydrostatic force due to Maximum head'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'Wmax  ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnVerticalHydroForceMaxHead().toFixed(0))} {' N/m'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Hydrostatic force due to seating head'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'Wseat  ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnVerticalHydroForceSeatingHead().toFixed(0))} {' N/m'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Hydrostatic force due to unseating head'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'Wunseat='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnVerticalHydroForceUnseatingHead().toFixed(0))} {' N/m'}
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3'}>
                                                                        <Col md={'12'}>
                                                                            {'For Fixed end beam having uniform distributed load,'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Bending Moment due to Maximum head'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'BMmax='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            Wmax x L<sup>2</sup>/12
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnVerticalBendingMomentMaxHead().toFixed(0))}{' Nm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Bending Moment due to Seating head'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'BMseat='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            Wseat x L<sup>2</sup>/12
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnVerticalBendingMomentSeatingHead().toFixed(0))}{' Nm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Bending Moment due to Unseating head'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'BMunseat ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            Wunseat x L<sup>2</sup>/12
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnVerticalBendingMomentUnSeatingHead().toFixed(0))}{' Nm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="12">
                                                                            <div className={'page-heads'}>
                                                                                {'Checking for maximum tensile and compressive stress during bending on seating Head'}
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Checking for maximum Tensile stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className="text-right">
                                                                            {' Tensile stress ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'BMseat / Z2'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Therefore, Maximum tensile stress  '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(parseInt(this.returnVerticalMaxTensileStress()))} {' N/m'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnVerticalMaxTensileStress() / Math.pow(10, 6)).toFixed(2))} {' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnVerticalMaxTensileStress() / Math.pow(10, 6)).toFixed(2))}{' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Where, Permissible tensile stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(shearstressObj).toFixed(2)}{' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <b>{this.verticalTensileStressDesignMessage()}</b>
                                                                        </Col>

                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Checking for maximum Compressive stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className="text-right">
                                                                            {'Compressive stress ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'BMseat / Z1'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Max compressive stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(parseInt(this.returnVerticalMaxCompressiveStress()))}{' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnVerticalMaxCompressiveStress() / Math.pow(10, 6)).toFixed(2))}{' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnVerticalMaxCompressiveStress() / Math.pow(10, 6)).toFixed(2))}{' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Where, Permissible Compressive stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(shearstressObj).toFixed(2)} {' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <b>{this.verticalCompressiveStressDesignMessage()}</b>
                                                                        </Col>
                                                                    </Row>




                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="12">
                                                                            <div className={'page-heads'}>
                                                                                {'Checking for maximum tensile and compressive stress during bending on unseating Head'}
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Checking for maximum Tensile stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className="text-right">
                                                                            {' Tensile stress ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'BMunseat / Z1'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Therefore, Maximum tensile stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(parseInt(this.returnVerticalMaxTensileStressUnSeatHead()))}  {' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnVerticalMaxTensileStressUnSeatHead() / Math.pow(10, 6)).toFixed(2))}  {' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnVerticalMaxTensileStressUnSeatHead() / Math.pow(10, 6)).toFixed(2))}{' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Where, Permissible tensile stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(shearstressObj).toFixed(2)} {' Mpa'}
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>

                                                                        <Col md="12">
                                                                            <b>{this.verticalTensileStressUnseatHeadDesignMessage()}</b>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>

                                                                        <Col md="5">
                                                                            {'Checking for maximum Compressive stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className="text-right">
                                                                            {'Compressive stress ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'BMunseat / Z1'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Max compressive stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnVerticalMaxCompressiveStressUnseatedHead().toFixed(0))} {' N/m'}<sup>2</sup>
                                                                        </Col>
                                                                        <Col md={'3'}>

                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnVerticalMaxCompressiveStressUnseatedHead() / Math.pow(10, 6)).toFixed(2))} {' N/mm'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnVerticalMaxCompressiveStressUnseatedHead() / Math.pow(10, 6)).toFixed(2))}{' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Where, Permissible Compressive stress'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(shearstressObj).toFixed(2)}{' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <b>{this.verticalCompressiveStressUnseatHeadDesignMessage()}</b>
                                                                        </Col>
                                                                    </Row>



                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="12">
                                                                            <div className={'page-heads'}>
                                                                                <u>{'Check for Shear stress on Max Head'}</u>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'(Wmax x L) / 2'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Max shear force (fs)'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnVerticalMaxShearForce().toFixed(1))}{' N'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            {'Ignoring the contribution of flanges, and assuming that only web is effective in resisting the shear:'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Max shear stress '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'1.5 x fs / Shear area'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnVerticalMaxShearStress().toFixed(0))}  {' N/m'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnVerticalMaxShearStress() / Math.pow(10, 6)).toFixed(2))}{' N/m'}<sup>2</sup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnVerticalMaxShearStress() / Math.pow(10, 6)).toFixed(2))} {' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Where, Permissible shear stress '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.shearStressCalc() * manufacturingMaterialObj.FSS).toFixed(2)} {' Mpa'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <b>{this.verticalShearStressMaxHeadMessage()}</b>
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className={'mb-3 mt-4'}>
                                                                        <Col md="12">
                                                                            <div className={'page-heads'}>
                                                                                <u> {'Checking for deflection'}</u>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Max. deflection at the centre'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'δ  ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            Wmax x L<sup>4</sup>/ (384 x E x I)
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnVerticalMaxDeflectionAtCentre().toFixed(7))}{' m'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {''}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'δ  ='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull((this.returnVerticalMaxDeflectionAtCentre() * 1000).toFixed(3))}{' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Permissible deflection as per tender specification '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'Span / L  '}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {' '}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {' ='}
                                                                        </Col>
                                                                        <Col md={'5'}>
                                                                            {'( H + 80 )/ L '}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5" className="cr-mm-dimension">
                                                                            {'Where,'}<span class="asterisk-required">*</span>
                                                                        </Col>
                                                                        <Col md={'2'} className={'cr-mm-dimension text-right'}>
                                                                            {'L ='}
                                                                        </Col>
                                                                        <Col md="2" className={'none-label'}>
                                                                            <Field
                                                                                label={``}
                                                                                name={"verticalDeflection"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                required={true}
                                                                                component={renderText}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md={'3'} className="cr-mm-dimension">
                                                                            {'mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="5">
                                                                            {'Therefore, Permissible deflection as per tender specification'}
                                                                        </Col>
                                                                        <Col md={'2'} className='text-right'>
                                                                            {'='}
                                                                        </Col>
                                                                        <Col md={'2'}>
                                                                            {checkForNull(this.returnVerticalPermissibleDefTenderSpec().toFixed(2))} {' mm'}
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        {/* {fieldObj.referenceDocuments == 0 && */}
                                                                        <>
                                                                            <Col md="5">
                                                                                {'But as per AWWA Permissible deflection not to exceed'}
                                                                            </Col>
                                                                            <Col md={'2'} className='text-right'>
                                                                                {'='}
                                                                            </Col>
                                                                            <Col md={'2'}>
                                                                                {'1.60'} {' mm'}
                                                                            </Col>
                                                                            <Col md={'3'}>

                                                                            </Col>
                                                                        </>
                                                                        {/* } */}
                                                                    </Row>
                                                                    <Row className={'mb-3'}>
                                                                        <Col md="12">
                                                                            <b>{this.actualVerticalDeflectionDesignMessage()}</b>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                        }

                                                    </>
                                                }

                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className={'mb-3'}>
                                        <Col>
                                            <div className={'collaps-wrapper m-0 card w100 mt-0 cr-stage-three'}>
                                                <div className={'collaps-head card-header'} onClick={this.stageThreeController}>
                                                    <h3>Stage Three</h3>
                                                </div>
                                                {this.state.stageThreeOpen &&
                                                    <>
                                                        {
                                                            this.state.isSeriesOfferedCI ?
                                                                <>
                                                                    <div className={'collaps-body card-body '}>
                                                                        <h4> 3. WEIGHT OF DOOR / SHUTTER (Md)</h4>
                                                                        <Row>
                                                                            <Col className="je-shutter-table">
                                                                                <table className="table table-responsive">
                                                                                    <tbody>
                                                                                        <th></th>
                                                                                        <th>REQUIRED</th>
                                                                                        <th>CONSIDERED</th>
                                                                                    </tbody>
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td>SKIN PLATE THICKNESS</td>
                                                                                            <td>{`${checkForNull(skinPlateThicknessStage3).toFixed(0)}`}</td>
                                                                                            <td>{`${checkForNull(skinPlateThicknessStage3).toFixed(2)} mm`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>{horizontalStiffenersSection === 'A' ? 'HORIZ.RIB THICKNESS' : 'HORIZ.RIB THICKNESS-WEB'}</td>
                                                                                            <td>{`${checkForNull(horizRibThickWeb_M3).toFixed(0)}`}</td>
                                                                                            <td>{`${checkForNull(horizRibThickWeb_M3).toFixed(2)} mm`}</td>
                                                                                        </tr>
                                                                                        {horizontalStiffenersSection === 'B' && <tr>
                                                                                            <td>HORIZ.RIB THICKNESS-FLANGE</td>
                                                                                            <td>{`${checkForNull(hs7).toFixed(0)}`}</td>
                                                                                            <td>{`${checkForNull(hs7).toFixed(2)} mm`}</td>
                                                                                        </tr>}
                                                                                        <tr>
                                                                                            <td>VERTI.RIB THICKNESS</td>
                                                                                            <td>{`${checkForNull(hs13).toFixed(0)}`}</td>
                                                                                            <td>{`${checkForNull(hs13).toFixed(2)} mm`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>HORIZ. RIBS HEIGHT</td>
                                                                                            <td>{`${checkForNull(horizRibsHeightVal_M3).toFixed(0)}`}</td>
                                                                                            <td> {`${checkForNull(horizRibsHeightVal_M3).toFixed(2)} mm`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>VERTI. RIBS HEIGHT</td>
                                                                                            <td>{`${checkForNull(hs14).toFixed(0)}`}</td>
                                                                                            <td>{`${checkForNull(hs14).toFixed(2)} mm`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>HORIZONTAL RIBS QTY</td>
                                                                                            <td>{`${checkForNull(horizoncalRibsQuantityVal_M).toFixed(0)}`}</td>
                                                                                            <td>{`${checkForNull(horizoncalRibsQuantityVal_M).toFixed(2)} Nos.`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>VERTICAL RIBS QTY</td>
                                                                                            <td>{`${checkForNull(verticalRibsQuantityVal_M).toFixed(0)}`}</td>
                                                                                            <td>{`${checkForNull(verticalRibsQuantityVal_M).toFixed(2)} Nos.`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>SIZE OF SIDE WEDGES</td>
                                                                                            <td>{`${this.sizeOfSideWedges().toFixed(0)}`}</td>
                                                                                            <td>{`${this.sizeOfSideWedges().toFixed(2)}`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>NO OF SIDE WEDGES</td>
                                                                                            <td>{`${this.noOfSideWedges().toFixed(0)}`}</td>
                                                                                            <td>{`${this.noOfSideWedges().toFixed(2)} Nos.`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>WIDTH OF BORDER (mm)</td>
                                                                                            <td>{`${checkForNull(this.widthOfBorder()).toFixed(0)}`}</td>
                                                                                            <td>{`${checkForNull(this.widthOfBorder()).toFixed(2)} mm`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>THICKNESS OF BORDER(mm)</td>
                                                                                            <td>{`${checkForNull(this.thicknessOfBorder()).toFixed(0)}`}</td>
                                                                                            <td>{`${checkForNull(this.thicknessOfBorder()).toFixed(2)} mm`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>M/C ALLOWANCE (mm)</td>
                                                                                            <td>{`${checkForNull(this.mcAllowance()).toFixed(0)}`}</td>
                                                                                            <td>{`${checkForNull(this.mcAllowance()).toFixed(2)} mm`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td> WEIGHT OF SKIN PLATE</td>
                                                                                            <td>{`@ ${checkForNull(this.weightOfSkinPlate()).toFixed(2)} KG/SqM `}</td>
                                                                                            <td>{`${checkForNull(this.weightOfSkinPlate_2()).toFixed(2)} Kgs.`}</td>
                                                                                            {/* ************************  */}
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>WEIGHT OF H. RIBS EXCLUDING BOTTOM RIB</td>
                                                                                            <td>{`@ ${checkForNull(weightOfHRibsEBR).toFixed(2)} KG/SqM `}</td>
                                                                                            <td>{`${checkForNull(weightOfHRibsEBR_2).toFixed(2)} Kgs.`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>WEIGHT OF H. TOP & BOTTOM RIB</td>
                                                                                            <td>{`@ ${checkForNull(weightOfHTopBottomRib).toFixed(2)} KG/SqM `}</td>
                                                                                            <td>{`${checkForNull(weightOfHTopBottomRib_2).toFixed(2)} Kgs.`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>WEIGHT OF V. RIBS</td>
                                                                                            <td>{`@ ${checkForNull(weightOfVRibs).toFixed(2)} KG/SqM `}</td>
                                                                                            <td>{`${checkForNull(weightOfVRibs_2).toFixed(2)} Kgs.`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>WEIGHT OF SIDE WEDGES</td>
                                                                                            <td>{`@ ${this.weightOfSideWedges().toFixed(2)} KG/SqM `}</td>
                                                                                            <td>{`${(Number(this.weightOfSideWedges()) * Number(this.noOfSideWedges())).toFixed(2)} Kgs.`}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>WEIGHT OF BORDER</td>
                                                                                            <td>{`@ ${checkForNull(this.weightOfDoor3()).toFixed(2)}   KG/SqM `}</td>
                                                                                            <td> = <span className="shutter-border-bottom">{checkForNull(this.weightOfDoor3_2()).toFixed(2)}</span> Kgs. </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colSpan="2"> <strong>WEIGHT OF SHUTTER </strong></td>
                                                                                            <td>  = <strong> <span className="shutter-border-bottom">{checkForNull(weightOfShutter).toFixed(2)} </span> Kgs. </strong> </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colSpan="2">MISC. OTHER WEIGHT FOR WEDGE PADS,  STEM BLOCK & RADIUS INCREASED BY 8%</td>
                                                                                            <td>  = <span className="shutter-border-bottom">{checkForNull(Number(weightOfShutter) * 1.08).toFixed(2)} </span> Kgs.</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colSpan="2">MOULDING / CASTING VARIATION INCREASED BY 10%</td>
                                                                                            <td> = <span className="shutter-border-bottom last-col-none">{checkForNull(Number(weightOfShutter) * 1.08 * 1.1).toFixed(2)} </span> Kgs.</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colSpan="2">ESTIMATED WEIGHT OF DOOR/SHUTTER (Md)</td>
                                                                                            <td> = <span className="shutter-border-bottom last-col">{checkForNull(Number(weightOfShutter) * 1.08 * 1.1).toFixed(0)} </span> Kgs.</td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </Col>
                                                                        </Row>
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                SKIN PLATE THICKNESS
                                                                            </Col>
                                                                            <Col md="3">
                                                                                {`REQUIRED`}
                                                                            </Col>
                                                                            <Col md="2"  className="text-right">
                                                                                {`CONSIDERED`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                SKIN PLATE THICKNESS
                                                                            </Col>
                                                                            <Col md="3">
                                                                                {`= ${checkForNull(skinPlateThicknessStage3).toFixed(0)}`}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${checkForNull(skinPlateThicknessStage3).toFixed(0)} mm`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                {horizontalStiffenersSection == 'A' ? 'HORIZ.RIB THICKNESS' : 'HORIZ.RIB THICKNESS-WEB'}
                                                                            </Col>
                                                                            <Col md="3">
                                                                                {`= ${checkForNull(horizRibThickWeb_M3).toFixed(0)}`}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${checkForNull(horizRibThickWeb_M3).toFixed(0)} mm`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* {horizontalStiffenersSection == 'B' &&
                                                                            <Row className={'mb-3 mt-4'}>
                                                                                <Col md="6">
                                                                                    {'HORIZ.RIB THICKNESS-FLANGE'}
                                                                                </Col>
                                                                                <Col md="3">
                                                                                    {`= ${checkForNull(hs7).toFixed(0)}`}
                                                                                </Col>
                                                                                <Col md="2" className="text-right">
                                                                                    {`${checkForNull(hs7).toFixed(0)} mm`}
                                                                                </Col>
                                                                            </Row>
                                                                        } */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                VERTI.RIB THICKNESS
                                                                            </Col>
                                                                            <Col md="3">
                                                                                {`= ${checkForNull(hs13).toFixed(0)}`}
                                                                            </Col>
                                                                            <Col md="2"  className="text-right">
                                                                                {`${checkForNull(hs13).toFixed(0)} mm`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                HORIZ. RIBS HEIGHT
                                                                            </Col>
                                                                            <Col md="3">
                                                                                {`= ${checkForNull(horizRibsHeightVal_M3).toFixed(0)}`}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${checkForNull(horizRibsHeightVal_M3).toFixed(0)} mm`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                VERTI. RIBS HEIGHT
                                                                            </Col>
                                                                            <Col md="3">
                                                                                {`= ${checkForNull(hs14).toFixed(0)}`}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${checkForNull(hs14).toFixed(0)} mm`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                HORIZONTAL RIBS QTY
                                                                            </Col>
                                                                            <Col md="3">
                                                                                {`= ${checkForNull(horizoncalRibsQuantityVal_M).toFixed(0)}`}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${checkForNull(horizoncalRibsQuantityVal_M).toFixed(0)} Nos.`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                VERTICAL RIBS QTY
                                                                            </Col>
                                                                            <Col md="3">
                                                                                {`= ${checkForNull(verticalRibsQuantityVal_M).toFixed(0)}`}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${checkForNull(verticalRibsQuantityVal_M).toFixed(0)} Nos.`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                SIZE OF SIDE WEDGES
                                                                            </Col>
                                                                            <Col md="3">
                                                                                {`= ${this.sizeOfSideWedges().toFixed(0)}`}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${this.sizeOfSideWedges().toFixed(0)}`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                NO OF SIDE WEDGES
                                                                            </Col>
                                                                            <Col md="3">
                                                                                {`= ${this.noOfSideWedges().toFixed(0)}`}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${this.noOfSideWedges().toFixed(0)} Nos.`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                WIDTH OF BORDER (mm)
                                                                            </Col>
                                                                            <Col md="3">
                                                                                {`= ${checkForNull(this.widthOfBorder()).toFixed(0)}`}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${checkForNull(this.widthOfBorder()).toFixed(0)} mm`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                THICKNESS OF BORDER(mm)
                                                                            </Col>
                                                                            <Col md="3">
                                                                                {`= ${checkForNull(this.thicknessOfBorder()).toFixed(0)}`}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${checkForNull(this.thicknessOfBorder()).toFixed(0)} mm`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                M/C ALLOWANCE (mm)
                                                                            </Col>
                                                                            <Col md="3">
                                                                                {`= ${checkForNull(this.mcAllowance()).toFixed(0)}`}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${checkForNull(this.mcAllowance()).toFixed(0)} mm`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                        </Row>
                                                                        <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                WEIGHT OF SKIN PLATE
                                                                            </Col>
                                                                            <Col md="2">
                                                                                {`@ ${checkForNull(this.weightOfSkinPlate()).toFixed(0)}   KG/SqM `}
                                                                            </Col>
                                                                            <Col md="1">
                                                                                {''}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${checkForNull(this.weightOfSkinPlate_2()).toFixed(2)} Kgs.`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                WEIGHT OF H. RIBS EXCLUDING BOTTOM RIB
                                                                            </Col>
                                                                            <Col md="2">
                                                                                {`@ ${checkForNull(weightOfHRibsEBR).toFixed(0)}   KG/SqM `}
                                                                            </Col>
                                                                            <Col md="1">
                                                                                {''}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${checkForNull(weightOfHRibsEBR_2).toFixed(2)} Kgs.`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                WEIGHT OF H. TOP & BOTTOM RIB
                                                                            </Col>
                                                                            <Col md="2">
                                                                                {`@ ${checkForNull(weightOfHTopBottomRib).toFixed(0)}   KG/SqM `}
                                                                            </Col>
                                                                            <Col md="1">
                                                                                {''}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${checkForNull(weightOfHTopBottomRib_2).toFixed(2)} Kgs.`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                WEIGHT OF V. RIBS
                                                                            </Col>
                                                                            <Col md="2">
                                                                                {`@ ${checkForNull(weightOfVRibs).toFixed(0)}   KG/SqM `}
                                                                            </Col>
                                                                            <Col md="1">
                                                                                {''}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${checkForNull(weightOfVRibs_2).toFixed(2)} Kgs.`}
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                WEIGHT OF SIDE WEDGES
                                                                            </Col>
                                                                            <Col md="2">
                                                                                {`@ ${this.weightOfSideWedges().toFixed(0)}   KG/SqM `}
                                                                            </Col>
                                                                            <Col md="1">
                                                                                {''}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                                {`${(Number(this.weightOfSideWedges()) * Number(this.noOfSideWedges())).toFixed(2)} Kgs.`}
                                                                                
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                WEIGHT OF BORDER
                                                                            </Col>
                                                                            <Col md="2">
                                                                                {`@ ${checkForNull(this.weightOfDoor3()).toFixed(0)}   KG/SqM `}
                                                                            </Col>
                                                                            <Col md="1">
                                                                                {''}
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                            = <span className="shutter-border-bottom">{checkForNull(this.weightOfDoor3_2()).toFixed(2)}</span> Kgs. 
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                               <strong>WEIGHT OF SHUTTER </strong>
                                                                            </Col>
                                                                            <Col md="2">
                                                                            </Col>
                                                                            <Col md="1">
                                                                            </Col>
                                                                            <Col md="2" className="text-right font-bold">
                                                                             =  <span className="shutter-border-bottom">{checkForNull(weightOfShutter).toFixed(2)} </span> Kgs.
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                MISC. OTHER WEIGHT FOR WEDGE PADS,  STEM BLOCK & RADIUS INCREASED BY 8%
                                                                            </Col>
                                                                            <Col md="2">
                                                                            </Col>
                                                                            <Col md="1">
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                           = <span className="shutter-border-bottom">{checkForNull(Number(weightOfShutter) * 1.08).toFixed(2)} </span> Kgs.
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                MOULDING / CASTING VARIATION INCREASED BY 10%
                                                                            </Col>
                                                                            <Col md="2">
                                                                            </Col>
                                                                            <Col md="1">
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                           = <span className="shutter-border-bottom last-col-none">{checkForNull(Number(weightOfShutter) * 1.08 * 1.1).toFixed(2)} </span> Kgs.
                                                                            </Col>
                                                                        </Row> */}
                                                                        {/* <Row className={'mb-3 mt-4'}>
                                                                            <Col md="6">
                                                                                ESTIMATED WEIGHT OF DOOR/SHUTTER (Md)
                                                                            </Col>
                                                                            <Col md="2">
                                                                            </Col>
                                                                            <Col md="1">
                                                                            </Col>
                                                                            <Col md="2" className="text-right">
                                                                           = <span className="shutter-border-bottom last-col">{checkForNull(Number(weightOfShutter) * 1.08 * 1.1).toFixed(0)} </span> Kgs.
                                                                            </Col>
                                                                        </Row> */}
                                                                        <Row className={'mb-3 align-items-center'}>
                                                                            <Col md="6">
                                                                                {'CONSIDERED WEIGHT OF DOOR/SHUTTER (Md)'}<span class="asterisk-required">*</span>
                                                                            </Col>
                                                                            <Col md="2">

                                                                            </Col>
                                                                            <Col md="2">

                                                                            </Col>
                                                                            <Col md="2" className="text-right border-input">
                                                                                <Field
                                                                                    label={``}
                                                                                    name={"consideredWeightOfDoor_Shutter"}
                                                                                    type="text"
                                                                                    placeholder={''}
                                                                                    validate={[required]}
                                                                                    component={renderText}
                                                                                    required={true}
                                                                                    className={''}
                                                                                    customClassName=" withoutBorderBottom"
                                                                                    readOnly={isViewFlag}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </>
                                                                :
                                                                <div className={'collaps-body card-body'}>
                                                                    <h4>3. WEIGHT OF DOOR / SHUTTER (Md)</h4>
                                                                    <Row>
                                                                        <Col className="je-shutter-table">
                                                                            <table className="table table-responsive">
                                                                                <tbody>
                                                                                    <th></th>
                                                                                    <th>REQUIRED</th>
                                                                                    <th>CONSIDERED</th>
                                                                                </tbody>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td>SKIN PLATE THICKNESS</td>
                                                                                        <td>{`${checkForNull(parseInt(this.returnFieldInteger('skinPlateThickness')))}`}</td>
                                                                                        <td>{`${this.returnFieldInteger('skinPlateThickness')} mm`}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td>HORIZ. RIBS  THICKNESS</td>
                                                                                        <td>{`${checkForNull(parseInt(this.returnFieldInteger('HRt3')))}`}</td>
                                                                                        <td>{`${this.returnFieldInteger('HRt3')} mm`}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td>VERTI. RIBS  THICKNESS</td>
                                                                                        <td>{`${checkForNull(parseInt(this.returnFieldInteger('VRt3')))}`}</td>
                                                                                        <td>{`${this.returnFieldInteger('VRt3')} mm`}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td>HORIZ. RIBS HEIGHT</td>
                                                                                        <td>{`${checkForNull(horizontalRibsHeight)}`}</td>
                                                                                        <td>{`${checkForNull(parseInt(horizontalRibsHeight))} mm`}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td>VERTI. RIBS HEIGHT</td>
                                                                                        <td>{`${checkForNull(verticalRibsHeight)}`}</td>
                                                                                        <td> {`${checkForNull(parseInt(verticalRibsHeight))} mm`}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td>HORIZONTAL RIBS QTY</td>
                                                                                        <td>{`${this.returnFieldInteger('horizontalStiffeners')}`}</td>
                                                                                        <td>{`${this.returnFieldInteger('horizontalStiffeners')} Nos.`}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td>VERTICAL RIBS QTY</td>
                                                                                        <td>{`${checkForNull(parseInt(this.returnFieldInteger('verticalStiffeners')))}`}</td>
                                                                                        <td>{`${checkForNull(parseInt(this.returnFieldInteger('verticalStiffeners')))} Nos.`}</td>
                                                                                    </tr>

                                                                                    <tr>
                                                                                        <td colSpan="2"><strong>Weight of door/Shutter (Md)</strong></td>
                                                                                        <td><strong>{checkForNull(weightDoor(fieldObj, currentSelectedMaterial).toFixed(2))} {'Kgs.'}</strong></td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </Col>
                                                                    </Row>

                                                                </div>

                                                        }
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            }
                            {!isViewFlag && <Row className={'mb-3'}>
                                <Col md="12" className={''}>
                                    <button
                                        onClick={() => {
                                            this.props.cancleToggle('1')
                                        }}
                                        disabled={pristine || submitting}
                                        className={'btn btn-secondary pull-right'}>Cancel</button>
                                    <button
                                        //onClick={this.UploadMassHandler}
                                        disabled={false}
                                        className={'btn btn-primary pull-right mr15'}>Save</button>
                                </Col>
                            </Row>}
                        </form>
                        {/* </Container> */}
                    </div>
                </Container>
            </div >
        );
    }
}

/**
* Form validations
* @param values
* @returns {{}}
        */
const validate = values => {
    let errors = {};

    return errors;
};

/**
* @method mapStateToProps
* @description return state to component as props
* @param {*} state
    */
function mapStateToProps(state) {
    const { auth } = state;
    const fieldObj = selector(state, 'height', 'width', 'seatingHead', 'unseatingHead',
        'referenceDocuments', 'stemDia', 'verticalStiffeners', 'horizontalStiffeners',
        'skinPlateThickness', 'horizontalStiffenersSection', 'HRb1', 'HRt1', 'HRt3',
        'HRd', 'HRd1', 'HRD', 'horizontalDeflection', 'VRb1', 'VRt1', 'VRt3', 'VRd',
        'VRd1', 'VRD', 'verticalDeflection', 'weightDoor', 'cl_pl', 'shaftSpindle',
        'SpindleDirection', 'frameMounting', 'verticalStiffenersSection', 'manufacturingMaterial',
        'ClosureType', 'Actuation', 'SelectedSeriesOffered', 'SelectedFrameLengthType', 'date',
        'ItemNumber', 'pid_number', 'quote_number', 'location', 'client', 'project', 'tag_number',
        'rev_number', 'rev_date', 'applicableStandard', 'stemMaterial', 'selectedThrustOn', 'FL', 'FOS1'
        , 'FOS2', 'FOS3', 'consideredWeightOfDoor_Shutter'
    );

    const { technologyList, loading } = auth;
    return { technologyList, loading, fieldObj }
}

/**
* @method connect
* @description connect with redux
* @param {function} mapStateToProps
* @param {function} mapDispatchToProps
*/
export default connect(mapStateToProps, {
    createShutterDesign,
    getShutterDesignData,
    updateShutterDesign,
})(reduxForm({
    form: 'ShutterDesign',
    onSubmitFail: errors => {
        focusOnError(errors);
    },
    enableReinitialize: true,
})(ShutterDesign));
